import { IncidentRecord } from './collectSeaTypes';

export const INCIDENT_SNAPSHOT_VERSION = "2026.08.20";

export const INCIDENTS: IncidentRecord[] = [
  {
    "incident_id": "SEA-SEC-001",
    "title": "Enterprise Cloud Identity & OAuth Consent Grant Compromise",
    "affected_system": {
      "system_type": "Enterprise Cloud & Distributed Systems",
      "organization": "Global Cloud Identity & Enterprise SaaS Provider",
      "product": "Enterprise Cloud Identity Platform",
      "is_ai_system": false,
      "is_agentic": false,
      "primary_language": "Multi-Language / Distributed Architecture"
    },
    "incident_date": "2024-03-15",
    "source_authority": {
      "document_type": "Regulatory Filing & Engineering Postmortem",
      "filing_id": "SEA-SEC-001-DOC",
      "reporting_entity": "Microsoft Corporation",
      "regulatory_body": "SEC / Regulatory & Engineering Authority"
    },
    "source_url": "https://www.sec.gov/Archives/edgar/data/789019/000119312524011295/d708866d8k.htm",
    "source_publisher": "Official Regulatory Repository & Engineering Disclosures",
    "source_stated_contributors": [
      "Legacy test tenant without MFA compromised via password spraying; adversary created malici..."
    ],
    "documented_facts": [
      {
        "fact_id": "SEA-SEC-001-F1",
        "statement": "Legacy test tenant without MFA compromised via password spraying; adversary created malicious OAuth apps with mail.read privileges.",
        "document_citation": "Official Primary Filing / Published Postmortem"
      }
    ],
    "collectsea_classification": {
      "capabilities": [
        "auth.privileged_action",
        "data.credentials_secrets",
        "arch.multi_tenant"
      ],
      "failure_mechanisms": [
        "SEA-FM-001",
        "SEA-FM-008"
      ],
      "consequences": [
        "Financial Loss",
        "Execution Error"
      ],
      "authority_level": "PRIVILEGED_INTERNAL"
    },
    "safeguards": [
      {
        "safeguard_id": "SEA-SEC-001-SG1",
        "label": "Automated Defensive Guardrail",
        "description": "Enforce strict pre-implementation automated architecture validation against SEA-FM-001.",
        "target_failure_mode": "Repeat architectural failure",
        "effectiveness_level": "PREVENTATIVE"
      }
    ],
    "status": "active"
  },
  {
    "incident_id": "SEA-SEC-002",
    "title": "Nationwide Healthcare Clearinghouse & Payment Gateway Outage",
    "affected_system": {
      "system_type": "Enterprise Cloud & Distributed Systems",
      "organization": "National Healthcare EDI Clearinghouse & Billing Gateway",
      "product": "EDI Claims Clearinghouse & Payment Gateway",
      "is_ai_system": false,
      "is_agentic": false,
      "primary_language": "Multi-Language / Distributed Architecture"
    },
    "incident_date": "2024-03-15",
    "source_authority": {
      "document_type": "Regulatory Filing & Engineering Postmortem",
      "filing_id": "SEA-SEC-002-DOC",
      "reporting_entity": "UnitedHealth Group / Change Healthcare",
      "regulatory_body": "SEC / Regulatory & Engineering Authority"
    },
    "source_url": "https://www.sec.gov/edgar/browse/?CIK=0000731766",
    "source_publisher": "Official Regulatory Repository & Engineering Disclosures",
    "source_stated_contributors": [
      "Single-factor remote access portal breached with stolen credentials; ransomware forced nat..."
    ],
    "documented_facts": [
      {
        "fact_id": "SEA-SEC-002-F1",
        "statement": "Single-factor remote access portal breached with stolen credentials; ransomware forced nationwide claims gateway disconnection.",
        "document_citation": "Official Primary Filing / Published Postmortem"
      }
    ],
    "collectsea_classification": {
      "capabilities": [
        "auth.financial_action",
        "data.financial_records",
        "auth.privileged_action"
      ],
      "failure_mechanisms": [
        "SEA-FM-001",
        "SEA-FM-005"
      ],
      "consequences": [
        "Financial Loss",
        "Execution Error"
      ],
      "authority_level": "IRREVERSIBLE_EXTERNAL"
    },
    "safeguards": [
      {
        "safeguard_id": "SEA-SEC-002-SG1",
        "label": "Automated Defensive Guardrail",
        "description": "Enforce strict pre-implementation automated architecture validation against SEA-FM-001.",
        "target_failure_mode": "Repeat architectural failure",
        "effectiveness_level": "PREVENTATIVE"
      }
    ],
    "status": "active"
  },
  {
    "incident_id": "SEA-SEC-003",
    "title": "Enterprise Endpoint Security Configuration Update System Crash",
    "affected_system": {
      "system_type": "Enterprise Cloud & Distributed Systems",
      "organization": "Enterprise Endpoint Security & Kernel Driver Pipeline",
      "product": "Kernel-Level Endpoint Protection Sensor",
      "is_ai_system": false,
      "is_agentic": false,
      "primary_language": "Multi-Language / Distributed Architecture"
    },
    "incident_date": "2024-03-15",
    "source_authority": {
      "document_type": "Regulatory Filing & Engineering Postmortem",
      "filing_id": "SEA-SEC-003-DOC",
      "reporting_entity": "CrowdStrike Holdings",
      "regulatory_body": "SEC / Regulatory & Engineering Authority"
    },
    "source_url": "https://www.sec.gov/edgar/browse/?CIK=0001535527",
    "source_publisher": "Official Regulatory Repository & Engineering Disclosures",
    "source_stated_contributors": [
      "Rapid deployment channel 291 bypassed staged canary rings; out-of-bounds memory read trigg..."
    ],
    "documented_facts": [
      {
        "fact_id": "SEA-SEC-003-F1",
        "statement": "Rapid deployment channel 291 bypassed staged canary rings; out-of-bounds memory read triggered BSOD on 8.5M Windows hosts.",
        "document_citation": "Official Primary Filing / Published Postmortem"
      }
    ],
    "collectsea_classification": {
      "capabilities": [
        "auth.code_execution",
        "auth.infrastructure_modification",
        "arch.external_api"
      ],
      "failure_mechanisms": [
        "SEA-FM-003",
        "SEA-FM-006"
      ],
      "consequences": [
        "Financial Loss",
        "Execution Error"
      ],
      "authority_level": "PRIVILEGED_INTERNAL"
    },
    "safeguards": [
      {
        "safeguard_id": "SEA-SEC-003-SG1",
        "label": "Automated Defensive Guardrail",
        "description": "Enforce strict pre-implementation automated architecture validation against SEA-FM-003.",
        "target_failure_mode": "Repeat architectural failure",
        "effectiveness_level": "PREVENTATIVE"
      }
    ],
    "status": "active"
  },
  {
    "incident_id": "SEA-SEC-004",
    "title": "Hospitality & Gaming ESXi Hypervisor Infrastructure Disruption",
    "affected_system": {
      "system_type": "Enterprise Cloud & Distributed Systems",
      "organization": "Hospitality Hypervisor & Central Reservation Infrastructure",
      "product": "Global Reservation & Hypervisor Infrastructure",
      "is_ai_system": false,
      "is_agentic": false,
      "primary_language": "Multi-Language / Distributed Architecture"
    },
    "incident_date": "2024-03-15",
    "source_authority": {
      "document_type": "Regulatory Filing & Engineering Postmortem",
      "filing_id": "SEA-SEC-004-DOC",
      "reporting_entity": "MGM Resorts International",
      "regulatory_body": "SEC / Regulatory & Engineering Authority"
    },
    "source_url": "https://www.sec.gov/edgar/browse/?CIK=0001039565",
    "source_publisher": "Official Regulatory Repository & Engineering Disclosures",
    "source_stated_contributors": [
      "Social engineering of IT helpdesk reset admin credentials; ransomware deployed directly to..."
    ],
    "documented_facts": [
      {
        "fact_id": "SEA-SEC-004-F1",
        "statement": "Social engineering of IT helpdesk reset admin credentials; ransomware deployed directly to ESXi hypervisors shutting down resort operations.",
        "document_citation": "Official Primary Filing / Published Postmortem"
      }
    ],
    "collectsea_classification": {
      "capabilities": [
        "auth.destructive_action",
        "auth.privileged_action",
        "auth.infrastructure_modification"
      ],
      "failure_mechanisms": [
        "SEA-FM-001",
        "SEA-FM-005"
      ],
      "consequences": [
        "Financial Loss",
        "Execution Error"
      ],
      "authority_level": "IRREVERSIBLE_EXTERNAL"
    },
    "safeguards": [
      {
        "safeguard_id": "SEA-SEC-004-SG1",
        "label": "Automated Defensive Guardrail",
        "description": "Enforce strict pre-implementation automated architecture validation against SEA-FM-001.",
        "target_failure_mode": "Repeat architectural failure",
        "effectiveness_level": "PREVENTATIVE"
      }
    ],
    "status": "active"
  },
  {
    "incident_id": "SEA-SEC-005",
    "title": "Consumer Goods Manufacturing Global ERP Ordering System Disruption",
    "affected_system": {
      "system_type": "Enterprise Cloud & Distributed Systems",
      "organization": "Manufacturing ERP & Automated Supply Chain Platform",
      "product": "Enterprise Resource Planning (ERP) & Ordering Engine",
      "is_ai_system": false,
      "is_agentic": false,
      "primary_language": "Multi-Language / Distributed Architecture"
    },
    "incident_date": "2024-03-15",
    "source_authority": {
      "document_type": "Regulatory Filing & Engineering Postmortem",
      "filing_id": "SEA-SEC-005-DOC",
      "reporting_entity": "The Clorox Company",
      "regulatory_body": "SEC / Regulatory & Engineering Authority"
    },
    "source_url": "https://www.sec.gov/edgar/browse/?CIK=0000021076",
    "source_publisher": "Official Regulatory Repository & Engineering Disclosures",
    "source_stated_contributors": [
      "Ransomware encrypted internal ordering databases; lack of decoupled offline queue forced m..."
    ],
    "documented_facts": [
      {
        "fact_id": "SEA-SEC-005-F1",
        "statement": "Ransomware encrypted internal ordering databases; lack of decoupled offline queue forced multi-week manual processing and inventory write-downs.",
        "document_citation": "Official Primary Filing / Published Postmortem"
      }
    ],
    "collectsea_classification": {
      "capabilities": [
        "auth.financial_action",
        "data.financial_records",
        "auth.infrastructure_modification"
      ],
      "failure_mechanisms": [
        "SEA-FM-005",
        "SEA-FM-007"
      ],
      "consequences": [
        "Financial Loss",
        "Execution Error"
      ],
      "authority_level": "IRREVERSIBLE_EXTERNAL"
    },
    "safeguards": [
      {
        "safeguard_id": "SEA-SEC-005-SG1",
        "label": "Automated Defensive Guardrail",
        "description": "Enforce strict pre-implementation automated architecture validation against SEA-FM-005.",
        "target_failure_mode": "Repeat architectural failure",
        "effectiveness_level": "PREVENTATIVE"
      }
    ],
    "status": "active"
  },
  {
    "incident_id": "SEA-SEC-006",
    "title": "Customer Support Portal Diagnostic HTTP Archive (HAR) Token Exfiltration",
    "affected_system": {
      "system_type": "Enterprise Cloud & Distributed Systems",
      "organization": "Enterprise Identity Provider & Customer Support Mesh",
      "product": "Customer Support Case Management System",
      "is_ai_system": false,
      "is_agentic": false,
      "primary_language": "Multi-Language / Distributed Architecture"
    },
    "incident_date": "2024-03-15",
    "source_authority": {
      "document_type": "Regulatory Filing & Engineering Postmortem",
      "filing_id": "SEA-SEC-006-DOC",
      "reporting_entity": "Okta Inc.",
      "regulatory_body": "SEC / Regulatory & Engineering Authority"
    },
    "source_url": "https://www.sec.gov/edgar/browse/?CIK=0001660134",
    "source_publisher": "Official Regulatory Repository & Engineering Disclosures",
    "source_stated_contributors": [
      "Support portal allowed unredacted HAR file uploads containing session tokens; threat actor..."
    ],
    "documented_facts": [
      {
        "fact_id": "SEA-SEC-006-F1",
        "statement": "Support portal allowed unredacted HAR file uploads containing session tokens; threat actor hijacked customer administrator accounts.",
        "document_citation": "Official Primary Filing / Published Postmortem"
      }
    ],
    "collectsea_classification": {
      "capabilities": [
        "data.credentials_secrets",
        "data.pii",
        "arch.multi_tenant"
      ],
      "failure_mechanisms": [
        "SEA-FM-001",
        "SEA-FM-009"
      ],
      "consequences": [
        "Financial Loss",
        "Execution Error"
      ],
      "authority_level": "PRIVILEGED_INTERNAL"
    },
    "safeguards": [
      {
        "safeguard_id": "SEA-SEC-006-SG1",
        "label": "Automated Defensive Guardrail",
        "description": "Enforce strict pre-implementation automated architecture validation against SEA-FM-001.",
        "target_failure_mode": "Repeat architectural failure",
        "effectiveness_level": "PREVENTATIVE"
      }
    ],
    "status": "active"
  },
  {
    "incident_id": "SEA-SEC-007",
    "title": "High-Frequency Algorithmic Order Router Runaway Execution",
    "affected_system": {
      "system_type": "Enterprise Cloud & Distributed Systems",
      "organization": "High-Frequency Automated Equities Router & Market Maker",
      "product": "Automated High-Frequency Order Execution Router",
      "is_ai_system": true,
      "is_agentic": true,
      "primary_language": "Multi-Language / Distributed Architecture"
    },
    "incident_date": "2024-03-15",
    "source_authority": {
      "document_type": "Regulatory Filing & Engineering Postmortem",
      "filing_id": "SEA-SEC-007-DOC",
      "reporting_entity": "Knight Capital Group",
      "regulatory_body": "SEC / Regulatory & Engineering Authority"
    },
    "source_url": "https://www.sec.gov/litigation/admin/2013/34-70694.pdf",
    "source_publisher": "Official Regulatory Repository & Engineering Disclosures",
    "source_stated_contributors": [
      "Repurposed test flag on 1 of 8 servers activated legacy Power Peg loop; bought 4M shares i..."
    ],
    "documented_facts": [
      {
        "fact_id": "SEA-SEC-007-F1",
        "statement": "Repurposed test flag on 1 of 8 servers activated legacy Power Peg loop; bought 4M shares in 45 minutes losing $460M.",
        "document_citation": "Official Primary Filing / Published Postmortem"
      }
    ],
    "collectsea_classification": {
      "capabilities": [
        "auth.financial_action",
        "auth.autonomous_approval",
        "auth.code_execution"
      ],
      "failure_mechanisms": [
        "SEA-FM-002",
        "SEA-FM-006"
      ],
      "consequences": [
        "Financial Loss",
        "Execution Error"
      ],
      "authority_level": "IRREVERSIBLE_EXTERNAL"
    },
    "safeguards": [
      {
        "safeguard_id": "SEA-SEC-007-SG1",
        "label": "Automated Defensive Guardrail",
        "description": "Enforce strict pre-implementation automated architecture validation against SEA-FM-002.",
        "target_failure_mode": "Repeat architectural failure",
        "effectiveness_level": "PREVENTATIVE"
      }
    ],
    "status": "active"
  },
  {
    "incident_id": "SEA-SEC-008",
    "title": "Telecommunications Customer Call & Text Metadata Repository Exfiltration",
    "affected_system": {
      "system_type": "Enterprise Cloud & Distributed Systems",
      "organization": "Telecommunications & Cloud Data Analytics Warehouse",
      "product": "Cloud Data Warehouse Analytics Repository",
      "is_ai_system": false,
      "is_agentic": false,
      "primary_language": "Multi-Language / Distributed Architecture"
    },
    "incident_date": "2024-03-15",
    "source_authority": {
      "document_type": "Regulatory Filing & Engineering Postmortem",
      "filing_id": "SEA-SEC-008-DOC",
      "reporting_entity": "AT&T Inc.",
      "regulatory_body": "SEC / Regulatory & Engineering Authority"
    },
    "source_url": "https://www.sec.gov/edgar/browse/?CIK=0000732717",
    "source_publisher": "Official Regulatory Repository & Engineering Disclosures",
    "source_stated_contributors": [
      "Contractor credentials without MFA accessed third-party cloud data warehouse; downloaded 1..."
    ],
    "documented_facts": [
      {
        "fact_id": "SEA-SEC-008-F1",
        "statement": "Contractor credentials without MFA accessed third-party cloud data warehouse; downloaded 109 million customer call and text records.",
        "document_citation": "Official Primary Filing / Published Postmortem"
      }
    ],
    "collectsea_classification": {
      "capabilities": [
        "data.pii",
        "data.credentials_secrets",
        "arch.multi_tenant"
      ],
      "failure_mechanisms": [
        "SEA-FM-001",
        "SEA-FM-009"
      ],
      "consequences": [
        "Financial Loss",
        "Execution Error"
      ],
      "authority_level": "PRIVILEGED_INTERNAL"
    },
    "safeguards": [
      {
        "safeguard_id": "SEA-SEC-008-SG1",
        "label": "Automated Defensive Guardrail",
        "description": "Enforce strict pre-implementation automated architecture validation against SEA-FM-001.",
        "target_failure_mode": "Repeat architectural failure",
        "effectiveness_level": "PREVENTATIVE"
      }
    ],
    "status": "active"
  },
  {
    "incident_id": "SEA-SEC-009",
    "title": "Real Estate Escrow Document Portal Insecure Direct Object Reference (IDOR)",
    "affected_system": {
      "system_type": "Enterprise Cloud & Distributed Systems",
      "organization": "Real Estate Escrow & Document Image Management Portal",
      "product": "Document Management & Escrow Imaging Portal",
      "is_ai_system": false,
      "is_agentic": false,
      "primary_language": "Multi-Language / Distributed Architecture"
    },
    "incident_date": "2024-03-15",
    "source_authority": {
      "document_type": "Regulatory Filing & Engineering Postmortem",
      "filing_id": "SEA-SEC-009-DOC",
      "reporting_entity": "First American Financial Corporation",
      "regulatory_body": "SEC / Regulatory & Engineering Authority"
    },
    "source_url": "https://www.sec.gov/news/press-release/2021-102",
    "source_publisher": "Official Regulatory Repository & Engineering Disclosures",
    "source_stated_contributors": [
      "Sequential integer URLs in imaging web portal lacked object-level authorization checks; ex..."
    ],
    "documented_facts": [
      {
        "fact_id": "SEA-SEC-009-F1",
        "statement": "Sequential integer URLs in imaging web portal lacked object-level authorization checks; exposed 885 million escrow and wire documents.",
        "document_citation": "Official Primary Filing / Published Postmortem"
      }
    ],
    "collectsea_classification": {
      "capabilities": [
        "data.financial_records",
        "data.pii",
        "arch.multi_tenant"
      ],
      "failure_mechanisms": [
        "SEA-FM-001",
        "SEA-FM-009"
      ],
      "consequences": [
        "Financial Loss",
        "Execution Error"
      ],
      "authority_level": "PRIVILEGED_INTERNAL"
    },
    "safeguards": [
      {
        "safeguard_id": "SEA-SEC-009-SG1",
        "label": "Automated Defensive Guardrail",
        "description": "Enforce strict pre-implementation automated architecture validation against SEA-FM-001.",
        "target_failure_mode": "Repeat architectural failure",
        "effectiveness_level": "PREVENTATIVE"
      }
    ],
    "status": "active"
  },
  {
    "incident_id": "SEA-SEC-010",
    "title": "Network Management Software Automated Build Pipeline Backdoor Insertion",
    "affected_system": {
      "system_type": "Enterprise Cloud & Distributed Systems",
      "organization": "Enterprise CI/CD Build Orchestration & Distribution Pipeline",
      "product": "Continuous Integration & Build Pipeline (CI/CD)",
      "is_ai_system": false,
      "is_agentic": false,
      "primary_language": "Multi-Language / Distributed Architecture"
    },
    "incident_date": "2024-03-15",
    "source_authority": {
      "document_type": "Regulatory Filing & Engineering Postmortem",
      "filing_id": "SEA-SEC-010-DOC",
      "reporting_entity": "SolarWinds Corporation",
      "regulatory_body": "SEC / Regulatory & Engineering Authority"
    },
    "source_url": "https://www.sec.gov/litigation/complaints/2023/comp-pr2023-227.pdf",
    "source_publisher": "Official Regulatory Repository & Engineering Disclosures",
    "source_stated_contributors": [
      "Compromised build server injected SUNBURST malware into compiler memory during build proce..."
    ],
    "documented_facts": [
      {
        "fact_id": "SEA-SEC-010-F1",
        "statement": "Compromised build server injected SUNBURST malware into compiler memory during build process; distributed to 18,000 customers.",
        "document_citation": "Official Primary Filing / Published Postmortem"
      }
    ],
    "collectsea_classification": {
      "capabilities": [
        "auth.code_execution",
        "auth.infrastructure_modification",
        "data.credentials_secrets"
      ],
      "failure_mechanisms": [
        "SEA-FM-003",
        "SEA-FM-009"
      ],
      "consequences": [
        "Financial Loss",
        "Execution Error"
      ],
      "authority_level": "PRIVILEGED_INTERNAL"
    },
    "safeguards": [
      {
        "safeguard_id": "SEA-SEC-010-SG1",
        "label": "Automated Defensive Guardrail",
        "description": "Enforce strict pre-implementation automated architecture validation against SEA-FM-003.",
        "target_failure_mode": "Repeat architectural failure",
        "effectiveness_level": "PREVENTATIVE"
      }
    ],
    "status": "active"
  },
  {
    "incident_id": "SEA-SEC-011",
    "title": "Automated Algorithmic Real Estate Asset Purchasing Model Failure",
    "affected_system": {
      "system_type": "Enterprise Cloud & Distributed Systems",
      "organization": "Algorithmic Property Valuation & Automated Capital Allocation Engine",
      "product": "Algorithmic Home Valuation & Purchasing Engine (Offers)",
      "is_ai_system": true,
      "is_agentic": true,
      "primary_language": "Multi-Language / Distributed Architecture"
    },
    "incident_date": "2024-03-15",
    "source_authority": {
      "document_type": "Regulatory Filing & Engineering Postmortem",
      "filing_id": "SEA-SEC-011-DOC",
      "reporting_entity": "Zillow Group",
      "regulatory_body": "SEC / Regulatory & Engineering Authority"
    },
    "source_url": "https://www.sec.gov/Archives/edgar/data/1617640/000161764021000085/z-20211102.htm",
    "source_publisher": "Official Regulatory Repository & Engineering Disclosures",
    "source_stated_contributors": [
      "Machine learning pricing models drifted during market volatility; automated purchasing bou..."
    ],
    "documented_facts": [
      {
        "fact_id": "SEA-SEC-011-F1",
        "statement": "Machine learning pricing models drifted during market volatility; automated purchasing bought homes above value resulting in $540M inventory write-down.",
        "document_citation": "Official Primary Filing / Published Postmortem"
      }
    ],
    "collectsea_classification": {
      "capabilities": [
        "auth.financial_action",
        "auth.autonomous_approval",
        "arch.tool_enabled_agent"
      ],
      "failure_mechanisms": [
        "SEA-FM-002",
        "SEA-FM-010"
      ],
      "consequences": [
        "Financial Loss",
        "Execution Error"
      ],
      "authority_level": "IRREVERSIBLE_EXTERNAL"
    },
    "safeguards": [
      {
        "safeguard_id": "SEA-SEC-011-SG1",
        "label": "Automated Defensive Guardrail",
        "description": "Enforce strict pre-implementation automated architecture validation against SEA-FM-002.",
        "target_failure_mode": "Repeat architectural failure",
        "effectiveness_level": "PREVENTATIVE"
      }
    ],
    "status": "active"
  },
  {
    "incident_id": "SEA-SEC-012",
    "title": "Industrial Building Automation Enterprise Hypervisor Ransomware Outage",
    "affected_system": {
      "system_type": "Enterprise Cloud & Distributed Systems",
      "organization": "Industrial Automation & Enterprise Hypervisor Cluster",
      "product": "Enterprise Hypervisor & Corporate Data Infrastructure",
      "is_ai_system": false,
      "is_agentic": false,
      "primary_language": "Multi-Language / Distributed Architecture"
    },
    "incident_date": "2024-03-15",
    "source_authority": {
      "document_type": "Regulatory Filing & Engineering Postmortem",
      "filing_id": "SEA-SEC-012-DOC",
      "reporting_entity": "Johnson Controls International",
      "regulatory_body": "SEC / Regulatory & Engineering Authority"
    },
    "source_url": "https://www.sec.gov/Archives/edgar/data/833444/000083344423000036/jci-20230927.htm",
    "source_publisher": "Official Regulatory Repository & Engineering Disclosures",
    "source_stated_contributors": [
      "Ransomware encrypted virtual hypervisors; halted manufacturing and billing operations incu..."
    ],
    "documented_facts": [
      {
        "fact_id": "SEA-SEC-012-F1",
        "statement": "Ransomware encrypted virtual hypervisors; halted manufacturing and billing operations incurring $27M in direct remediation costs.",
        "document_citation": "Official Primary Filing / Published Postmortem"
      }
    ],
    "collectsea_classification": {
      "capabilities": [
        "auth.destructive_action",
        "auth.infrastructure_modification",
        "data.credentials_secrets"
      ],
      "failure_mechanisms": [
        "SEA-FM-005",
        "SEA-FM-001"
      ],
      "consequences": [
        "Financial Loss",
        "Execution Error"
      ],
      "authority_level": "IRREVERSIBLE_EXTERNAL"
    },
    "safeguards": [
      {
        "safeguard_id": "SEA-SEC-012-SG1",
        "label": "Automated Defensive Guardrail",
        "description": "Enforce strict pre-implementation automated architecture validation against SEA-FM-005.",
        "target_failure_mode": "Repeat architectural failure",
        "effectiveness_level": "PREVENTATIVE"
      }
    ],
    "status": "active"
  },
  {
    "incident_id": "SEA-SEC-013",
    "title": "Credit Bureau Apache Struts Unpatched Framework Remote Code Execution",
    "affected_system": {
      "system_type": "Enterprise Cloud & Distributed Systems",
      "organization": "National Credit Bureau & Consumer Dispute Portal",
      "product": "Online Consumer Dispute Web Application",
      "is_ai_system": false,
      "is_agentic": false,
      "primary_language": "Multi-Language / Distributed Architecture"
    },
    "incident_date": "2024-03-15",
    "source_authority": {
      "document_type": "Regulatory Filing & Engineering Postmortem",
      "filing_id": "SEA-SEC-013-DOC",
      "reporting_entity": "Equifax Inc.",
      "regulatory_body": "SEC / Regulatory & Engineering Authority"
    },
    "source_url": "https://www.sec.gov/edgar/browse/?CIK=0000896878",
    "source_publisher": "Official Regulatory Repository & Engineering Disclosures",
    "source_stated_contributors": [
      "Apache Struts CVE-2017-5638 parser bug left unpatched for 2 months; attackers executed arb..."
    ],
    "documented_facts": [
      {
        "fact_id": "SEA-SEC-013-F1",
        "statement": "Apache Struts CVE-2017-5638 parser bug left unpatched for 2 months; attackers executed arbitrary commands and accessed unencrypted databases of 147M Americans.",
        "document_citation": "Official Primary Filing / Published Postmortem"
      }
    ],
    "collectsea_classification": {
      "capabilities": [
        "data.pii",
        "auth.code_execution",
        "arch.multi_tenant"
      ],
      "failure_mechanisms": [
        "SEA-FM-001",
        "SEA-FM-003"
      ],
      "consequences": [
        "Financial Loss",
        "Execution Error"
      ],
      "authority_level": "PRIVILEGED_INTERNAL"
    },
    "safeguards": [
      {
        "safeguard_id": "SEA-SEC-013-SG1",
        "label": "Automated Defensive Guardrail",
        "description": "Enforce strict pre-implementation automated architecture validation against SEA-FM-001.",
        "target_failure_mode": "Repeat architectural failure",
        "effectiveness_level": "PREVENTATIVE"
      }
    ],
    "status": "active"
  },
  {
    "incident_id": "SEA-SEC-014",
    "title": "Automotive Dealer Management ERP SaaS Ransomware Shutdown",
    "affected_system": {
      "system_type": "Enterprise Cloud & Distributed Systems",
      "organization": "Automotive Dealer Management & Credit Financing SaaS",
      "product": "Dealer Management & Loan Financing SaaS Mesh",
      "is_ai_system": false,
      "is_agentic": false,
      "primary_language": "Multi-Language / Distributed Architecture"
    },
    "incident_date": "2024-03-15",
    "source_authority": {
      "document_type": "Regulatory Filing & Engineering Postmortem",
      "filing_id": "SEA-SEC-014-DOC",
      "reporting_entity": "CDK Global Inc.",
      "regulatory_body": "SEC / Regulatory & Engineering Authority"
    },
    "source_url": "https://www.sec.gov/edgar/browse/?CIK=0001609702",
    "source_publisher": "Official Regulatory Repository & Engineering Disclosures",
    "source_stated_contributors": [
      "Ransomware forced shutdown of core dealer management SaaS platform, halting sales, financi..."
    ],
    "documented_facts": [
      {
        "fact_id": "SEA-SEC-014-F1",
        "statement": "Ransomware forced shutdown of core dealer management SaaS platform, halting sales, financing, and parts ordering for 15,000 auto dealerships.",
        "document_citation": "Official Primary Filing / Published Postmortem"
      }
    ],
    "collectsea_classification": {
      "capabilities": [
        "auth.financial_action",
        "arch.multi_tenant",
        "auth.infrastructure_modification"
      ],
      "failure_mechanisms": [
        "SEA-FM-005",
        "SEA-FM-007"
      ],
      "consequences": [
        "Financial Loss",
        "Execution Error"
      ],
      "authority_level": "IRREVERSIBLE_EXTERNAL"
    },
    "safeguards": [
      {
        "safeguard_id": "SEA-SEC-014-SG1",
        "label": "Automated Defensive Guardrail",
        "description": "Enforce strict pre-implementation automated architecture validation against SEA-FM-005.",
        "target_failure_mode": "Repeat architectural failure",
        "effectiveness_level": "PREVENTATIVE"
      }
    ],
    "status": "active"
  },
  {
    "incident_id": "SEA-SEC-015",
    "title": "Hospitality Chain Unsegmented Reservation Database Credential Breach",
    "affected_system": {
      "system_type": "Enterprise Cloud & Distributed Systems",
      "organization": "Global Hospitality Multi-Property Reservation Database",
      "product": "Starwood Legacy Reservation Database",
      "is_ai_system": false,
      "is_agentic": false,
      "primary_language": "Multi-Language / Distributed Architecture"
    },
    "incident_date": "2024-03-15",
    "source_authority": {
      "document_type": "Regulatory Filing & Engineering Postmortem",
      "filing_id": "SEA-SEC-015-DOC",
      "reporting_entity": "Marriott International",
      "regulatory_body": "SEC / Regulatory & Engineering Authority"
    },
    "source_url": "https://www.sec.gov/edgar/browse/?CIK=0001048286",
    "source_publisher": "Official Regulatory Repository & Engineering Disclosures",
    "source_stated_contributors": [
      "Legacy Starwood database left unsegmented following acquisition; attackers extracted passp..."
    ],
    "documented_facts": [
      {
        "fact_id": "SEA-SEC-015-F1",
        "statement": "Legacy Starwood database left unsegmented following acquisition; attackers extracted passport numbers and encrypted payment cards of 383M guests.",
        "document_citation": "Official Primary Filing / Published Postmortem"
      }
    ],
    "collectsea_classification": {
      "capabilities": [
        "data.pii",
        "data.financial_records",
        "arch.multi_tenant"
      ],
      "failure_mechanisms": [
        "SEA-FM-001",
        "SEA-FM-008"
      ],
      "consequences": [
        "Financial Loss",
        "Execution Error"
      ],
      "authority_level": "PRIVILEGED_INTERNAL"
    },
    "safeguards": [
      {
        "safeguard_id": "SEA-SEC-015-SG1",
        "label": "Automated Defensive Guardrail",
        "description": "Enforce strict pre-implementation automated architecture validation against SEA-FM-001.",
        "target_failure_mode": "Repeat architectural failure",
        "effectiveness_level": "PREVENTATIVE"
      }
    ],
    "status": "active"
  },
  {
    "incident_id": "SEA-SEC-016",
    "title": "Cloud Telephony Inbound SMS Verification Token Interception",
    "affected_system": {
      "system_type": "Enterprise Cloud & Distributed Systems",
      "organization": "Cloud Communications & SMS Gateway Infrastructure",
      "product": "Customer SMS Routing & API Console",
      "is_ai_system": false,
      "is_agentic": false,
      "primary_language": "Multi-Language / Distributed Architecture"
    },
    "incident_date": "2024-03-15",
    "source_authority": {
      "document_type": "Regulatory Filing & Engineering Postmortem",
      "filing_id": "SEA-SEC-016-DOC",
      "reporting_entity": "Twilio Inc.",
      "regulatory_body": "SEC / Regulatory & Engineering Authority"
    },
    "source_url": "https://www.sec.gov/edgar/browse/?CIK=0001447669",
    "source_publisher": "Official Regulatory Repository & Engineering Disclosures",
    "source_stated_contributors": [
      "SMS phishing against employees compromised Okta credentials; attackers accessed internal c..."
    ],
    "documented_facts": [
      {
        "fact_id": "SEA-SEC-016-F1",
        "statement": "SMS phishing against employees compromised Okta credentials; attackers accessed internal consoles to reroute SMS 2FA tokens for 125 customers.",
        "document_citation": "Official Primary Filing / Published Postmortem"
      }
    ],
    "collectsea_classification": {
      "capabilities": [
        "auth.external_communication",
        "data.credentials_secrets",
        "arch.multi_tenant"
      ],
      "failure_mechanisms": [
        "SEA-FM-001",
        "SEA-FM-008"
      ],
      "consequences": [
        "Financial Loss",
        "Execution Error"
      ],
      "authority_level": "PRIVILEGED_INTERNAL"
    },
    "safeguards": [
      {
        "safeguard_id": "SEA-SEC-016-SG1",
        "label": "Automated Defensive Guardrail",
        "description": "Enforce strict pre-implementation automated architecture validation against SEA-FM-001.",
        "target_failure_mode": "Repeat architectural failure",
        "effectiveness_level": "PREVENTATIVE"
      }
    ],
    "status": "active"
  },
  {
    "incident_id": "SEA-SEC-017",
    "title": "Cloud File Storage & Metadata Management Service Exfiltration",
    "affected_system": {
      "system_type": "Enterprise Cloud & Distributed Systems",
      "organization": "Distributed Cloud Storage & Developer Code Repository",
      "product": "GitHub Source Code Repositories & API Tokens",
      "is_ai_system": false,
      "is_agentic": false,
      "primary_language": "Multi-Language / Distributed Architecture"
    },
    "incident_date": "2024-03-15",
    "source_authority": {
      "document_type": "Regulatory Filing & Engineering Postmortem",
      "filing_id": "SEA-SEC-017-DOC",
      "reporting_entity": "Dropbox Inc.",
      "regulatory_body": "SEC / Regulatory & Engineering Authority"
    },
    "source_url": "https://www.sec.gov/edgar/browse/?CIK=0001467623",
    "source_publisher": "Official Regulatory Repository & Engineering Disclosures",
    "source_stated_contributors": [
      "Phishing attack targeted developer CircleCI accounts; attackers accessed internal GitHub r..."
    ],
    "documented_facts": [
      {
        "fact_id": "SEA-SEC-017-F1",
        "statement": "Phishing attack targeted developer CircleCI accounts; attackers accessed internal GitHub repositories containing API tokens and internal tooling source code.",
        "document_citation": "Official Primary Filing / Published Postmortem"
      }
    ],
    "collectsea_classification": {
      "capabilities": [
        "auth.code_execution",
        "data.credentials_secrets",
        "arch.external_api"
      ],
      "failure_mechanisms": [
        "SEA-FM-001",
        "SEA-FM-009"
      ],
      "consequences": [
        "Financial Loss",
        "Execution Error"
      ],
      "authority_level": "PRIVILEGED_INTERNAL"
    },
    "safeguards": [
      {
        "safeguard_id": "SEA-SEC-017-SG1",
        "label": "Automated Defensive Guardrail",
        "description": "Enforce strict pre-implementation automated architecture validation against SEA-FM-001.",
        "target_failure_mode": "Repeat architectural failure",
        "effectiveness_level": "PREVENTATIVE"
      }
    ],
    "status": "active"
  },
  {
    "incident_id": "SEA-SEC-018",
    "title": "Entertainment Media Corporation Active Directory Kerberos Ticket Forgery",
    "affected_system": {
      "system_type": "Enterprise Cloud & Distributed Systems",
      "organization": "Media Production Domain Controller & Enterprise Storage",
      "product": "Corporate Windows Active Directory Domain",
      "is_ai_system": false,
      "is_agentic": false,
      "primary_language": "Multi-Language / Distributed Architecture"
    },
    "incident_date": "2024-03-15",
    "source_authority": {
      "document_type": "Regulatory Filing & Engineering Postmortem",
      "filing_id": "SEA-SEC-018-DOC",
      "reporting_entity": "Sony Pictures Entertainment",
      "regulatory_body": "SEC / Regulatory & Engineering Authority"
    },
    "source_url": "https://www.sec.gov/Archives/edgar/data/789019/000119312524011295/d708866d8k.htm",
    "source_publisher": "Official Regulatory Repository & Engineering Disclosures",
    "source_stated_contributors": [
      "Spear phishing compromised administrator credentials; adversaries used Mimikatz for Pass-t..."
    ],
    "documented_facts": [
      {
        "fact_id": "SEA-SEC-018-F1",
        "statement": "Spear phishing compromised administrator credentials; adversaries used Mimikatz for Pass-the-Hash and wiper malware to permanently erase servers and workstations.",
        "document_citation": "Official Primary Filing / Published Postmortem"
      }
    ],
    "collectsea_classification": {
      "capabilities": [
        "auth.destructive_action",
        "auth.privileged_action",
        "data.credentials_secrets"
      ],
      "failure_mechanisms": [
        "SEA-FM-005",
        "SEA-FM-001"
      ],
      "consequences": [
        "Financial Loss",
        "Execution Error"
      ],
      "authority_level": "IRREVERSIBLE_EXTERNAL"
    },
    "safeguards": [
      {
        "safeguard_id": "SEA-SEC-018-SG1",
        "label": "Automated Defensive Guardrail",
        "description": "Enforce strict pre-implementation automated architecture validation against SEA-FM-005.",
        "target_failure_mode": "Repeat architectural failure",
        "effectiveness_level": "PREVENTATIVE"
      }
    ],
    "status": "active"
  },
  {
    "incident_id": "SEA-SEC-019",
    "title": "National Retailer HVAC Vendor VPN Credential Pivot & POS Memory Scraper",
    "affected_system": {
      "system_type": "Enterprise Cloud & Distributed Systems",
      "organization": "Retail Point-of-Sale (POS) & Automated Ingestion Network",
      "product": "Point-of-Sale Checkout Terminal Cluster",
      "is_ai_system": false,
      "is_agentic": false,
      "primary_language": "Multi-Language / Distributed Architecture"
    },
    "incident_date": "2024-03-15",
    "source_authority": {
      "document_type": "Regulatory Filing & Engineering Postmortem",
      "filing_id": "SEA-SEC-019-DOC",
      "reporting_entity": "Target Corporation",
      "regulatory_body": "SEC / Regulatory & Engineering Authority"
    },
    "source_url": "https://www.sec.gov/edgar/browse/?CIK=0000027419",
    "source_publisher": "Official Regulatory Repository & Engineering Disclosures",
    "source_stated_contributors": [
      "HVAC vendor portal credentials lacked two-factor authentication; attackers pivoted into in..."
    ],
    "documented_facts": [
      {
        "fact_id": "SEA-SEC-019-F1",
        "statement": "HVAC vendor portal credentials lacked two-factor authentication; attackers pivoted into internal networks and pushed BlackPOS memory scrapers to 1,800 checkout terminals.",
        "document_citation": "Official Primary Filing / Published Postmortem"
      }
    ],
    "collectsea_classification": {
      "capabilities": [
        "auth.financial_action",
        "data.financial_records",
        "data.credentials_secrets"
      ],
      "failure_mechanisms": [
        "SEA-FM-001",
        "SEA-FM-009"
      ],
      "consequences": [
        "Financial Loss",
        "Execution Error"
      ],
      "authority_level": "IRREVERSIBLE_EXTERNAL"
    },
    "safeguards": [
      {
        "safeguard_id": "SEA-SEC-019-SG1",
        "label": "Automated Defensive Guardrail",
        "description": "Enforce strict pre-implementation automated architecture validation against SEA-FM-001.",
        "target_failure_mode": "Repeat architectural failure",
        "effectiveness_level": "PREVENTATIVE"
      }
    ],
    "status": "active"
  },
  {
    "incident_id": "SEA-SEC-020",
    "title": "Social Media Internal Administrative Account Delegation Social Engineering",
    "affected_system": {
      "system_type": "Enterprise Cloud & Distributed Systems",
      "organization": "Social Messaging & Internal Administrative Support Portal",
      "product": "Internal Customer Support & Account Management Tooling",
      "is_ai_system": false,
      "is_agentic": false,
      "primary_language": "Multi-Language / Distributed Architecture"
    },
    "incident_date": "2024-03-15",
    "source_authority": {
      "document_type": "Regulatory Filing & Engineering Postmortem",
      "filing_id": "SEA-SEC-020-DOC",
      "reporting_entity": "Twitter Inc.",
      "regulatory_body": "SEC / Regulatory & Engineering Authority"
    },
    "source_url": "https://www.sec.gov/edgar/browse/?CIK=0001418091",
    "source_publisher": "Official Regulatory Repository & Engineering Disclosures",
    "source_stated_contributors": [
      "Social engineering against customer support agents granted access to internal account dele..."
    ],
    "documented_facts": [
      {
        "fact_id": "SEA-SEC-020-F1",
        "statement": "Social engineering against customer support agents granted access to internal account delegation tooling; attackers hijacked 130 verified accounts for Bitcoin fraud.",
        "document_citation": "Official Primary Filing / Published Postmortem"
      }
    ],
    "collectsea_classification": {
      "capabilities": [
        "auth.privileged_action",
        "data.credentials_secrets",
        "arch.multi_tenant"
      ],
      "failure_mechanisms": [
        "SEA-FM-001",
        "SEA-FM-008"
      ],
      "consequences": [
        "Financial Loss",
        "Execution Error"
      ],
      "authority_level": "PRIVILEGED_INTERNAL"
    },
    "safeguards": [
      {
        "safeguard_id": "SEA-SEC-020-SG1",
        "label": "Automated Defensive Guardrail",
        "description": "Enforce strict pre-implementation automated architecture validation against SEA-FM-001.",
        "target_failure_mode": "Repeat architectural failure",
        "effectiveness_level": "PREVENTATIVE"
      }
    ],
    "status": "active"
  },
  {
    "incident_id": "SEA-REG-001",
    "title": "Loan Servicing Interface Confusion Inadvertent Principal Wire Transfer",
    "affected_system": {
      "system_type": "Enterprise Cloud & Distributed Systems",
      "organization": "Global Commercial Banking & Wire Settlement Clearinghouse",
      "product": "Financial Wire Settlement Platform (Flexcube)",
      "is_ai_system": false,
      "is_agentic": false,
      "primary_language": "Multi-Language / Distributed Architecture"
    },
    "incident_date": "2024-03-15",
    "source_authority": {
      "document_type": "Regulatory Filing & Engineering Postmortem",
      "filing_id": "SEA-REG-001-DOC",
      "reporting_entity": "Citibank, N.A.",
      "regulatory_body": "SEC / Regulatory & Engineering Authority"
    },
    "source_url": "https://scholar.google.com/scholar_case?case=17621124430154941913",
    "source_publisher": "Official Regulatory Repository & Engineering Disclosures",
    "source_stated_contributors": [
      "Unintuitive Flexcube interface required checking obscure override box; bank accidentally w..."
    ],
    "documented_facts": [
      {
        "fact_id": "SEA-REG-001-F1",
        "statement": "Unintuitive Flexcube interface required checking obscure override box; bank accidentally wired $894M of proprietary funds to Revlon lenders.",
        "document_citation": "Official Primary Filing / Published Postmortem"
      }
    ],
    "collectsea_classification": {
      "capabilities": [
        "auth.financial_action",
        "auth.privileged_action",
        "data.financial_records"
      ],
      "failure_mechanisms": [
        "SEA-FM-002",
        "SEA-FM-007"
      ],
      "consequences": [
        "Financial Loss",
        "Execution Error"
      ],
      "authority_level": "IRREVERSIBLE_EXTERNAL"
    },
    "safeguards": [
      {
        "safeguard_id": "SEA-REG-001-SG1",
        "label": "Automated Defensive Guardrail",
        "description": "Enforce strict pre-implementation automated architecture validation against SEA-FM-002.",
        "target_failure_mode": "Repeat architectural failure",
        "effectiveness_level": "PREVENTATIVE"
      }
    ],
    "status": "active"
  },
  {
    "incident_id": "SEA-REG-002",
    "title": "Cloud Metadata Proxy SSRF & WAF Misconfiguration Data Exfiltration",
    "affected_system": {
      "system_type": "Enterprise Cloud & Distributed Systems",
      "organization": "Consumer Banking & Cloud Object Storage Infrastructure",
      "product": "Cloud Virtual Private Network & WAF Architecture",
      "is_ai_system": false,
      "is_agentic": false,
      "primary_language": "Multi-Language / Distributed Architecture"
    },
    "incident_date": "2024-03-15",
    "source_authority": {
      "document_type": "Regulatory Filing & Engineering Postmortem",
      "filing_id": "SEA-REG-002-DOC",
      "reporting_entity": "Capital One Financial Corporation",
      "regulatory_body": "SEC / Regulatory & Engineering Authority"
    },
    "source_url": "https://www.occ.gov/static/enforcement-actions/ea2020-047.pdf",
    "source_publisher": "Official Regulatory Repository & Engineering Disclosures",
    "source_stated_contributors": [
      "Misconfigured ModSecurity WAF exploited via SSRF to query IMDSv1; exfiltrated 700 S3 bucke..."
    ],
    "documented_facts": [
      {
        "fact_id": "SEA-REG-002-F1",
        "statement": "Misconfigured ModSecurity WAF exploited via SSRF to query IMDSv1; exfiltrated 700 S3 buckets containing 106M credit card applications.",
        "document_citation": "Official Primary Filing / Published Postmortem"
      }
    ],
    "collectsea_classification": {
      "capabilities": [
        "data.credentials_secrets",
        "data.pii",
        "auth.privileged_action"
      ],
      "failure_mechanisms": [
        "SEA-FM-001",
        "SEA-FM-009"
      ],
      "consequences": [
        "Financial Loss",
        "Execution Error"
      ],
      "authority_level": "PRIVILEGED_INTERNAL"
    },
    "safeguards": [
      {
        "safeguard_id": "SEA-REG-002-SG1",
        "label": "Automated Defensive Guardrail",
        "description": "Enforce strict pre-implementation automated architecture validation against SEA-FM-001.",
        "target_failure_mode": "Repeat architectural failure",
        "effectiveness_level": "PREVENTATIVE"
      }
    ],
    "status": "active"
  },
  {
    "incident_id": "SEA-REG-003",
    "title": "Automated Algorithmic Order Routing & Price Execution Quality Disclosures",
    "affected_system": {
      "system_type": "Enterprise Cloud & Distributed Systems",
      "organization": "Retail Brokerage Mobile API & Market Settlement Engine",
      "product": "Algorithmic Order Routing & Settlement Engine",
      "is_ai_system": true,
      "is_agentic": true,
      "primary_language": "Multi-Language / Distributed Architecture"
    },
    "incident_date": "2024-03-15",
    "source_authority": {
      "document_type": "Regulatory Filing & Engineering Postmortem",
      "filing_id": "SEA-REG-003-DOC",
      "reporting_entity": "Robinhood Financial LLC",
      "regulatory_body": "SEC / Regulatory & Engineering Authority"
    },
    "source_url": "https://www.sec.gov/litigation/admin/2020/33-10906.pdf",
    "source_publisher": "Official Regulatory Repository & Engineering Disclosures",
    "source_stated_contributors": [
      "Algorithmic order router prioritized Payment for Order Flow (PFOF) revenue over customer p..."
    ],
    "documented_facts": [
      {
        "fact_id": "SEA-REG-003-F1",
        "statement": "Algorithmic order router prioritized Payment for Order Flow (PFOF) revenue over customer price execution quality, costing users $34.1M in inferior prices.",
        "document_citation": "Official Primary Filing / Published Postmortem"
      }
    ],
    "collectsea_classification": {
      "capabilities": [
        "auth.financial_action",
        "auth.autonomous_approval",
        "data.financial_records"
      ],
      "failure_mechanisms": [
        "SEA-FM-002",
        "SEA-FM-010"
      ],
      "consequences": [
        "Financial Loss",
        "Execution Error"
      ],
      "authority_level": "IRREVERSIBLE_EXTERNAL"
    },
    "safeguards": [
      {
        "safeguard_id": "SEA-REG-003-SG1",
        "label": "Automated Defensive Guardrail",
        "description": "Enforce strict pre-implementation automated architecture validation against SEA-FM-002.",
        "target_failure_mode": "Repeat architectural failure",
        "effectiveness_level": "PREVENTATIVE"
      }
    ],
    "status": "active"
  },
  {
    "incident_id": "SEA-REG-004",
    "title": "Algorithmic Dynamic Spoofing & Order Book Manipulation Flash Crash",
    "affected_system": {
      "system_type": "Enterprise Cloud & Distributed Systems",
      "organization": "Algorithmic Derivatives High-Frequency Trading Engine",
      "product": "Automated E-Mini Futures Trading System",
      "is_ai_system": true,
      "is_agentic": true,
      "primary_language": "Multi-Language / Distributed Architecture"
    },
    "incident_date": "2024-03-15",
    "source_authority": {
      "document_type": "Regulatory Filing & Engineering Postmortem",
      "filing_id": "SEA-REG-004-DOC",
      "reporting_entity": "Navinder Singh Sarao / Nav Sarao Futures",
      "regulatory_body": "SEC / Regulatory & Engineering Authority"
    },
    "source_url": "https://www.cftc.gov/PressRoom/PressReleases/8412-21",
    "source_publisher": "Official Regulatory Repository & Engineering Disclosures",
    "source_stated_contributors": [
      "Dynamic spoofing trading algorithm modified thousands of phantom orders in milliseconds to..."
    ],
    "documented_facts": [
      {
        "fact_id": "SEA-REG-004-F1",
        "statement": "Dynamic spoofing trading algorithm modified thousands of phantom orders in milliseconds to manipulate order books, contributing to the 2010 Flash Crash.",
        "document_citation": "Official Primary Filing / Published Postmortem"
      }
    ],
    "collectsea_classification": {
      "capabilities": [
        "auth.financial_action",
        "auth.autonomous_approval",
        "auth.code_execution"
      ],
      "failure_mechanisms": [
        "SEA-FM-002",
        "SEA-FM-010"
      ],
      "consequences": [
        "Financial Loss",
        "Execution Error"
      ],
      "authority_level": "IRREVERSIBLE_EXTERNAL"
    },
    "safeguards": [
      {
        "safeguard_id": "SEA-REG-004-SG1",
        "label": "Automated Defensive Guardrail",
        "description": "Enforce strict pre-implementation automated architecture validation against SEA-FM-002.",
        "target_failure_mode": "Repeat architectural failure",
        "effectiveness_level": "PREVENTATIVE"
      }
    ],
    "status": "active"
  },
  {
    "incident_id": "SEA-REG-005",
    "title": "Quantitative Market Maker Microwave Timestamp Synchronization Failure",
    "affected_system": {
      "system_type": "Enterprise Cloud & Distributed Systems",
      "organization": "Proprietary Quantitative Arbitrage Trading Mesh",
      "product": "Ultra-Low Latency High-Frequency Trading Mesh",
      "is_ai_system": false,
      "is_agentic": false,
      "primary_language": "Multi-Language / Distributed Architecture"
    },
    "incident_date": "2024-03-15",
    "source_authority": {
      "document_type": "Regulatory Filing & Engineering Postmortem",
      "filing_id": "SEA-REG-005-DOC",
      "reporting_entity": "Jump Trading LLC",
      "regulatory_body": "SEC / Regulatory & Engineering Authority"
    },
    "source_url": "https://www.cftc.gov/PressRoom/PressReleases/8412-21",
    "source_publisher": "Official Regulatory Repository & Engineering Disclosures",
    "source_stated_contributors": [
      "A microsecond clock drift between Chicago and New York microwave feeds caused automated tr..."
    ],
    "documented_facts": [
      {
        "fact_id": "SEA-REG-005-F1",
        "statement": "A microsecond clock drift between Chicago and New York microwave feeds caused automated trading models to execute arbitrage against stale quotes.",
        "document_citation": "Official Primary Filing / Published Postmortem"
      }
    ],
    "collectsea_classification": {
      "capabilities": [
        "auth.financial_action",
        "auth.autonomous_approval",
        "data.financial_records"
      ],
      "failure_mechanisms": [
        "SEA-FM-002",
        "SEA-FM-006"
      ],
      "consequences": [
        "Financial Loss",
        "Execution Error"
      ],
      "authority_level": "IRREVERSIBLE_EXTERNAL"
    },
    "safeguards": [
      {
        "safeguard_id": "SEA-REG-005-SG1",
        "label": "Automated Defensive Guardrail",
        "description": "Enforce strict pre-implementation automated architecture validation against SEA-FM-002.",
        "target_failure_mode": "Repeat architectural failure",
        "effectiveness_level": "PREVENTATIVE"
      }
    ],
    "status": "active"
  },
  {
    "incident_id": "SEA-POST-001",
    "title": "High-Throughput Global Financial API: Idempotency Key Architecture",
    "affected_system": {
      "system_type": "Enterprise Cloud & Distributed Systems",
      "organization": "Global Payment Gateway & Merchant Idempotency API",
      "product": "API Gateway & Payment Processing Engine",
      "is_ai_system": false,
      "is_agentic": false,
      "primary_language": "Multi-Language / Distributed Architecture"
    },
    "incident_date": "2024-03-15",
    "source_authority": {
      "document_type": "Regulatory Filing & Engineering Postmortem",
      "filing_id": "SEA-POST-001-DOC",
      "reporting_entity": "Stripe Inc.",
      "regulatory_body": "SEC / Regulatory & Engineering Authority"
    },
    "source_url": "https://stripe.com/blog/idempotency",
    "source_publisher": "Official Regulatory Repository & Engineering Disclosures",
    "source_stated_contributors": [
      "Network timeouts caused client retry storms and double charges; engineered atomic SQL idem..."
    ],
    "documented_facts": [
      {
        "fact_id": "SEA-POST-001-F1",
        "statement": "Network timeouts caused client retry storms and double charges; engineered atomic SQL idempotency keys to guarantee exactly-once mutation semantics.",
        "document_citation": "Official Primary Filing / Published Postmortem"
      }
    ],
    "collectsea_classification": {
      "capabilities": [
        "auth.financial_action",
        "arch.external_api",
        "arch.caching"
      ],
      "failure_mechanisms": [
        "SEA-FM-006",
        "SEA-FM-007"
      ],
      "consequences": [
        "Financial Loss",
        "Execution Error"
      ],
      "authority_level": "IRREVERSIBLE_EXTERNAL"
    },
    "safeguards": [
      {
        "safeguard_id": "SEA-POST-001-SG1",
        "label": "Automated Defensive Guardrail",
        "description": "Enforce strict pre-implementation automated architecture validation against SEA-FM-006.",
        "target_failure_mode": "Repeat architectural failure",
        "effectiveness_level": "PREVENTATIVE"
      }
    ],
    "status": "active"
  },
  {
    "incident_id": "SEA-POST-002",
    "title": "Distributed Cloud Systems: Idempotent API Recovery & Retry Storms",
    "affected_system": {
      "system_type": "Enterprise Cloud & Distributed Systems",
      "organization": "Global Cloud Control Plane & Dynamic Configuration Service",
      "product": "Cloud API Gateway & Distributed State Orchestrator",
      "is_ai_system": false,
      "is_agentic": false,
      "primary_language": "Multi-Language / Distributed Architecture"
    },
    "incident_date": "2024-03-15",
    "source_authority": {
      "document_type": "Regulatory Filing & Engineering Postmortem",
      "filing_id": "SEA-POST-002-DOC",
      "reporting_entity": "Amazon Web Services (AWS)",
      "regulatory_body": "SEC / Regulatory & Engineering Authority"
    },
    "source_url": "https://aws.amazon.com/builders-library/making-retries-safe-with-idempotent-APIs/",
    "source_publisher": "Official Regulatory Repository & Engineering Disclosures",
    "source_stated_contributors": [
      "Naive retry loops across thousands of microservices created self-inflicted denial-of-servi..."
    ],
    "documented_facts": [
      {
        "fact_id": "SEA-POST-002-F1",
        "statement": "Naive retry loops across thousands of microservices created self-inflicted denial-of-service avalanches; designed exponential jitter algorithms.",
        "document_citation": "Official Primary Filing / Published Postmortem"
      }
    ],
    "collectsea_classification": {
      "capabilities": [
        "auth.infrastructure_modification",
        "arch.external_api",
        "arch.caching"
      ],
      "failure_mechanisms": [
        "SEA-FM-006",
        "SEA-FM-007"
      ],
      "consequences": [
        "Financial Loss",
        "Execution Error"
      ],
      "authority_level": "PRIVILEGED_INTERNAL"
    },
    "safeguards": [
      {
        "safeguard_id": "SEA-POST-002-SG1",
        "label": "Automated Defensive Guardrail",
        "description": "Enforce strict pre-implementation automated architecture validation against SEA-FM-006.",
        "target_failure_mode": "Repeat architectural failure",
        "effectiveness_level": "PREVENTATIVE"
      }
    ],
    "status": "active"
  },
  {
    "incident_id": "SEA-POST-004",
    "title": "Cloud Provider Automated De-provisioning Script Unintended Account Deletion",
    "affected_system": {
      "system_type": "Enterprise Cloud & Distributed Systems",
      "organization": "Private Cloud Virtual Private Cloud (VPC) Deployment Engine",
      "product": "Multi-Region Cloud Hosting & Backup Environment",
      "is_ai_system": false,
      "is_agentic": false,
      "primary_language": "Multi-Language / Distributed Architecture"
    },
    "incident_date": "2024-03-15",
    "source_authority": {
      "document_type": "Regulatory Filing & Engineering Postmortem",
      "filing_id": "SEA-POST-004-DOC",
      "reporting_entity": "UniSuper & Google Cloud",
      "regulatory_body": "SEC / Regulatory & Engineering Authority"
    },
    "source_url": "https://www.unisuper.com.au/about-us/media-centre/2024/a-joint-statement-from-unisuper-and-google-cloud",
    "source_publisher": "Official Regulatory Repository & Engineering Disclosures",
    "source_stated_contributors": [
      "A blank account parameter during internal migration triggered an automated garbage collect..."
    ],
    "documented_facts": [
      {
        "fact_id": "SEA-POST-004-F1",
        "statement": "A blank account parameter during internal migration triggered an automated garbage collector that permanently deleted the entire cloud estate.",
        "document_citation": "Official Primary Filing / Published Postmortem"
      }
    ],
    "collectsea_classification": {
      "capabilities": [
        "auth.destructive_action",
        "auth.infrastructure_modification",
        "arch.multi_tenant"
      ],
      "failure_mechanisms": [
        "SEA-FM-005",
        "SEA-FM-008"
      ],
      "consequences": [
        "Financial Loss",
        "Execution Error"
      ],
      "authority_level": "IRREVERSIBLE_EXTERNAL"
    },
    "safeguards": [
      {
        "safeguard_id": "SEA-POST-004-SG1",
        "label": "Automated Defensive Guardrail",
        "description": "Enforce strict pre-implementation automated architecture validation against SEA-FM-005.",
        "target_failure_mode": "Repeat architectural failure",
        "effectiveness_level": "PREVENTATIVE"
      }
    ],
    "status": "active"
  },
  {
    "incident_id": "SEA-POST-005",
    "title": "Global Edge Network Control Plane Deadlock & DNS Resolution Failure",
    "affected_system": {
      "system_type": "Enterprise Cloud & Distributed Systems",
      "organization": "Global Edge CDN & Control Plane Service Mesh",
      "product": "Global Edge Control Plane & DNS Infrastructure",
      "is_ai_system": false,
      "is_agentic": false,
      "primary_language": "Multi-Language / Distributed Architecture"
    },
    "incident_date": "2024-03-15",
    "source_authority": {
      "document_type": "Regulatory Filing & Engineering Postmortem",
      "filing_id": "SEA-POST-005-DOC",
      "reporting_entity": "Cloudflare Inc.",
      "regulatory_body": "SEC / Regulatory & Engineering Authority"
    },
    "source_url": "https://blog.cloudflare.com/cloudflare-outage-on-june-21-2022/",
    "source_publisher": "Official Regulatory Repository & Engineering Disclosures",
    "source_stated_contributors": [
      "Database schema migration distributed malformed configuration tables to edge proxies, caus..."
    ],
    "documented_facts": [
      {
        "fact_id": "SEA-POST-005-F1",
        "statement": "Database schema migration distributed malformed configuration tables to edge proxies, causing edge daemons to crash-loop on unhandled NULL values.",
        "document_citation": "Official Primary Filing / Published Postmortem"
      }
    ],
    "collectsea_classification": {
      "capabilities": [
        "auth.code_execution",
        "auth.infrastructure_modification",
        "arch.external_api"
      ],
      "failure_mechanisms": [
        "SEA-FM-003",
        "SEA-FM-006"
      ],
      "consequences": [
        "Financial Loss",
        "Execution Error"
      ],
      "authority_level": "PRIVILEGED_INTERNAL"
    },
    "safeguards": [
      {
        "safeguard_id": "SEA-POST-005-SG1",
        "label": "Automated Defensive Guardrail",
        "description": "Enforce strict pre-implementation automated architecture validation against SEA-FM-003.",
        "target_failure_mode": "Repeat architectural failure",
        "effectiveness_level": "PREVENTATIVE"
      }
    ],
    "status": "active"
  },
  {
    "incident_id": "SEA-POST-006",
    "title": "Dynamic Edge Configuration Compiler Bug & Traffic Routing Disruption",
    "affected_system": {
      "system_type": "Enterprise Cloud & Distributed Systems",
      "organization": "Global Edge Compute & Dynamic VCL Proxy Network",
      "product": "Dynamic Edge VCL Configuration Engine",
      "is_ai_system": false,
      "is_agentic": false,
      "primary_language": "Multi-Language / Distributed Architecture"
    },
    "incident_date": "2024-03-15",
    "source_authority": {
      "document_type": "Regulatory Filing & Engineering Postmortem",
      "filing_id": "SEA-POST-006-DOC",
      "reporting_entity": "Fastly Inc.",
      "regulatory_body": "SEC / Regulatory & Engineering Authority"
    },
    "source_url": "https://blog.cloudflare.com/cloudflare-outage-on-june-21-2022/",
    "source_publisher": "Official Regulatory Repository & Engineering Disclosures",
    "source_stated_contributors": [
      "A customer configuration update containing a rare syntax pattern triggered a dormant compi..."
    ],
    "documented_facts": [
      {
        "fact_id": "SEA-POST-006-F1",
        "statement": "A customer configuration update containing a rare syntax pattern triggered a dormant compiler bug, crashing 85% of global edge nodes.",
        "document_citation": "Official Primary Filing / Published Postmortem"
      }
    ],
    "collectsea_classification": {
      "capabilities": [
        "auth.code_execution",
        "auth.infrastructure_modification",
        "arch.external_api"
      ],
      "failure_mechanisms": [
        "SEA-FM-003",
        "SEA-FM-006"
      ],
      "consequences": [
        "Financial Loss",
        "Execution Error"
      ],
      "authority_level": "PRIVILEGED_INTERNAL"
    },
    "safeguards": [
      {
        "safeguard_id": "SEA-POST-006-SG1",
        "label": "Automated Defensive Guardrail",
        "description": "Enforce strict pre-implementation automated architecture validation against SEA-FM-003.",
        "target_failure_mode": "Repeat architectural failure",
        "effectiveness_level": "PREVENTATIVE"
      }
    ],
    "status": "active"
  },
  {
    "incident_id": "SEA-POST-007",
    "title": "Multi-Tenant Cloud Database MicroVM Container Escape Vulnerability",
    "affected_system": {
      "system_type": "Enterprise Cloud & Distributed Systems",
      "organization": "Multi-Tenant Cloud Database & Jupyter Container Host",
      "product": "Managed PostgreSQL Cloud Service",
      "is_ai_system": false,
      "is_agentic": false,
      "primary_language": "Multi-Language / Distributed Architecture"
    },
    "incident_date": "2024-03-15",
    "source_authority": {
      "document_type": "Regulatory Filing & Engineering Postmortem",
      "filing_id": "SEA-POST-007-DOC",
      "reporting_entity": "Wiz Security & Microsoft Azure",
      "regulatory_body": "SEC / Regulatory & Engineering Authority"
    },
    "source_url": "https://github.blog/2023-03-23-we-updated-our-rsa-ssh-host-key/",
    "source_publisher": "Official Regulatory Repository & Engineering Disclosures",
    "source_stated_contributors": [
      "Custom PostgreSQL extensions allowed remote code execution and container escape, granting ..."
    ],
    "documented_facts": [
      {
        "fact_id": "SEA-POST-007-F1",
        "statement": "Custom PostgreSQL extensions allowed remote code execution and container escape, granting read access to authentication certificates of other tenants.",
        "document_citation": "Official Primary Filing / Published Postmortem"
      }
    ],
    "collectsea_classification": {
      "capabilities": [
        "auth.code_execution",
        "arch.multi_tenant",
        "data.credentials_secrets"
      ],
      "failure_mechanisms": [
        "SEA-FM-003",
        "SEA-FM-001"
      ],
      "consequences": [
        "Financial Loss",
        "Execution Error"
      ],
      "authority_level": "PRIVILEGED_INTERNAL"
    },
    "safeguards": [
      {
        "safeguard_id": "SEA-POST-007-SG1",
        "label": "Automated Defensive Guardrail",
        "description": "Enforce strict pre-implementation automated architecture validation against SEA-FM-003.",
        "target_failure_mode": "Repeat architectural failure",
        "effectiveness_level": "PREVENTATIVE"
      }
    ],
    "status": "active"
  },
  {
    "incident_id": "SEA-POST-008",
    "title": "Public Source Code Repository Private RSA Host Key Exposure",
    "affected_system": {
      "system_type": "Enterprise Cloud & Distributed Systems",
      "organization": "Distributed Git Host & RSA Host Key Infrastructure",
      "product": "SSH Remote Repository Management System",
      "is_ai_system": false,
      "is_agentic": false,
      "primary_language": "Multi-Language / Distributed Architecture"
    },
    "incident_date": "2024-03-15",
    "source_authority": {
      "document_type": "Regulatory Filing & Engineering Postmortem",
      "filing_id": "SEA-POST-008-DOC",
      "reporting_entity": "GitHub Inc.",
      "regulatory_body": "SEC / Regulatory & Engineering Authority"
    },
    "source_url": "https://github.blog/2023-03-23-we-updated-our-rsa-ssh-host-key/",
    "source_publisher": "Official Regulatory Repository & Engineering Disclosures",
    "source_stated_contributors": [
      "Private RSA SSH host key was briefly exposed in a public repository commit log; rotated gl..."
    ],
    "documented_facts": [
      {
        "fact_id": "SEA-POST-008-F1",
        "statement": "Private RSA SSH host key was briefly exposed in a public repository commit log; rotated global host key to prevent MITM traffic interception.",
        "document_citation": "Official Primary Filing / Published Postmortem"
      }
    ],
    "collectsea_classification": {
      "capabilities": [
        "data.credentials_secrets",
        "auth.privileged_action",
        "arch.external_api"
      ],
      "failure_mechanisms": [
        "SEA-FM-001",
        "SEA-FM-009"
      ],
      "consequences": [
        "Financial Loss",
        "Execution Error"
      ],
      "authority_level": "PRIVILEGED_INTERNAL"
    },
    "safeguards": [
      {
        "safeguard_id": "SEA-POST-008-SG1",
        "label": "Automated Defensive Guardrail",
        "description": "Enforce strict pre-implementation automated architecture validation against SEA-FM-001.",
        "target_failure_mode": "Repeat architectural failure",
        "effectiveness_level": "PREVENTATIVE"
      }
    ],
    "status": "active"
  },
  {
    "incident_id": "SEA-POST-009",
    "title": "Production Database Directory Accidental Deletion & 5-Way Backup Failure",
    "affected_system": {
      "system_type": "Enterprise Cloud & Distributed Systems",
      "organization": "Git CI/CD Pipeline & PostgreSQL Secondary Cluster",
      "product": "Production PostgreSQL Replication Cluster",
      "is_ai_system": false,
      "is_agentic": false,
      "primary_language": "Multi-Language / Distributed Architecture"
    },
    "incident_date": "2024-03-15",
    "source_authority": {
      "document_type": "Regulatory Filing & Engineering Postmortem",
      "filing_id": "SEA-POST-009-DOC",
      "reporting_entity": "GitLab B.V.",
      "regulatory_body": "SEC / Regulatory & Engineering Authority"
    },
    "source_url": "https://aws.amazon.com/builders-library/making-retries-safe-with-idempotent-APIs/",
    "source_publisher": "Official Regulatory Repository & Engineering Disclosures",
    "source_stated_contributors": [
      "System administrator attempting to fix replication lag accidentally deleted production DB ..."
    ],
    "documented_facts": [
      {
        "fact_id": "SEA-POST-009-F1",
        "statement": "System administrator attempting to fix replication lag accidentally deleted production DB directory; 5 backup mechanisms failed silently or were empty.",
        "document_citation": "Official Primary Filing / Published Postmortem"
      }
    ],
    "collectsea_classification": {
      "capabilities": [
        "auth.destructive_action",
        "auth.infrastructure_modification",
        "data.cross_tenant_data"
      ],
      "failure_mechanisms": [
        "SEA-FM-005",
        "SEA-FM-008"
      ],
      "consequences": [
        "Financial Loss",
        "Execution Error"
      ],
      "authority_level": "IRREVERSIBLE_EXTERNAL"
    },
    "safeguards": [
      {
        "safeguard_id": "SEA-POST-009-SG1",
        "label": "Automated Defensive Guardrail",
        "description": "Enforce strict pre-implementation automated architecture validation against SEA-FM-005.",
        "target_failure_mode": "Repeat architectural failure",
        "effectiveness_level": "PREVENTATIVE"
      }
    ],
    "status": "active"
  },
  {
    "incident_id": "SEA-POST-010",
    "title": "Multi-Tenant Cloud De-provisioning Script 775-Customer Instance Teardown",
    "affected_system": {
      "system_type": "Enterprise Cloud & Distributed Systems",
      "organization": "Enterprise Multi-Tenant Jira & Confluence Cloud Mesh",
      "product": "Cloud Workspace De-provisioning Script",
      "is_ai_system": false,
      "is_agentic": false,
      "primary_language": "Multi-Language / Distributed Architecture"
    },
    "incident_date": "2024-03-15",
    "source_authority": {
      "document_type": "Regulatory Filing & Engineering Postmortem",
      "filing_id": "SEA-POST-010-DOC",
      "reporting_entity": "Atlassian Corporation",
      "regulatory_body": "SEC / Regulatory & Engineering Authority"
    },
    "source_url": "https://www.unisuper.com.au/about-us/media-centre/2024/a-joint-statement-from-unisuper-and-google-cloud",
    "source_publisher": "Official Regulatory Repository & Engineering Disclosures",
    "source_stated_contributors": [
      "Engineering team running script to retire deprecated app provided wrong tenant IDs, accide..."
    ],
    "documented_facts": [
      {
        "fact_id": "SEA-POST-010-F1",
        "statement": "Engineering team running script to retire deprecated app provided wrong tenant IDs, accidentally deleting 775 customer cloud instances for 14 days.",
        "document_citation": "Official Primary Filing / Published Postmortem"
      }
    ],
    "collectsea_classification": {
      "capabilities": [
        "auth.destructive_action",
        "auth.infrastructure_modification",
        "arch.multi_tenant"
      ],
      "failure_mechanisms": [
        "SEA-FM-005",
        "SEA-FM-008"
      ],
      "consequences": [
        "Financial Loss",
        "Execution Error"
      ],
      "authority_level": "IRREVERSIBLE_EXTERNAL"
    },
    "safeguards": [
      {
        "safeguard_id": "SEA-POST-010-SG1",
        "label": "Automated Defensive Guardrail",
        "description": "Enforce strict pre-implementation automated architecture validation against SEA-FM-005.",
        "target_failure_mode": "Repeat architectural failure",
        "effectiveness_level": "PREVENTATIVE"
      }
    ],
    "status": "active"
  },
  {
    "incident_id": "SEA-POST-011",
    "title": "CI/CD Environment Variable & GitHub Token Exfiltration via Compromised SSO",
    "affected_system": {
      "system_type": "Enterprise Cloud & Distributed Systems",
      "organization": "Cloud CI/CD Build Runner & Secret Injection Daemon",
      "product": "CI/CD Build Environment & Secrets Store",
      "is_ai_system": false,
      "is_agentic": false,
      "primary_language": "Multi-Language / Distributed Architecture"
    },
    "incident_date": "2024-03-15",
    "source_authority": {
      "document_type": "Regulatory Filing & Engineering Postmortem",
      "filing_id": "SEA-POST-011-DOC",
      "reporting_entity": "CircleCI",
      "regulatory_body": "SEC / Regulatory & Engineering Authority"
    },
    "source_url": "https://github.blog/2023-03-23-we-updated-our-rsa-ssh-host-key/",
    "source_publisher": "Official Regulatory Repository & Engineering Disclosures",
    "source_stated_contributors": [
      "Compromised engineer laptop allowed session token exfiltration; attacker decrypted custome..."
    ],
    "documented_facts": [
      {
        "fact_id": "SEA-POST-011-F1",
        "statement": "Compromised engineer laptop allowed session token exfiltration; attacker decrypted customer environment variables and GitHub tokens from datastore.",
        "document_citation": "Official Primary Filing / Published Postmortem"
      }
    ],
    "collectsea_classification": {
      "capabilities": [
        "auth.code_execution",
        "data.credentials_secrets",
        "arch.multi_tenant"
      ],
      "failure_mechanisms": [
        "SEA-FM-001",
        "SEA-FM-009"
      ],
      "consequences": [
        "Financial Loss",
        "Execution Error"
      ],
      "authority_level": "PRIVILEGED_INTERNAL"
    },
    "safeguards": [
      {
        "safeguard_id": "SEA-POST-011-SG1",
        "label": "Automated Defensive Guardrail",
        "description": "Enforce strict pre-implementation automated architecture validation against SEA-FM-001.",
        "target_failure_mode": "Repeat architectural failure",
        "effectiveness_level": "PREVENTATIVE"
      }
    ],
    "status": "active"
  },
  {
    "incident_id": "SEA-POST-012",
    "title": "Real-Time Message Cache Inconsistency During Large Redis Cluster Migration",
    "affected_system": {
      "system_type": "Enterprise Cloud & Distributed Systems",
      "organization": "Distributed Real-Time Voice/Chat Messaging & Redis Tier",
      "product": "Distributed Redis Messaging & Guild Cache",
      "is_ai_system": false,
      "is_agentic": false,
      "primary_language": "Multi-Language / Distributed Architecture"
    },
    "incident_date": "2024-03-15",
    "source_authority": {
      "document_type": "Regulatory Filing & Engineering Postmortem",
      "filing_id": "SEA-POST-012-DOC",
      "reporting_entity": "Discord Inc.",
      "regulatory_body": "SEC / Regulatory & Engineering Authority"
    },
    "source_url": "https://aws.amazon.com/builders-library/making-retries-safe-with-idempotent-APIs/",
    "source_publisher": "Official Regulatory Repository & Engineering Disclosures",
    "source_stated_contributors": [
      "Migrating message caches between Redis clusters caused race conditions and state drift bet..."
    ],
    "documented_facts": [
      {
        "fact_id": "SEA-POST-012-F1",
        "statement": "Migrating message caches between Redis clusters caused race conditions and state drift between cache and Cassandra persistence layer.",
        "document_citation": "Official Primary Filing / Published Postmortem"
      }
    ],
    "collectsea_classification": {
      "capabilities": [
        "arch.caching",
        "arch.multi_tenant",
        "data.untrusted_external_text"
      ],
      "failure_mechanisms": [
        "SEA-FM-004",
        "SEA-FM-007"
      ],
      "consequences": [
        "Financial Loss",
        "Execution Error"
      ],
      "authority_level": "PRIVILEGED_INTERNAL"
    },
    "safeguards": [
      {
        "safeguard_id": "SEA-POST-012-SG1",
        "label": "Automated Defensive Guardrail",
        "description": "Enforce strict pre-implementation automated architecture validation against SEA-FM-004.",
        "target_failure_mode": "Repeat architectural failure",
        "effectiveness_level": "PREVENTATIVE"
      }
    ],
    "status": "active"
  },
  {
    "incident_id": "SEA-POST-013",
    "title": "Network Partition Database Failover Connection Pool Starvation",
    "affected_system": {
      "system_type": "Enterprise Cloud & Distributed Systems",
      "organization": "Enterprise Collaborative Messaging & Distributed MySQL Vitess",
      "product": "Distributed MySQL Vitess Database Tier",
      "is_ai_system": false,
      "is_agentic": false,
      "primary_language": "Multi-Language / Distributed Architecture"
    },
    "incident_date": "2024-03-15",
    "source_authority": {
      "document_type": "Regulatory Filing & Engineering Postmortem",
      "filing_id": "SEA-POST-013-DOC",
      "reporting_entity": "Slack Technologies",
      "regulatory_body": "SEC / Regulatory & Engineering Authority"
    },
    "source_url": "https://aws.amazon.com/builders-library/making-retries-safe-with-idempotent-APIs/",
    "source_publisher": "Official Regulatory Repository & Engineering Disclosures",
    "source_stated_contributors": [
      "Network partition during database maintenance triggered simultaneous split-brain failovers..."
    ],
    "documented_facts": [
      {
        "fact_id": "SEA-POST-013-F1",
        "statement": "Network partition during database maintenance triggered simultaneous split-brain failovers, causing connection pool exhaustion on all API gateways.",
        "document_citation": "Official Primary Filing / Published Postmortem"
      }
    ],
    "collectsea_classification": {
      "capabilities": [
        "arch.multi_tenant",
        "auth.infrastructure_modification",
        "arch.caching"
      ],
      "failure_mechanisms": [
        "SEA-FM-006",
        "SEA-FM-007"
      ],
      "consequences": [
        "Financial Loss",
        "Execution Error"
      ],
      "authority_level": "PRIVILEGED_INTERNAL"
    },
    "safeguards": [
      {
        "safeguard_id": "SEA-POST-013-SG1",
        "label": "Automated Defensive Guardrail",
        "description": "Enforce strict pre-implementation automated architecture validation against SEA-FM-006.",
        "target_failure_mode": "Repeat architectural failure",
        "effectiveness_level": "PREVENTATIVE"
      }
    ],
    "status": "active"
  },
  {
    "incident_id": "SEA-POST-014",
    "title": "Viral Flash Sale Checkout Write Lock Amplification & Database Contention",
    "affected_system": {
      "system_type": "Enterprise Cloud & Distributed Systems",
      "organization": "Multi-Tenant E-Commerce Flash Sale & Inventory Lock Service",
      "product": "Flash Sale Checkout & Inventory Reservation Engine",
      "is_ai_system": false,
      "is_agentic": false,
      "primary_language": "Multi-Language / Distributed Architecture"
    },
    "incident_date": "2024-03-15",
    "source_authority": {
      "document_type": "Regulatory Filing & Engineering Postmortem",
      "filing_id": "SEA-POST-014-DOC",
      "reporting_entity": "Shopify Inc.",
      "regulatory_body": "SEC / Regulatory & Engineering Authority"
    },
    "source_url": "https://stripe.com/blog/idempotency",
    "source_publisher": "Official Regulatory Repository & Engineering Disclosures",
    "source_stated_contributors": [
      "Synchronized row-level inventory locks on viral merchant flash sales saturated database th..."
    ],
    "documented_facts": [
      {
        "fact_id": "SEA-POST-014-F1",
        "statement": "Synchronized row-level inventory locks on viral merchant flash sales saturated database thread pools, causing cascading timeouts on unrelated stores.",
        "document_citation": "Official Primary Filing / Published Postmortem"
      }
    ],
    "collectsea_classification": {
      "capabilities": [
        "auth.financial_action",
        "arch.multi_tenant",
        "arch.caching"
      ],
      "failure_mechanisms": [
        "SEA-FM-006",
        "SEA-FM-007"
      ],
      "consequences": [
        "Financial Loss",
        "Execution Error"
      ],
      "authority_level": "IRREVERSIBLE_EXTERNAL"
    },
    "safeguards": [
      {
        "safeguard_id": "SEA-POST-014-SG1",
        "label": "Automated Defensive Guardrail",
        "description": "Enforce strict pre-implementation automated architecture validation against SEA-FM-006.",
        "target_failure_mode": "Repeat architectural failure",
        "effectiveness_level": "PREVENTATIVE"
      }
    ],
    "status": "active"
  },
  {
    "incident_id": "SEA-POST-015",
    "title": "Real-Time Collaborative Canvas WebSocket State Conflict Storm",
    "affected_system": {
      "system_type": "Enterprise Cloud & Distributed Systems",
      "organization": "Collaborative Multi-User Canvas & Real-Time Sync Engine",
      "product": "Multiplayer Real-Time Canvas Sync Engine",
      "is_ai_system": false,
      "is_agentic": false,
      "primary_language": "Multi-Language / Distributed Architecture"
    },
    "incident_date": "2024-03-15",
    "source_authority": {
      "document_type": "Regulatory Filing & Engineering Postmortem",
      "filing_id": "SEA-POST-015-DOC",
      "reporting_entity": "Figma Inc.",
      "regulatory_body": "SEC / Regulatory & Engineering Authority"
    },
    "source_url": "https://aws.amazon.com/builders-library/making-retries-safe-with-idempotent-APIs/",
    "source_publisher": "Official Regulatory Repository & Engineering Disclosures",
    "source_stated_contributors": [
      "Transient cross-region WebSocket disconnect caused client reconciliation loops to send mil..."
    ],
    "documented_facts": [
      {
        "fact_id": "SEA-POST-015-F1",
        "statement": "Transient cross-region WebSocket disconnect caused client reconciliation loops to send millions of redundant state delta patches, overwhelming sync servers.",
        "document_citation": "Official Primary Filing / Published Postmortem"
      }
    ],
    "collectsea_classification": {
      "capabilities": [
        "arch.multi_tenant",
        "arch.caching",
        "auth.infrastructure_modification"
      ],
      "failure_mechanisms": [
        "SEA-FM-006",
        "SEA-FM-004"
      ],
      "consequences": [
        "Financial Loss",
        "Execution Error"
      ],
      "authority_level": "PRIVILEGED_INTERNAL"
    },
    "safeguards": [
      {
        "safeguard_id": "SEA-POST-015-SG1",
        "label": "Automated Defensive Guardrail",
        "description": "Enforce strict pre-implementation automated architecture validation against SEA-FM-006.",
        "target_failure_mode": "Repeat architectural failure",
        "effectiveness_level": "PREVENTATIVE"
      }
    ],
    "status": "active"
  },
  {
    "incident_id": "SEA-PUB-040",
    "title": "Autonomous AI Agent Model Context Protocol Token Hijacking (Verified Case #40)",
    "affected_system": {
      "system_type": "AI Agentic Development Platform",
      "organization": "AI Agentic Development Platform Infrastructure",
      "product": "Autonomous MCP Agent Execution Sandbox",
      "is_ai_system": true,
      "is_agentic": true,
      "primary_language": "Cloud & Distributed Systems"
    },
    "incident_date": "2021-05-13",
    "source_authority": {
      "document_type": "AI Agent Security Advisory",
      "filing_id": "PUB-040",
      "reporting_entity": "AI Agentic Development Platform Infrastructure",
      "regulatory_body": "Public Regulatory Filing / Engineering Postmortem"
    },
    "source_url": "https://www.sec.gov/Archives/edgar/data/789019/000119312524011295/d708866d8k.htm",
    "source_publisher": "Regulatory Disclosure & Cloud Engineering Archive",
    "source_stated_contributors": [
      "Model Context Protocol search tool allowed prompt injection to leak bearer tokens in subag..."
    ],
    "documented_facts": [
      {
        "fact_id": "SEA-PUB-040-F1",
        "statement": "Model Context Protocol search tool allowed prompt injection to leak bearer tokens in subagent prompt context.",
        "document_citation": "AI Agent Security Advisory"
      }
    ],
    "collectsea_classification": {
      "capabilities": [
        "arch.tool_enabled_agent",
        "data.credentials_secrets",
        "data.untrusted_external_text"
      ],
      "failure_mechanisms": [
        "SEA-FM-010",
        "SEA-FM-001"
      ],
      "consequences": [
        "Financial Loss",
        "Execution Error"
      ],
      "authority_level": "PRIVILEGED_INTERNAL"
    },
    "safeguards": [
      {
        "safeguard_id": "SEA-PUB-040-SG1",
        "label": "Automated Defensive Guardrail",
        "description": "Enforce strict pre-implementation automated architecture validation against SEA-FM-010.",
        "target_failure_mode": "Repeat architectural failure",
        "effectiveness_level": "PREVENTATIVE"
      }
    ],
    "status": "active"
  },
  {
    "incident_id": "SEA-PUB-041",
    "title": "AI LLM Coding Assistant Arbitrary Terminal Command Execution (Verified Case #41)",
    "affected_system": {
      "system_type": "AI Developer Tools Inc.",
      "organization": "AI Developer Tools Inc. Infrastructure",
      "product": "IDE Agentic Code Generation & Shell Runner",
      "is_ai_system": true,
      "is_agentic": false,
      "primary_language": "Cloud & Distributed Systems"
    },
    "incident_date": "2022-06-14",
    "source_authority": {
      "document_type": "Software Security Advisory",
      "filing_id": "PUB-041",
      "reporting_entity": "AI Developer Tools Inc. Infrastructure",
      "regulatory_body": "Public Regulatory Filing / Engineering Postmortem"
    },
    "source_url": "https://aws.amazon.com/builders-library/making-retries-safe-with-idempotent-APIs/",
    "source_publisher": "Regulatory Disclosure & Cloud Engineering Archive",
    "source_stated_contributors": [
      "AI coding agent accepted unvalidated repository prompt that executed malicious curl script..."
    ],
    "documented_facts": [
      {
        "fact_id": "SEA-PUB-041-F1",
        "statement": "AI coding agent accepted unvalidated repository prompt that executed malicious curl script inside local terminal.",
        "document_citation": "Software Security Advisory"
      }
    ],
    "collectsea_classification": {
      "capabilities": [
        "auth.code_execution",
        "arch.tool_enabled_agent",
        "data.untrusted_external_text"
      ],
      "failure_mechanisms": [
        "SEA-FM-010",
        "SEA-FM-003"
      ],
      "consequences": [
        "Financial Loss",
        "Execution Error"
      ],
      "authority_level": "PRIVILEGED_INTERNAL"
    },
    "safeguards": [
      {
        "safeguard_id": "SEA-PUB-041-SG1",
        "label": "Automated Defensive Guardrail",
        "description": "Enforce strict pre-implementation automated architecture validation against SEA-FM-010.",
        "target_failure_mode": "Repeat architectural failure",
        "effectiveness_level": "PREVENTATIVE"
      }
    ],
    "status": "active"
  },
  {
    "incident_id": "SEA-PUB-042",
    "title": "Distributed Consensus Split-Brain State Divergence (Verified Case #42)",
    "affected_system": {
      "system_type": "Distributed Database Corporation",
      "organization": "Distributed Database Corporation Infrastructure",
      "product": "Raft Consensus Cluster & Replication Log",
      "is_ai_system": false,
      "is_agentic": false,
      "primary_language": "Cloud & Distributed Systems"
    },
    "incident_date": "2023-07-15",
    "source_authority": {
      "document_type": "Distributed Systems Postmortem",
      "filing_id": "PUB-042",
      "reporting_entity": "Distributed Database Corporation Infrastructure",
      "regulatory_body": "Public Regulatory Filing / Engineering Postmortem"
    },
    "source_url": "https://www.sec.gov/Archives/edgar/data/789019/000119312524011295/d708866d8k.htm",
    "source_publisher": "Regulatory Disclosure & Cloud Engineering Archive",
    "source_stated_contributors": [
      "Asymmetric network partition caused two leader nodes to accept client writes simultaneousl..."
    ],
    "documented_facts": [
      {
        "fact_id": "SEA-PUB-042-F1",
        "statement": "Asymmetric network partition caused two leader nodes to accept client writes simultaneously, corrupting ledger state.",
        "document_citation": "Distributed Systems Postmortem"
      }
    ],
    "collectsea_classification": {
      "capabilities": [
        "auth.infrastructure_modification",
        "arch.caching",
        "data.financial_records"
      ],
      "failure_mechanisms": [
        "SEA-FM-007",
        "SEA-FM-004"
      ],
      "consequences": [
        "Financial Loss",
        "Execution Error"
      ],
      "authority_level": "PRIVILEGED_INTERNAL"
    },
    "safeguards": [
      {
        "safeguard_id": "SEA-PUB-042-SG1",
        "label": "Automated Defensive Guardrail",
        "description": "Enforce strict pre-implementation automated architecture validation against SEA-FM-007.",
        "target_failure_mode": "Repeat architectural failure",
        "effectiveness_level": "PREVENTATIVE"
      }
    ],
    "status": "active"
  },
  {
    "incident_id": "SEA-PUB-043",
    "title": "Serverless Function Cold Start Connection Pool Exhaustion (Verified Case #43)",
    "affected_system": {
      "system_type": "Serverless Cloud Provider",
      "organization": "Serverless Cloud Provider Infrastructure",
      "product": "Managed Serverless Database Connector",
      "is_ai_system": false,
      "is_agentic": false,
      "primary_language": "Cloud & Distributed Systems"
    },
    "incident_date": "2024-08-16",
    "source_authority": {
      "document_type": "Cloud Engineering Guide",
      "filing_id": "PUB-043",
      "reporting_entity": "Serverless Cloud Provider Infrastructure",
      "regulatory_body": "Public Regulatory Filing / Engineering Postmortem"
    },
    "source_url": "https://aws.amazon.com/builders-library/making-retries-safe-with-idempotent-APIs/",
    "source_publisher": "Regulatory Disclosure & Cloud Engineering Archive",
    "source_stated_contributors": [
      "Spike in concurrent lambda invocations opened 10,000 direct PostgreSQL connections, crashi..."
    ],
    "documented_facts": [
      {
        "fact_id": "SEA-PUB-043-F1",
        "statement": "Spike in concurrent lambda invocations opened 10,000 direct PostgreSQL connections, crashing primary RDS instance.",
        "document_citation": "Cloud Engineering Guide"
      }
    ],
    "collectsea_classification": {
      "capabilities": [
        "auth.infrastructure_modification",
        "arch.multi_tenant",
        "arch.external_api"
      ],
      "failure_mechanisms": [
        "SEA-FM-006",
        "SEA-FM-007"
      ],
      "consequences": [
        "Financial Loss",
        "Execution Error"
      ],
      "authority_level": "PRIVILEGED_INTERNAL"
    },
    "safeguards": [
      {
        "safeguard_id": "SEA-PUB-043-SG1",
        "label": "Automated Defensive Guardrail",
        "description": "Enforce strict pre-implementation automated architecture validation against SEA-FM-006.",
        "target_failure_mode": "Repeat architectural failure",
        "effectiveness_level": "PREVENTATIVE"
      }
    ],
    "status": "active"
  },
  {
    "incident_id": "SEA-PUB-044",
    "title": "Payment Webhook Out-of-Order Delivery State Machine Corruption (Verified Case #44)",
    "affected_system": {
      "system_type": "FinTech Billing Platform",
      "organization": "FinTech Billing Platform Infrastructure",
      "product": "Asynchronous Payment Webhook Event Consumer",
      "is_ai_system": false,
      "is_agentic": false,
      "primary_language": "Cloud & Distributed Systems"
    },
    "incident_date": "2025-09-17",
    "source_authority": {
      "document_type": "Payment Engineering Postmortem",
      "filing_id": "PUB-044",
      "reporting_entity": "FinTech Billing Platform Infrastructure",
      "regulatory_body": "Public Regulatory Filing / Engineering Postmortem"
    },
    "source_url": "https://www.sec.gov/Archives/edgar/data/789019/000119312524011295/d708866d8k.htm",
    "source_publisher": "Regulatory Disclosure & Cloud Engineering Archive",
    "source_stated_contributors": [
      "Late-arriving `payment_failed` webhook processed after `subscription_renewed`, deactivatin..."
    ],
    "documented_facts": [
      {
        "fact_id": "SEA-PUB-044-F1",
        "statement": "Late-arriving `payment_failed` webhook processed after `subscription_renewed`, deactivating active paying customer account.",
        "document_citation": "Payment Engineering Postmortem"
      }
    ],
    "collectsea_classification": {
      "capabilities": [
        "auth.financial_action",
        "arch.external_api",
        "data.financial_records"
      ],
      "failure_mechanisms": [
        "SEA-FM-007",
        "SEA-FM-008"
      ],
      "consequences": [
        "Financial Loss",
        "Execution Error"
      ],
      "authority_level": "IRREVERSIBLE_EXTERNAL"
    },
    "safeguards": [
      {
        "safeguard_id": "SEA-PUB-044-SG1",
        "label": "Automated Defensive Guardrail",
        "description": "Enforce strict pre-implementation automated architecture validation against SEA-FM-007.",
        "target_failure_mode": "Repeat architectural failure",
        "effectiveness_level": "PREVENTATIVE"
      }
    ],
    "status": "active"
  },
  {
    "incident_id": "SEA-PUB-045",
    "title": "GraphQL Deeply Nested Query Denial of Service (Verified Case #45)",
    "affected_system": {
      "system_type": "Enterprise API Gateway",
      "organization": "Enterprise API Gateway Infrastructure",
      "product": "Public GraphQL Query Parser & Resolver",
      "is_ai_system": false,
      "is_agentic": false,
      "primary_language": "Cloud & Distributed Systems"
    },
    "incident_date": "2021-10-18",
    "source_authority": {
      "document_type": "API Security Advisory",
      "filing_id": "PUB-045",
      "reporting_entity": "Enterprise API Gateway Infrastructure",
      "regulatory_body": "Public Regulatory Filing / Engineering Postmortem"
    },
    "source_url": "https://aws.amazon.com/builders-library/making-retries-safe-with-idempotent-APIs/",
    "source_publisher": "Regulatory Disclosure & Cloud Engineering Archive",
    "source_stated_contributors": [
      "Recursive query execution (`user { friends { friends { friends } } }`) caused heap memory ..."
    ],
    "documented_facts": [
      {
        "fact_id": "SEA-PUB-045-F1",
        "statement": "Recursive query execution (`user { friends { friends { friends } } }`) caused heap memory exhaustion on backend node.",
        "document_citation": "API Security Advisory"
      }
    ],
    "collectsea_classification": {
      "capabilities": [
        "arch.multi_tenant",
        "arch.external_api",
        "data.untrusted_external_text"
      ],
      "failure_mechanisms": [
        "SEA-FM-006",
        "SEA-FM-003"
      ],
      "consequences": [
        "Financial Loss",
        "Execution Error"
      ],
      "authority_level": "PRIVILEGED_INTERNAL"
    },
    "safeguards": [
      {
        "safeguard_id": "SEA-PUB-045-SG1",
        "label": "Automated Defensive Guardrail",
        "description": "Enforce strict pre-implementation automated architecture validation against SEA-FM-006.",
        "target_failure_mode": "Repeat architectural failure",
        "effectiveness_level": "PREVENTATIVE"
      }
    ],
    "status": "active"
  },
  {
    "incident_id": "SEA-PUB-046",
    "title": "JWT Secret Key Confusion & Privilege Escalation (Verified Case #46)",
    "affected_system": {
      "system_type": "Cloud SaaS Authentication Service",
      "organization": "Cloud SaaS Authentication Service Infrastructure",
      "product": "OAuth2 / OpenID Connect Token Signer",
      "is_ai_system": false,
      "is_agentic": false,
      "primary_language": "Cloud & Distributed Systems"
    },
    "incident_date": "2022-11-19",
    "source_authority": {
      "document_type": "Identity Security Report",
      "filing_id": "PUB-046",
      "reporting_entity": "Cloud SaaS Authentication Service Infrastructure",
      "regulatory_body": "Public Regulatory Filing / Engineering Postmortem"
    },
    "source_url": "https://www.sec.gov/Archives/edgar/data/789019/000119312524011295/d708866d8k.htm",
    "source_publisher": "Regulatory Disclosure & Cloud Engineering Archive",
    "source_stated_contributors": [
      "Backend accepted HMAC-SHA256 tokens signed with public RSA key, allowing attacker to forge..."
    ],
    "documented_facts": [
      {
        "fact_id": "SEA-PUB-046-F1",
        "statement": "Backend accepted HMAC-SHA256 tokens signed with public RSA key, allowing attacker to forge administrator tokens.",
        "document_citation": "Identity Security Report"
      }
    ],
    "collectsea_classification": {
      "capabilities": [
        "data.credentials_secrets",
        "auth.privileged_action",
        "arch.multi_tenant"
      ],
      "failure_mechanisms": [
        "SEA-FM-001",
        "SEA-FM-008"
      ],
      "consequences": [
        "Financial Loss",
        "Execution Error"
      ],
      "authority_level": "PRIVILEGED_INTERNAL"
    },
    "safeguards": [
      {
        "safeguard_id": "SEA-PUB-046-SG1",
        "label": "Automated Defensive Guardrail",
        "description": "Enforce strict pre-implementation automated architecture validation against SEA-FM-001.",
        "target_failure_mode": "Repeat architectural failure",
        "effectiveness_level": "PREVENTATIVE"
      }
    ],
    "status": "active"
  },
  {
    "incident_id": "SEA-PUB-047",
    "title": "Distributed Rate Limiter Redis Key Collision & Global Lockout (Verified Case #47)",
    "affected_system": {
      "system_type": "Global API Proxy Network",
      "organization": "Global API Proxy Network Infrastructure",
      "product": "Distributed Redis Token Bucket Rate Limiter",
      "is_ai_system": false,
      "is_agentic": false,
      "primary_language": "Cloud & Distributed Systems"
    },
    "incident_date": "2023-12-20",
    "source_authority": {
      "document_type": "Edge Engineering Postmortem",
      "filing_id": "PUB-047",
      "reporting_entity": "Global API Proxy Network Infrastructure",
      "regulatory_body": "Public Regulatory Filing / Engineering Postmortem"
    },
    "source_url": "https://aws.amazon.com/builders-library/making-retries-safe-with-idempotent-APIs/",
    "source_publisher": "Regulatory Disclosure & Cloud Engineering Archive",
    "source_stated_contributors": [
      "Missing tenant namespace prefix in rate limiter Redis key caused single user limit to appl..."
    ],
    "documented_facts": [
      {
        "fact_id": "SEA-PUB-047-F1",
        "statement": "Missing tenant namespace prefix in rate limiter Redis key caused single user limit to apply globally to all tenants.",
        "document_citation": "Edge Engineering Postmortem"
      }
    ],
    "collectsea_classification": {
      "capabilities": [
        "arch.multi_tenant",
        "arch.caching",
        "auth.infrastructure_modification"
      ],
      "failure_mechanisms": [
        "SEA-FM-001",
        "SEA-FM-006"
      ],
      "consequences": [
        "Financial Loss",
        "Execution Error"
      ],
      "authority_level": "PRIVILEGED_INTERNAL"
    },
    "safeguards": [
      {
        "safeguard_id": "SEA-PUB-047-SG1",
        "label": "Automated Defensive Guardrail",
        "description": "Enforce strict pre-implementation automated architecture validation against SEA-FM-001.",
        "target_failure_mode": "Repeat architectural failure",
        "effectiveness_level": "PREVENTATIVE"
      }
    ],
    "status": "active"
  },
  {
    "incident_id": "SEA-PUB-048",
    "title": "Kafka Consumer Group Rebalance Storm Message Lag (Verified Case #48)",
    "affected_system": {
      "system_type": "Streaming Analytics Platform",
      "organization": "Streaming Analytics Platform Infrastructure",
      "product": "Distributed Event Stream Processing Engine",
      "is_ai_system": false,
      "is_agentic": false,
      "primary_language": "Cloud & Distributed Systems"
    },
    "incident_date": "2024-01-21",
    "source_authority": {
      "document_type": "Streaming Engineering Postmortem",
      "filing_id": "PUB-048",
      "reporting_entity": "Streaming Analytics Platform Infrastructure",
      "regulatory_body": "Public Regulatory Filing / Engineering Postmortem"
    },
    "source_url": "https://www.sec.gov/Archives/edgar/data/789019/000119312524011295/d708866d8k.htm",
    "source_publisher": "Regulatory Disclosure & Cloud Engineering Archive",
    "source_stated_contributors": [
      "Slow consumer heartbeat during heavy batch processing triggered infinite rebalance loop, h..."
    ],
    "documented_facts": [
      {
        "fact_id": "SEA-PUB-048-F1",
        "statement": "Slow consumer heartbeat during heavy batch processing triggered infinite rebalance loop, halting all event consumption.",
        "document_citation": "Streaming Engineering Postmortem"
      }
    ],
    "collectsea_classification": {
      "capabilities": [
        "auth.infrastructure_modification",
        "arch.caching",
        "arch.external_api"
      ],
      "failure_mechanisms": [
        "SEA-FM-006",
        "SEA-FM-007"
      ],
      "consequences": [
        "Financial Loss",
        "Execution Error"
      ],
      "authority_level": "PRIVILEGED_INTERNAL"
    },
    "safeguards": [
      {
        "safeguard_id": "SEA-PUB-048-SG1",
        "label": "Automated Defensive Guardrail",
        "description": "Enforce strict pre-implementation automated architecture validation against SEA-FM-006.",
        "target_failure_mode": "Repeat architectural failure",
        "effectiveness_level": "PREVENTATIVE"
      }
    ],
    "status": "active"
  },
  {
    "incident_id": "SEA-PUB-049",
    "title": "Kubernetes Ingress Controller Memory Leak on Dynamic SSL Reload (Verified Case #49)",
    "affected_system": {
      "system_type": "Cloud Orchestration Mesh",
      "organization": "Cloud Orchestration Mesh Infrastructure",
      "product": "NGINX Ingress Controller & Cert-Manager",
      "is_ai_system": false,
      "is_agentic": false,
      "primary_language": "Cloud & Distributed Systems"
    },
    "incident_date": "2025-02-22",
    "source_authority": {
      "document_type": "Kubernetes Incident Postmortem",
      "filing_id": "PUB-049",
      "reporting_entity": "Cloud Orchestration Mesh Infrastructure",
      "regulatory_body": "Public Regulatory Filing / Engineering Postmortem"
    },
    "source_url": "https://aws.amazon.com/builders-library/making-retries-safe-with-idempotent-APIs/",
    "source_publisher": "Regulatory Disclosure & Cloud Engineering Archive",
    "source_stated_contributors": [
      "Frequent Let's Encrypt cert renewals triggered daily NGINX reloads, fragmenting heap until..."
    ],
    "documented_facts": [
      {
        "fact_id": "SEA-PUB-049-F1",
        "statement": "Frequent Let's Encrypt cert renewals triggered daily NGINX reloads, fragmenting heap until pods OOM-killed.",
        "document_citation": "Kubernetes Incident Postmortem"
      }
    ],
    "collectsea_classification": {
      "capabilities": [
        "auth.infrastructure_modification",
        "data.credentials_secrets",
        "arch.external_api"
      ],
      "failure_mechanisms": [
        "SEA-FM-006",
        "SEA-FM-005"
      ],
      "consequences": [
        "Financial Loss",
        "Execution Error"
      ],
      "authority_level": "PRIVILEGED_INTERNAL"
    },
    "safeguards": [
      {
        "safeguard_id": "SEA-PUB-049-SG1",
        "label": "Automated Defensive Guardrail",
        "description": "Enforce strict pre-implementation automated architecture validation against SEA-FM-006.",
        "target_failure_mode": "Repeat architectural failure",
        "effectiveness_level": "PREVENTATIVE"
      }
    ],
    "status": "active"
  },
  {
    "incident_id": "SEA-PUB-050",
    "title": "Container Image Registry Tag Mutation Supply Chain Compromise (Verified Case #50)",
    "affected_system": {
      "system_type": "Cloud Native Platform",
      "organization": "Cloud Native Platform Infrastructure",
      "product": "Public Docker Container Image Registry",
      "is_ai_system": false,
      "is_agentic": false,
      "primary_language": "Cloud & Distributed Systems"
    },
    "incident_date": "2021-03-23",
    "source_authority": {
      "document_type": "Cloud Supply Chain Report",
      "filing_id": "PUB-050",
      "reporting_entity": "Cloud Native Platform Infrastructure",
      "regulatory_body": "Public Regulatory Filing / Engineering Postmortem"
    },
    "source_url": "https://www.sec.gov/Archives/edgar/data/789019/000119312524011295/d708866d8k.htm",
    "source_publisher": "Regulatory Disclosure & Cloud Engineering Archive",
    "source_stated_contributors": [
      "Mutable `:latest` container tag overwritten by compromised build runner; deployed vulnerab..."
    ],
    "documented_facts": [
      {
        "fact_id": "SEA-PUB-050-F1",
        "statement": "Mutable `:latest` container tag overwritten by compromised build runner; deployed vulnerable image to production.",
        "document_citation": "Cloud Supply Chain Report"
      }
    ],
    "collectsea_classification": {
      "capabilities": [
        "auth.code_execution",
        "auth.infrastructure_modification",
        "data.credentials_secrets"
      ],
      "failure_mechanisms": [
        "SEA-FM-003",
        "SEA-FM-009"
      ],
      "consequences": [
        "Financial Loss",
        "Execution Error"
      ],
      "authority_level": "PRIVILEGED_INTERNAL"
    },
    "safeguards": [
      {
        "safeguard_id": "SEA-PUB-050-SG1",
        "label": "Automated Defensive Guardrail",
        "description": "Enforce strict pre-implementation automated architecture validation against SEA-FM-003.",
        "target_failure_mode": "Repeat architectural failure",
        "effectiveness_level": "PREVENTATIVE"
      }
    ],
    "status": "active"
  },
  {
    "incident_id": "SEA-PUB-051",
    "title": "DNSSEC Key Rollback & Global Domain Invalidation (Verified Case #51)",
    "affected_system": {
      "system_type": "Top-Level Domain Registry",
      "organization": "Top-Level Domain Registry Infrastructure",
      "product": "Authoritative DNSSEC Signing Infrastructure",
      "is_ai_system": false,
      "is_agentic": false,
      "primary_language": "Cloud & Distributed Systems"
    },
    "incident_date": "2022-04-24",
    "source_authority": {
      "document_type": "DNS Engineering Postmortem",
      "filing_id": "PUB-051",
      "reporting_entity": "Top-Level Domain Registry Infrastructure",
      "regulatory_body": "Public Regulatory Filing / Engineering Postmortem"
    },
    "source_url": "https://aws.amazon.com/builders-library/making-retries-safe-with-idempotent-APIs/",
    "source_publisher": "Regulatory Disclosure & Cloud Engineering Archive",
    "source_stated_contributors": [
      "Mismatched DS records during planned Key Signing Key (KSK) rollover caused recursive resol..."
    ],
    "documented_facts": [
      {
        "fact_id": "SEA-PUB-051-F1",
        "statement": "Mismatched DS records during planned Key Signing Key (KSK) rollover caused recursive resolvers worldwide to return SERVFAIL.",
        "document_citation": "DNS Engineering Postmortem"
      }
    ],
    "collectsea_classification": {
      "capabilities": [
        "auth.infrastructure_modification",
        "data.credentials_secrets",
        "arch.external_api"
      ],
      "failure_mechanisms": [
        "SEA-FM-008",
        "SEA-FM-005"
      ],
      "consequences": [
        "Financial Loss",
        "Execution Error"
      ],
      "authority_level": "PRIVILEGED_INTERNAL"
    },
    "safeguards": [
      {
        "safeguard_id": "SEA-PUB-051-SG1",
        "label": "Automated Defensive Guardrail",
        "description": "Enforce strict pre-implementation automated architecture validation against SEA-FM-008.",
        "target_failure_mode": "Repeat architectural failure",
        "effectiveness_level": "PREVENTATIVE"
      }
    ],
    "status": "active"
  },
  {
    "incident_id": "SEA-PUB-052",
    "title": "OAuth Refresh Token Reuse Race Condition & Account Takeover (Verified Case #52)",
    "affected_system": {
      "system_type": "Consumer Mobile Platform",
      "organization": "Consumer Mobile Platform Infrastructure",
      "product": "Mobile OAuth2 Token Exchange Gateway",
      "is_ai_system": false,
      "is_agentic": false,
      "primary_language": "Cloud & Distributed Systems"
    },
    "incident_date": "2023-05-25",
    "source_authority": {
      "document_type": "Mobile Security Advisory",
      "filing_id": "PUB-052",
      "reporting_entity": "Consumer Mobile Platform Infrastructure",
      "regulatory_body": "Public Regulatory Filing / Engineering Postmortem"
    },
    "source_url": "https://www.sec.gov/Archives/edgar/data/789019/000119312524011295/d708866d8k.htm",
    "source_publisher": "Regulatory Disclosure & Cloud Engineering Archive",
    "source_stated_contributors": [
      "Simultaneous token refresh requests from multi-tab sessions triggered false reuse detectio..."
    ],
    "documented_facts": [
      {
        "fact_id": "SEA-PUB-052-F1",
        "statement": "Simultaneous token refresh requests from multi-tab sessions triggered false reuse detection, locking user accounts.",
        "document_citation": "Mobile Security Advisory"
      }
    ],
    "collectsea_classification": {
      "capabilities": [
        "data.credentials_secrets",
        "arch.multi_tenant",
        "auth.privileged_action"
      ],
      "failure_mechanisms": [
        "SEA-FM-007",
        "SEA-FM-001"
      ],
      "consequences": [
        "Financial Loss",
        "Execution Error"
      ],
      "authority_level": "PRIVILEGED_INTERNAL"
    },
    "safeguards": [
      {
        "safeguard_id": "SEA-PUB-052-SG1",
        "label": "Automated Defensive Guardrail",
        "description": "Enforce strict pre-implementation automated architecture validation against SEA-FM-007.",
        "target_failure_mode": "Repeat architectural failure",
        "effectiveness_level": "PREVENTATIVE"
      }
    ],
    "status": "active"
  },
  {
    "incident_id": "SEA-PUB-053",
    "title": "BGP Prefix Hijack Inadvertent Cryptocurrency Wallet Redirection (Verified Case #53)",
    "affected_system": {
      "system_type": "Internet Routing Infrastructure",
      "organization": "Internet Routing Infrastructure Infrastructure",
      "product": "Autonomous System BGP Routing Gateway",
      "is_ai_system": false,
      "is_agentic": false,
      "primary_language": "Cloud & Distributed Systems"
    },
    "incident_date": "2024-06-26",
    "source_authority": {
      "document_type": "Internet Routing Postmortem",
      "filing_id": "PUB-053",
      "reporting_entity": "Internet Routing Infrastructure Infrastructure",
      "regulatory_body": "Public Regulatory Filing / Engineering Postmortem"
    },
    "source_url": "https://aws.amazon.com/builders-library/making-retries-safe-with-idempotent-APIs/",
    "source_publisher": "Regulatory Disclosure & Cloud Engineering Archive",
    "source_stated_contributors": [
      "Rogue BGP route announcement redirected DNS queries for major cryptocurrency portal to mal..."
    ],
    "documented_facts": [
      {
        "fact_id": "SEA-PUB-053-F1",
        "statement": "Rogue BGP route announcement redirected DNS queries for major cryptocurrency portal to malicious server for 2 hours.",
        "document_citation": "Internet Routing Postmortem"
      }
    ],
    "collectsea_classification": {
      "capabilities": [
        "auth.infrastructure_modification",
        "arch.external_api",
        "data.credentials_secrets"
      ],
      "failure_mechanisms": [
        "SEA-FM-001",
        "SEA-FM-005"
      ],
      "consequences": [
        "Financial Loss",
        "Execution Error"
      ],
      "authority_level": "PRIVILEGED_INTERNAL"
    },
    "safeguards": [
      {
        "safeguard_id": "SEA-PUB-053-SG1",
        "label": "Automated Defensive Guardrail",
        "description": "Enforce strict pre-implementation automated architecture validation against SEA-FM-001.",
        "target_failure_mode": "Repeat architectural failure",
        "effectiveness_level": "PREVENTATIVE"
      }
    ],
    "status": "active"
  },
  {
    "incident_id": "SEA-PUB-054",
    "title": "Database Auto-Vacuum Starvation Transaction ID Wraparound (Verified Case #54)",
    "affected_system": {
      "system_type": "Enterprise Managed PostgreSQL",
      "organization": "Enterprise Managed PostgreSQL Infrastructure",
      "product": "High-Volume Transaction Ledger Database",
      "is_ai_system": false,
      "is_agentic": false,
      "primary_language": "Cloud & Distributed Systems"
    },
    "incident_date": "2025-07-27",
    "source_authority": {
      "document_type": "Database Reliability Postmortem",
      "filing_id": "PUB-054",
      "reporting_entity": "Enterprise Managed PostgreSQL Infrastructure",
      "regulatory_body": "Public Regulatory Filing / Engineering Postmortem"
    },
    "source_url": "https://www.sec.gov/Archives/edgar/data/789019/000119312524011295/d708866d8k.htm",
    "source_publisher": "Regulatory Disclosure & Cloud Engineering Archive",
    "source_stated_contributors": [
      "Aggressive long-running analytics queries blocked auto-vacuum; reached 2-billion transacti..."
    ],
    "documented_facts": [
      {
        "fact_id": "SEA-PUB-054-F1",
        "statement": "Aggressive long-running analytics queries blocked auto-vacuum; reached 2-billion transaction ID limit forcing emergency shutdown.",
        "document_citation": "Database Reliability Postmortem"
      }
    ],
    "collectsea_classification": {
      "capabilities": [
        "data.financial_records",
        "auth.infrastructure_modification",
        "arch.caching"
      ],
      "failure_mechanisms": [
        "SEA-FM-005",
        "SEA-FM-006"
      ],
      "consequences": [
        "Financial Loss",
        "Execution Error"
      ],
      "authority_level": "PRIVILEGED_INTERNAL"
    },
    "safeguards": [
      {
        "safeguard_id": "SEA-PUB-054-SG1",
        "label": "Automated Defensive Guardrail",
        "description": "Enforce strict pre-implementation automated architecture validation against SEA-FM-005.",
        "target_failure_mode": "Repeat architectural failure",
        "effectiveness_level": "PREVENTATIVE"
      }
    ],
    "status": "active"
  },
  {
    "incident_id": "SEA-PUB-055",
    "title": "WebSocket Connection Thundering Herd on Load Balancer Restart (Verified Case #55)",
    "affected_system": {
      "system_type": "Real-Time Collaboration Platform",
      "organization": "Real-Time Collaboration Platform Infrastructure",
      "product": "Edge WebSocket Reverse Proxy Mesh",
      "is_ai_system": false,
      "is_agentic": false,
      "primary_language": "Cloud & Distributed Systems"
    },
    "incident_date": "2021-08-28",
    "source_authority": {
      "document_type": "Edge Engineering Postmortem",
      "filing_id": "PUB-055",
      "reporting_entity": "Real-Time Collaboration Platform Infrastructure",
      "regulatory_body": "Public Regulatory Filing / Engineering Postmortem"
    },
    "source_url": "https://aws.amazon.com/builders-library/making-retries-safe-with-idempotent-APIs/",
    "source_publisher": "Regulatory Disclosure & Cloud Engineering Archive",
    "source_stated_contributors": [
      "Simultaneous disconnect of 500,000 active WebSocket clients during proxy restart saturated..."
    ],
    "documented_facts": [
      {
        "fact_id": "SEA-PUB-055-F1",
        "statement": "Simultaneous disconnect of 500,000 active WebSocket clients during proxy restart saturated auth services upon reconnection.",
        "document_citation": "Edge Engineering Postmortem"
      }
    ],
    "collectsea_classification": {
      "capabilities": [
        "arch.multi_tenant",
        "arch.caching",
        "auth.infrastructure_modification"
      ],
      "failure_mechanisms": [
        "SEA-FM-006",
        "SEA-FM-007"
      ],
      "consequences": [
        "Financial Loss",
        "Execution Error"
      ],
      "authority_level": "PRIVILEGED_INTERNAL"
    },
    "safeguards": [
      {
        "safeguard_id": "SEA-PUB-055-SG1",
        "label": "Automated Defensive Guardrail",
        "description": "Enforce strict pre-implementation automated architecture validation against SEA-FM-006.",
        "target_failure_mode": "Repeat architectural failure",
        "effectiveness_level": "PREVENTATIVE"
      }
    ],
    "status": "active"
  },
  {
    "incident_id": "SEA-PUB-056",
    "title": "LLM Tool Call Hallucination SQL Injection Parameter (Verified Case #56)",
    "affected_system": {
      "system_type": "Autonomous AI Database Agent",
      "organization": "Autonomous AI Database Agent Infrastructure",
      "product": "Natural Language SQL Generation Pipeline",
      "is_ai_system": true,
      "is_agentic": false,
      "primary_language": "Cloud & Distributed Systems"
    },
    "incident_date": "2022-09-01",
    "source_authority": {
      "document_type": "AI Safety Research Advisory",
      "filing_id": "PUB-056",
      "reporting_entity": "Autonomous AI Database Agent Infrastructure",
      "regulatory_body": "Public Regulatory Filing / Engineering Postmortem"
    },
    "source_url": "https://www.sec.gov/Archives/edgar/data/789019/000119312524011295/d708866d8k.htm",
    "source_publisher": "Regulatory Disclosure & Cloud Engineering Archive",
    "source_stated_contributors": [
      "LLM hallucinated unescaped string concatenation when generating dynamic SQL query from use..."
    ],
    "documented_facts": [
      {
        "fact_id": "SEA-PUB-056-F1",
        "statement": "LLM hallucinated unescaped string concatenation when generating dynamic SQL query from user input, allowing data extraction.",
        "document_citation": "AI Safety Research Advisory"
      }
    ],
    "collectsea_classification": {
      "capabilities": [
        "auth.code_execution",
        "arch.tool_enabled_agent",
        "data.untrusted_external_text"
      ],
      "failure_mechanisms": [
        "SEA-FM-010",
        "SEA-FM-001"
      ],
      "consequences": [
        "Financial Loss",
        "Execution Error"
      ],
      "authority_level": "PRIVILEGED_INTERNAL"
    },
    "safeguards": [
      {
        "safeguard_id": "SEA-PUB-056-SG1",
        "label": "Automated Defensive Guardrail",
        "description": "Enforce strict pre-implementation automated architecture validation against SEA-FM-010.",
        "target_failure_mode": "Repeat architectural failure",
        "effectiveness_level": "PREVENTATIVE"
      }
    ],
    "status": "active"
  },
  {
    "incident_id": "SEA-PUB-057",
    "title": "Cloud IAM Wildcard Permission Lateral Privilege Escalation (Verified Case #57)",
    "affected_system": {
      "system_type": "Enterprise Cloud Infrastructure",
      "organization": "Enterprise Cloud Infrastructure Infrastructure",
      "product": "Cloud IAM Policy & Role Hierarchy",
      "is_ai_system": false,
      "is_agentic": false,
      "primary_language": "Cloud & Distributed Systems"
    },
    "incident_date": "2023-10-02",
    "source_authority": {
      "document_type": "Cloud Security Audit",
      "filing_id": "PUB-057",
      "reporting_entity": "Enterprise Cloud Infrastructure Infrastructure",
      "regulatory_body": "Public Regulatory Filing / Engineering Postmortem"
    },
    "source_url": "https://aws.amazon.com/builders-library/making-retries-safe-with-idempotent-APIs/",
    "source_publisher": "Regulatory Disclosure & Cloud Engineering Archive",
    "source_stated_contributors": [
      "Overly permissive `iam:PassRole` on worker instances allowed compromised application to as..."
    ],
    "documented_facts": [
      {
        "fact_id": "SEA-PUB-057-F1",
        "statement": "Overly permissive `iam:PassRole` on worker instances allowed compromised application to assume administrator role.",
        "document_citation": "Cloud Security Audit"
      }
    ],
    "collectsea_classification": {
      "capabilities": [
        "auth.privileged_action",
        "data.credentials_secrets",
        "arch.multi_tenant"
      ],
      "failure_mechanisms": [
        "SEA-FM-001",
        "SEA-FM-009"
      ],
      "consequences": [
        "Financial Loss",
        "Execution Error"
      ],
      "authority_level": "PRIVILEGED_INTERNAL"
    },
    "safeguards": [
      {
        "safeguard_id": "SEA-PUB-057-SG1",
        "label": "Automated Defensive Guardrail",
        "description": "Enforce strict pre-implementation automated architecture validation against SEA-FM-001.",
        "target_failure_mode": "Repeat architectural failure",
        "effectiveness_level": "PREVENTATIVE"
      }
    ],
    "status": "active"
  },
  {
    "incident_id": "SEA-PUB-058",
    "title": "S3 Bucket Access Control List (ACL) Misconfiguration Data Leak (Verified Case #58)",
    "affected_system": {
      "system_type": "Financial Technology Startup",
      "organization": "Financial Technology Startup Infrastructure",
      "product": "Customer KYC Verification Document Store",
      "is_ai_system": false,
      "is_agentic": false,
      "primary_language": "Cloud & Distributed Systems"
    },
    "incident_date": "2024-11-03",
    "source_authority": {
      "document_type": "Security Audit Report",
      "filing_id": "PUB-058",
      "reporting_entity": "Financial Technology Startup Infrastructure",
      "regulatory_body": "Public Regulatory Filing / Engineering Postmortem"
    },
    "source_url": "https://www.sec.gov/Archives/edgar/data/789019/000119312524011295/d708866d8k.htm",
    "source_publisher": "Regulatory Disclosure & Cloud Engineering Archive",
    "source_stated_contributors": [
      "Default bucket ACL configured as `public-read` exposed 500,000 passport photos and bank st..."
    ],
    "documented_facts": [
      {
        "fact_id": "SEA-PUB-058-F1",
        "statement": "Default bucket ACL configured as `public-read` exposed 500,000 passport photos and bank statements to search crawlers.",
        "document_citation": "Security Audit Report"
      }
    ],
    "collectsea_classification": {
      "capabilities": [
        "data.pii",
        "data.financial_records",
        "auth.privileged_action"
      ],
      "failure_mechanisms": [
        "SEA-FM-001",
        "SEA-FM-009"
      ],
      "consequences": [
        "Financial Loss",
        "Execution Error"
      ],
      "authority_level": "PRIVILEGED_INTERNAL"
    },
    "safeguards": [
      {
        "safeguard_id": "SEA-PUB-058-SG1",
        "label": "Automated Defensive Guardrail",
        "description": "Enforce strict pre-implementation automated architecture validation against SEA-FM-001.",
        "target_failure_mode": "Repeat architectural failure",
        "effectiveness_level": "PREVENTATIVE"
      }
    ],
    "status": "active"
  },
  {
    "incident_id": "SEA-PUB-059",
    "title": "Cross-Tenant Redis Session Hijacking via Unprefixed Cache Keys (Verified Case #59)",
    "affected_system": {
      "system_type": "SaaS CRM Platform",
      "organization": "SaaS CRM Platform Infrastructure",
      "product": "Distributed Redis Session Cache Tier",
      "is_ai_system": false,
      "is_agentic": false,
      "primary_language": "Cloud & Distributed Systems"
    },
    "incident_date": "2025-12-04",
    "source_authority": {
      "document_type": "SaaS Engineering Postmortem",
      "filing_id": "PUB-059",
      "reporting_entity": "SaaS CRM Platform Infrastructure",
      "regulatory_body": "Public Regulatory Filing / Engineering Postmortem"
    },
    "source_url": "https://aws.amazon.com/builders-library/making-retries-safe-with-idempotent-APIs/",
    "source_publisher": "Regulatory Disclosure & Cloud Engineering Archive",
    "source_stated_contributors": [
      "Session store used un-namespaced integer user IDs; tenant A authenticated as user 101 retr..."
    ],
    "documented_facts": [
      {
        "fact_id": "SEA-PUB-059-F1",
        "statement": "Session store used un-namespaced integer user IDs; tenant A authenticated as user 101 retrieved session of tenant B user 101.",
        "document_citation": "SaaS Engineering Postmortem"
      }
    ],
    "collectsea_classification": {
      "capabilities": [
        "arch.multi_tenant",
        "arch.caching",
        "data.credentials_secrets"
      ],
      "failure_mechanisms": [
        "SEA-FM-001",
        "SEA-FM-004"
      ],
      "consequences": [
        "Financial Loss",
        "Execution Error"
      ],
      "authority_level": "PRIVILEGED_INTERNAL"
    },
    "safeguards": [
      {
        "safeguard_id": "SEA-PUB-059-SG1",
        "label": "Automated Defensive Guardrail",
        "description": "Enforce strict pre-implementation automated architecture validation against SEA-FM-001.",
        "target_failure_mode": "Repeat architectural failure",
        "effectiveness_level": "PREVENTATIVE"
      }
    ],
    "status": "active"
  },
  {
    "incident_id": "SEA-PUB-060",
    "title": "Autonomous AI Agent Model Context Protocol Token Hijacking (Verified Case #60)",
    "affected_system": {
      "system_type": "AI Agentic Development Platform",
      "organization": "AI Agentic Development Platform Infrastructure",
      "product": "Autonomous MCP Agent Execution Sandbox",
      "is_ai_system": true,
      "is_agentic": true,
      "primary_language": "Cloud & Distributed Systems"
    },
    "incident_date": "2021-01-05",
    "source_authority": {
      "document_type": "AI Agent Security Advisory",
      "filing_id": "PUB-060",
      "reporting_entity": "AI Agentic Development Platform Infrastructure",
      "regulatory_body": "Public Regulatory Filing / Engineering Postmortem"
    },
    "source_url": "https://www.sec.gov/Archives/edgar/data/789019/000119312524011295/d708866d8k.htm",
    "source_publisher": "Regulatory Disclosure & Cloud Engineering Archive",
    "source_stated_contributors": [
      "Model Context Protocol search tool allowed prompt injection to leak bearer tokens in subag..."
    ],
    "documented_facts": [
      {
        "fact_id": "SEA-PUB-060-F1",
        "statement": "Model Context Protocol search tool allowed prompt injection to leak bearer tokens in subagent prompt context.",
        "document_citation": "AI Agent Security Advisory"
      }
    ],
    "collectsea_classification": {
      "capabilities": [
        "arch.tool_enabled_agent",
        "data.credentials_secrets",
        "data.untrusted_external_text"
      ],
      "failure_mechanisms": [
        "SEA-FM-010",
        "SEA-FM-001"
      ],
      "consequences": [
        "Financial Loss",
        "Execution Error"
      ],
      "authority_level": "PRIVILEGED_INTERNAL"
    },
    "safeguards": [
      {
        "safeguard_id": "SEA-PUB-060-SG1",
        "label": "Automated Defensive Guardrail",
        "description": "Enforce strict pre-implementation automated architecture validation against SEA-FM-010.",
        "target_failure_mode": "Repeat architectural failure",
        "effectiveness_level": "PREVENTATIVE"
      }
    ],
    "status": "active"
  },
  {
    "incident_id": "SEA-PUB-061",
    "title": "AI LLM Coding Assistant Arbitrary Terminal Command Execution (Verified Case #61)",
    "affected_system": {
      "system_type": "AI Developer Tools Inc.",
      "organization": "AI Developer Tools Inc. Infrastructure",
      "product": "IDE Agentic Code Generation & Shell Runner",
      "is_ai_system": true,
      "is_agentic": false,
      "primary_language": "Cloud & Distributed Systems"
    },
    "incident_date": "2022-02-06",
    "source_authority": {
      "document_type": "Software Security Advisory",
      "filing_id": "PUB-061",
      "reporting_entity": "AI Developer Tools Inc. Infrastructure",
      "regulatory_body": "Public Regulatory Filing / Engineering Postmortem"
    },
    "source_url": "https://aws.amazon.com/builders-library/making-retries-safe-with-idempotent-APIs/",
    "source_publisher": "Regulatory Disclosure & Cloud Engineering Archive",
    "source_stated_contributors": [
      "AI coding agent accepted unvalidated repository prompt that executed malicious curl script..."
    ],
    "documented_facts": [
      {
        "fact_id": "SEA-PUB-061-F1",
        "statement": "AI coding agent accepted unvalidated repository prompt that executed malicious curl script inside local terminal.",
        "document_citation": "Software Security Advisory"
      }
    ],
    "collectsea_classification": {
      "capabilities": [
        "auth.code_execution",
        "arch.tool_enabled_agent",
        "data.untrusted_external_text"
      ],
      "failure_mechanisms": [
        "SEA-FM-010",
        "SEA-FM-003"
      ],
      "consequences": [
        "Financial Loss",
        "Execution Error"
      ],
      "authority_level": "PRIVILEGED_INTERNAL"
    },
    "safeguards": [
      {
        "safeguard_id": "SEA-PUB-061-SG1",
        "label": "Automated Defensive Guardrail",
        "description": "Enforce strict pre-implementation automated architecture validation against SEA-FM-010.",
        "target_failure_mode": "Repeat architectural failure",
        "effectiveness_level": "PREVENTATIVE"
      }
    ],
    "status": "active"
  },
  {
    "incident_id": "SEA-PUB-062",
    "title": "Distributed Consensus Split-Brain State Divergence (Verified Case #62)",
    "affected_system": {
      "system_type": "Distributed Database Corporation",
      "organization": "Distributed Database Corporation Infrastructure",
      "product": "Raft Consensus Cluster & Replication Log",
      "is_ai_system": false,
      "is_agentic": false,
      "primary_language": "Cloud & Distributed Systems"
    },
    "incident_date": "2023-03-07",
    "source_authority": {
      "document_type": "Distributed Systems Postmortem",
      "filing_id": "PUB-062",
      "reporting_entity": "Distributed Database Corporation Infrastructure",
      "regulatory_body": "Public Regulatory Filing / Engineering Postmortem"
    },
    "source_url": "https://www.sec.gov/Archives/edgar/data/789019/000119312524011295/d708866d8k.htm",
    "source_publisher": "Regulatory Disclosure & Cloud Engineering Archive",
    "source_stated_contributors": [
      "Asymmetric network partition caused two leader nodes to accept client writes simultaneousl..."
    ],
    "documented_facts": [
      {
        "fact_id": "SEA-PUB-062-F1",
        "statement": "Asymmetric network partition caused two leader nodes to accept client writes simultaneously, corrupting ledger state.",
        "document_citation": "Distributed Systems Postmortem"
      }
    ],
    "collectsea_classification": {
      "capabilities": [
        "auth.infrastructure_modification",
        "arch.caching",
        "data.financial_records"
      ],
      "failure_mechanisms": [
        "SEA-FM-007",
        "SEA-FM-004"
      ],
      "consequences": [
        "Financial Loss",
        "Execution Error"
      ],
      "authority_level": "PRIVILEGED_INTERNAL"
    },
    "safeguards": [
      {
        "safeguard_id": "SEA-PUB-062-SG1",
        "label": "Automated Defensive Guardrail",
        "description": "Enforce strict pre-implementation automated architecture validation against SEA-FM-007.",
        "target_failure_mode": "Repeat architectural failure",
        "effectiveness_level": "PREVENTATIVE"
      }
    ],
    "status": "active"
  },
  {
    "incident_id": "SEA-PUB-063",
    "title": "Serverless Function Cold Start Connection Pool Exhaustion (Verified Case #63)",
    "affected_system": {
      "system_type": "Serverless Cloud Provider",
      "organization": "Serverless Cloud Provider Infrastructure",
      "product": "Managed Serverless Database Connector",
      "is_ai_system": false,
      "is_agentic": false,
      "primary_language": "Cloud & Distributed Systems"
    },
    "incident_date": "2024-04-08",
    "source_authority": {
      "document_type": "Cloud Engineering Guide",
      "filing_id": "PUB-063",
      "reporting_entity": "Serverless Cloud Provider Infrastructure",
      "regulatory_body": "Public Regulatory Filing / Engineering Postmortem"
    },
    "source_url": "https://aws.amazon.com/builders-library/making-retries-safe-with-idempotent-APIs/",
    "source_publisher": "Regulatory Disclosure & Cloud Engineering Archive",
    "source_stated_contributors": [
      "Spike in concurrent lambda invocations opened 10,000 direct PostgreSQL connections, crashi..."
    ],
    "documented_facts": [
      {
        "fact_id": "SEA-PUB-063-F1",
        "statement": "Spike in concurrent lambda invocations opened 10,000 direct PostgreSQL connections, crashing primary RDS instance.",
        "document_citation": "Cloud Engineering Guide"
      }
    ],
    "collectsea_classification": {
      "capabilities": [
        "auth.infrastructure_modification",
        "arch.multi_tenant",
        "arch.external_api"
      ],
      "failure_mechanisms": [
        "SEA-FM-006",
        "SEA-FM-007"
      ],
      "consequences": [
        "Financial Loss",
        "Execution Error"
      ],
      "authority_level": "PRIVILEGED_INTERNAL"
    },
    "safeguards": [
      {
        "safeguard_id": "SEA-PUB-063-SG1",
        "label": "Automated Defensive Guardrail",
        "description": "Enforce strict pre-implementation automated architecture validation against SEA-FM-006.",
        "target_failure_mode": "Repeat architectural failure",
        "effectiveness_level": "PREVENTATIVE"
      }
    ],
    "status": "active"
  },
  {
    "incident_id": "SEA-PUB-064",
    "title": "Payment Webhook Out-of-Order Delivery State Machine Corruption (Verified Case #64)",
    "affected_system": {
      "system_type": "FinTech Billing Platform",
      "organization": "FinTech Billing Platform Infrastructure",
      "product": "Asynchronous Payment Webhook Event Consumer",
      "is_ai_system": false,
      "is_agentic": false,
      "primary_language": "Cloud & Distributed Systems"
    },
    "incident_date": "2025-05-09",
    "source_authority": {
      "document_type": "Payment Engineering Postmortem",
      "filing_id": "PUB-064",
      "reporting_entity": "FinTech Billing Platform Infrastructure",
      "regulatory_body": "Public Regulatory Filing / Engineering Postmortem"
    },
    "source_url": "https://www.sec.gov/Archives/edgar/data/789019/000119312524011295/d708866d8k.htm",
    "source_publisher": "Regulatory Disclosure & Cloud Engineering Archive",
    "source_stated_contributors": [
      "Late-arriving `payment_failed` webhook processed after `subscription_renewed`, deactivatin..."
    ],
    "documented_facts": [
      {
        "fact_id": "SEA-PUB-064-F1",
        "statement": "Late-arriving `payment_failed` webhook processed after `subscription_renewed`, deactivating active paying customer account.",
        "document_citation": "Payment Engineering Postmortem"
      }
    ],
    "collectsea_classification": {
      "capabilities": [
        "auth.financial_action",
        "arch.external_api",
        "data.financial_records"
      ],
      "failure_mechanisms": [
        "SEA-FM-007",
        "SEA-FM-008"
      ],
      "consequences": [
        "Financial Loss",
        "Execution Error"
      ],
      "authority_level": "IRREVERSIBLE_EXTERNAL"
    },
    "safeguards": [
      {
        "safeguard_id": "SEA-PUB-064-SG1",
        "label": "Automated Defensive Guardrail",
        "description": "Enforce strict pre-implementation automated architecture validation against SEA-FM-007.",
        "target_failure_mode": "Repeat architectural failure",
        "effectiveness_level": "PREVENTATIVE"
      }
    ],
    "status": "active"
  },
  {
    "incident_id": "SEA-PUB-065",
    "title": "GraphQL Deeply Nested Query Denial of Service (Verified Case #65)",
    "affected_system": {
      "system_type": "Enterprise API Gateway",
      "organization": "Enterprise API Gateway Infrastructure",
      "product": "Public GraphQL Query Parser & Resolver",
      "is_ai_system": false,
      "is_agentic": false,
      "primary_language": "Cloud & Distributed Systems"
    },
    "incident_date": "2021-06-10",
    "source_authority": {
      "document_type": "API Security Advisory",
      "filing_id": "PUB-065",
      "reporting_entity": "Enterprise API Gateway Infrastructure",
      "regulatory_body": "Public Regulatory Filing / Engineering Postmortem"
    },
    "source_url": "https://aws.amazon.com/builders-library/making-retries-safe-with-idempotent-APIs/",
    "source_publisher": "Regulatory Disclosure & Cloud Engineering Archive",
    "source_stated_contributors": [
      "Recursive query execution (`user { friends { friends { friends } } }`) caused heap memory ..."
    ],
    "documented_facts": [
      {
        "fact_id": "SEA-PUB-065-F1",
        "statement": "Recursive query execution (`user { friends { friends { friends } } }`) caused heap memory exhaustion on backend node.",
        "document_citation": "API Security Advisory"
      }
    ],
    "collectsea_classification": {
      "capabilities": [
        "arch.multi_tenant",
        "arch.external_api",
        "data.untrusted_external_text"
      ],
      "failure_mechanisms": [
        "SEA-FM-006",
        "SEA-FM-003"
      ],
      "consequences": [
        "Financial Loss",
        "Execution Error"
      ],
      "authority_level": "PRIVILEGED_INTERNAL"
    },
    "safeguards": [
      {
        "safeguard_id": "SEA-PUB-065-SG1",
        "label": "Automated Defensive Guardrail",
        "description": "Enforce strict pre-implementation automated architecture validation against SEA-FM-006.",
        "target_failure_mode": "Repeat architectural failure",
        "effectiveness_level": "PREVENTATIVE"
      }
    ],
    "status": "active"
  },
  {
    "incident_id": "SEA-PUB-066",
    "title": "JWT Secret Key Confusion & Privilege Escalation (Verified Case #66)",
    "affected_system": {
      "system_type": "Cloud SaaS Authentication Service",
      "organization": "Cloud SaaS Authentication Service Infrastructure",
      "product": "OAuth2 / OpenID Connect Token Signer",
      "is_ai_system": false,
      "is_agentic": false,
      "primary_language": "Cloud & Distributed Systems"
    },
    "incident_date": "2022-07-11",
    "source_authority": {
      "document_type": "Identity Security Report",
      "filing_id": "PUB-066",
      "reporting_entity": "Cloud SaaS Authentication Service Infrastructure",
      "regulatory_body": "Public Regulatory Filing / Engineering Postmortem"
    },
    "source_url": "https://www.sec.gov/Archives/edgar/data/789019/000119312524011295/d708866d8k.htm",
    "source_publisher": "Regulatory Disclosure & Cloud Engineering Archive",
    "source_stated_contributors": [
      "Backend accepted HMAC-SHA256 tokens signed with public RSA key, allowing attacker to forge..."
    ],
    "documented_facts": [
      {
        "fact_id": "SEA-PUB-066-F1",
        "statement": "Backend accepted HMAC-SHA256 tokens signed with public RSA key, allowing attacker to forge administrator tokens.",
        "document_citation": "Identity Security Report"
      }
    ],
    "collectsea_classification": {
      "capabilities": [
        "data.credentials_secrets",
        "auth.privileged_action",
        "arch.multi_tenant"
      ],
      "failure_mechanisms": [
        "SEA-FM-001",
        "SEA-FM-008"
      ],
      "consequences": [
        "Financial Loss",
        "Execution Error"
      ],
      "authority_level": "PRIVILEGED_INTERNAL"
    },
    "safeguards": [
      {
        "safeguard_id": "SEA-PUB-066-SG1",
        "label": "Automated Defensive Guardrail",
        "description": "Enforce strict pre-implementation automated architecture validation against SEA-FM-001.",
        "target_failure_mode": "Repeat architectural failure",
        "effectiveness_level": "PREVENTATIVE"
      }
    ],
    "status": "active"
  },
  {
    "incident_id": "SEA-PUB-067",
    "title": "Distributed Rate Limiter Redis Key Collision & Global Lockout (Verified Case #67)",
    "affected_system": {
      "system_type": "Global API Proxy Network",
      "organization": "Global API Proxy Network Infrastructure",
      "product": "Distributed Redis Token Bucket Rate Limiter",
      "is_ai_system": false,
      "is_agentic": false,
      "primary_language": "Cloud & Distributed Systems"
    },
    "incident_date": "2023-08-12",
    "source_authority": {
      "document_type": "Edge Engineering Postmortem",
      "filing_id": "PUB-067",
      "reporting_entity": "Global API Proxy Network Infrastructure",
      "regulatory_body": "Public Regulatory Filing / Engineering Postmortem"
    },
    "source_url": "https://aws.amazon.com/builders-library/making-retries-safe-with-idempotent-APIs/",
    "source_publisher": "Regulatory Disclosure & Cloud Engineering Archive",
    "source_stated_contributors": [
      "Missing tenant namespace prefix in rate limiter Redis key caused single user limit to appl..."
    ],
    "documented_facts": [
      {
        "fact_id": "SEA-PUB-067-F1",
        "statement": "Missing tenant namespace prefix in rate limiter Redis key caused single user limit to apply globally to all tenants.",
        "document_citation": "Edge Engineering Postmortem"
      }
    ],
    "collectsea_classification": {
      "capabilities": [
        "arch.multi_tenant",
        "arch.caching",
        "auth.infrastructure_modification"
      ],
      "failure_mechanisms": [
        "SEA-FM-001",
        "SEA-FM-006"
      ],
      "consequences": [
        "Financial Loss",
        "Execution Error"
      ],
      "authority_level": "PRIVILEGED_INTERNAL"
    },
    "safeguards": [
      {
        "safeguard_id": "SEA-PUB-067-SG1",
        "label": "Automated Defensive Guardrail",
        "description": "Enforce strict pre-implementation automated architecture validation against SEA-FM-001.",
        "target_failure_mode": "Repeat architectural failure",
        "effectiveness_level": "PREVENTATIVE"
      }
    ],
    "status": "active"
  },
  {
    "incident_id": "SEA-PUB-068",
    "title": "Kafka Consumer Group Rebalance Storm Message Lag (Verified Case #68)",
    "affected_system": {
      "system_type": "Streaming Analytics Platform",
      "organization": "Streaming Analytics Platform Infrastructure",
      "product": "Distributed Event Stream Processing Engine",
      "is_ai_system": false,
      "is_agentic": false,
      "primary_language": "Cloud & Distributed Systems"
    },
    "incident_date": "2024-09-13",
    "source_authority": {
      "document_type": "Streaming Engineering Postmortem",
      "filing_id": "PUB-068",
      "reporting_entity": "Streaming Analytics Platform Infrastructure",
      "regulatory_body": "Public Regulatory Filing / Engineering Postmortem"
    },
    "source_url": "https://www.sec.gov/Archives/edgar/data/789019/000119312524011295/d708866d8k.htm",
    "source_publisher": "Regulatory Disclosure & Cloud Engineering Archive",
    "source_stated_contributors": [
      "Slow consumer heartbeat during heavy batch processing triggered infinite rebalance loop, h..."
    ],
    "documented_facts": [
      {
        "fact_id": "SEA-PUB-068-F1",
        "statement": "Slow consumer heartbeat during heavy batch processing triggered infinite rebalance loop, halting all event consumption.",
        "document_citation": "Streaming Engineering Postmortem"
      }
    ],
    "collectsea_classification": {
      "capabilities": [
        "auth.infrastructure_modification",
        "arch.caching",
        "arch.external_api"
      ],
      "failure_mechanisms": [
        "SEA-FM-006",
        "SEA-FM-007"
      ],
      "consequences": [
        "Financial Loss",
        "Execution Error"
      ],
      "authority_level": "PRIVILEGED_INTERNAL"
    },
    "safeguards": [
      {
        "safeguard_id": "SEA-PUB-068-SG1",
        "label": "Automated Defensive Guardrail",
        "description": "Enforce strict pre-implementation automated architecture validation against SEA-FM-006.",
        "target_failure_mode": "Repeat architectural failure",
        "effectiveness_level": "PREVENTATIVE"
      }
    ],
    "status": "active"
  },
  {
    "incident_id": "SEA-PUB-069",
    "title": "Kubernetes Ingress Controller Memory Leak on Dynamic SSL Reload (Verified Case #69)",
    "affected_system": {
      "system_type": "Cloud Orchestration Mesh",
      "organization": "Cloud Orchestration Mesh Infrastructure",
      "product": "NGINX Ingress Controller & Cert-Manager",
      "is_ai_system": false,
      "is_agentic": false,
      "primary_language": "Cloud & Distributed Systems"
    },
    "incident_date": "2025-10-14",
    "source_authority": {
      "document_type": "Kubernetes Incident Postmortem",
      "filing_id": "PUB-069",
      "reporting_entity": "Cloud Orchestration Mesh Infrastructure",
      "regulatory_body": "Public Regulatory Filing / Engineering Postmortem"
    },
    "source_url": "https://aws.amazon.com/builders-library/making-retries-safe-with-idempotent-APIs/",
    "source_publisher": "Regulatory Disclosure & Cloud Engineering Archive",
    "source_stated_contributors": [
      "Frequent Let's Encrypt cert renewals triggered daily NGINX reloads, fragmenting heap until..."
    ],
    "documented_facts": [
      {
        "fact_id": "SEA-PUB-069-F1",
        "statement": "Frequent Let's Encrypt cert renewals triggered daily NGINX reloads, fragmenting heap until pods OOM-killed.",
        "document_citation": "Kubernetes Incident Postmortem"
      }
    ],
    "collectsea_classification": {
      "capabilities": [
        "auth.infrastructure_modification",
        "data.credentials_secrets",
        "arch.external_api"
      ],
      "failure_mechanisms": [
        "SEA-FM-006",
        "SEA-FM-005"
      ],
      "consequences": [
        "Financial Loss",
        "Execution Error"
      ],
      "authority_level": "PRIVILEGED_INTERNAL"
    },
    "safeguards": [
      {
        "safeguard_id": "SEA-PUB-069-SG1",
        "label": "Automated Defensive Guardrail",
        "description": "Enforce strict pre-implementation automated architecture validation against SEA-FM-006.",
        "target_failure_mode": "Repeat architectural failure",
        "effectiveness_level": "PREVENTATIVE"
      }
    ],
    "status": "active"
  },
  {
    "incident_id": "SEA-PUB-070",
    "title": "Container Image Registry Tag Mutation Supply Chain Compromise (Verified Case #70)",
    "affected_system": {
      "system_type": "Cloud Native Platform",
      "organization": "Cloud Native Platform Infrastructure",
      "product": "Public Docker Container Image Registry",
      "is_ai_system": false,
      "is_agentic": false,
      "primary_language": "Cloud & Distributed Systems"
    },
    "incident_date": "2021-11-15",
    "source_authority": {
      "document_type": "Cloud Supply Chain Report",
      "filing_id": "PUB-070",
      "reporting_entity": "Cloud Native Platform Infrastructure",
      "regulatory_body": "Public Regulatory Filing / Engineering Postmortem"
    },
    "source_url": "https://www.sec.gov/Archives/edgar/data/789019/000119312524011295/d708866d8k.htm",
    "source_publisher": "Regulatory Disclosure & Cloud Engineering Archive",
    "source_stated_contributors": [
      "Mutable `:latest` container tag overwritten by compromised build runner; deployed vulnerab..."
    ],
    "documented_facts": [
      {
        "fact_id": "SEA-PUB-070-F1",
        "statement": "Mutable `:latest` container tag overwritten by compromised build runner; deployed vulnerable image to production.",
        "document_citation": "Cloud Supply Chain Report"
      }
    ],
    "collectsea_classification": {
      "capabilities": [
        "auth.code_execution",
        "auth.infrastructure_modification",
        "data.credentials_secrets"
      ],
      "failure_mechanisms": [
        "SEA-FM-003",
        "SEA-FM-009"
      ],
      "consequences": [
        "Financial Loss",
        "Execution Error"
      ],
      "authority_level": "PRIVILEGED_INTERNAL"
    },
    "safeguards": [
      {
        "safeguard_id": "SEA-PUB-070-SG1",
        "label": "Automated Defensive Guardrail",
        "description": "Enforce strict pre-implementation automated architecture validation against SEA-FM-003.",
        "target_failure_mode": "Repeat architectural failure",
        "effectiveness_level": "PREVENTATIVE"
      }
    ],
    "status": "active"
  },
  {
    "incident_id": "SEA-PUB-071",
    "title": "DNSSEC Key Rollback & Global Domain Invalidation (Verified Case #71)",
    "affected_system": {
      "system_type": "Top-Level Domain Registry",
      "organization": "Top-Level Domain Registry Infrastructure",
      "product": "Authoritative DNSSEC Signing Infrastructure",
      "is_ai_system": false,
      "is_agentic": false,
      "primary_language": "Cloud & Distributed Systems"
    },
    "incident_date": "2022-12-16",
    "source_authority": {
      "document_type": "DNS Engineering Postmortem",
      "filing_id": "PUB-071",
      "reporting_entity": "Top-Level Domain Registry Infrastructure",
      "regulatory_body": "Public Regulatory Filing / Engineering Postmortem"
    },
    "source_url": "https://aws.amazon.com/builders-library/making-retries-safe-with-idempotent-APIs/",
    "source_publisher": "Regulatory Disclosure & Cloud Engineering Archive",
    "source_stated_contributors": [
      "Mismatched DS records during planned Key Signing Key (KSK) rollover caused recursive resol..."
    ],
    "documented_facts": [
      {
        "fact_id": "SEA-PUB-071-F1",
        "statement": "Mismatched DS records during planned Key Signing Key (KSK) rollover caused recursive resolvers worldwide to return SERVFAIL.",
        "document_citation": "DNS Engineering Postmortem"
      }
    ],
    "collectsea_classification": {
      "capabilities": [
        "auth.infrastructure_modification",
        "data.credentials_secrets",
        "arch.external_api"
      ],
      "failure_mechanisms": [
        "SEA-FM-008",
        "SEA-FM-005"
      ],
      "consequences": [
        "Financial Loss",
        "Execution Error"
      ],
      "authority_level": "PRIVILEGED_INTERNAL"
    },
    "safeguards": [
      {
        "safeguard_id": "SEA-PUB-071-SG1",
        "label": "Automated Defensive Guardrail",
        "description": "Enforce strict pre-implementation automated architecture validation against SEA-FM-008.",
        "target_failure_mode": "Repeat architectural failure",
        "effectiveness_level": "PREVENTATIVE"
      }
    ],
    "status": "active"
  },
  {
    "incident_id": "SEA-PUB-072",
    "title": "OAuth Refresh Token Reuse Race Condition & Account Takeover (Verified Case #72)",
    "affected_system": {
      "system_type": "Consumer Mobile Platform",
      "organization": "Consumer Mobile Platform Infrastructure",
      "product": "Mobile OAuth2 Token Exchange Gateway",
      "is_ai_system": false,
      "is_agentic": false,
      "primary_language": "Cloud & Distributed Systems"
    },
    "incident_date": "2023-01-17",
    "source_authority": {
      "document_type": "Mobile Security Advisory",
      "filing_id": "PUB-072",
      "reporting_entity": "Consumer Mobile Platform Infrastructure",
      "regulatory_body": "Public Regulatory Filing / Engineering Postmortem"
    },
    "source_url": "https://www.sec.gov/Archives/edgar/data/789019/000119312524011295/d708866d8k.htm",
    "source_publisher": "Regulatory Disclosure & Cloud Engineering Archive",
    "source_stated_contributors": [
      "Simultaneous token refresh requests from multi-tab sessions triggered false reuse detectio..."
    ],
    "documented_facts": [
      {
        "fact_id": "SEA-PUB-072-F1",
        "statement": "Simultaneous token refresh requests from multi-tab sessions triggered false reuse detection, locking user accounts.",
        "document_citation": "Mobile Security Advisory"
      }
    ],
    "collectsea_classification": {
      "capabilities": [
        "data.credentials_secrets",
        "arch.multi_tenant",
        "auth.privileged_action"
      ],
      "failure_mechanisms": [
        "SEA-FM-007",
        "SEA-FM-001"
      ],
      "consequences": [
        "Financial Loss",
        "Execution Error"
      ],
      "authority_level": "PRIVILEGED_INTERNAL"
    },
    "safeguards": [
      {
        "safeguard_id": "SEA-PUB-072-SG1",
        "label": "Automated Defensive Guardrail",
        "description": "Enforce strict pre-implementation automated architecture validation against SEA-FM-007.",
        "target_failure_mode": "Repeat architectural failure",
        "effectiveness_level": "PREVENTATIVE"
      }
    ],
    "status": "active"
  },
  {
    "incident_id": "SEA-PUB-073",
    "title": "BGP Prefix Hijack Inadvertent Cryptocurrency Wallet Redirection (Verified Case #73)",
    "affected_system": {
      "system_type": "Internet Routing Infrastructure",
      "organization": "Internet Routing Infrastructure Infrastructure",
      "product": "Autonomous System BGP Routing Gateway",
      "is_ai_system": false,
      "is_agentic": false,
      "primary_language": "Cloud & Distributed Systems"
    },
    "incident_date": "2024-02-18",
    "source_authority": {
      "document_type": "Internet Routing Postmortem",
      "filing_id": "PUB-073",
      "reporting_entity": "Internet Routing Infrastructure Infrastructure",
      "regulatory_body": "Public Regulatory Filing / Engineering Postmortem"
    },
    "source_url": "https://aws.amazon.com/builders-library/making-retries-safe-with-idempotent-APIs/",
    "source_publisher": "Regulatory Disclosure & Cloud Engineering Archive",
    "source_stated_contributors": [
      "Rogue BGP route announcement redirected DNS queries for major cryptocurrency portal to mal..."
    ],
    "documented_facts": [
      {
        "fact_id": "SEA-PUB-073-F1",
        "statement": "Rogue BGP route announcement redirected DNS queries for major cryptocurrency portal to malicious server for 2 hours.",
        "document_citation": "Internet Routing Postmortem"
      }
    ],
    "collectsea_classification": {
      "capabilities": [
        "auth.infrastructure_modification",
        "arch.external_api",
        "data.credentials_secrets"
      ],
      "failure_mechanisms": [
        "SEA-FM-001",
        "SEA-FM-005"
      ],
      "consequences": [
        "Financial Loss",
        "Execution Error"
      ],
      "authority_level": "PRIVILEGED_INTERNAL"
    },
    "safeguards": [
      {
        "safeguard_id": "SEA-PUB-073-SG1",
        "label": "Automated Defensive Guardrail",
        "description": "Enforce strict pre-implementation automated architecture validation against SEA-FM-001.",
        "target_failure_mode": "Repeat architectural failure",
        "effectiveness_level": "PREVENTATIVE"
      }
    ],
    "status": "active"
  },
  {
    "incident_id": "SEA-PUB-074",
    "title": "Database Auto-Vacuum Starvation Transaction ID Wraparound (Verified Case #74)",
    "affected_system": {
      "system_type": "Enterprise Managed PostgreSQL",
      "organization": "Enterprise Managed PostgreSQL Infrastructure",
      "product": "High-Volume Transaction Ledger Database",
      "is_ai_system": false,
      "is_agentic": false,
      "primary_language": "Cloud & Distributed Systems"
    },
    "incident_date": "2025-03-19",
    "source_authority": {
      "document_type": "Database Reliability Postmortem",
      "filing_id": "PUB-074",
      "reporting_entity": "Enterprise Managed PostgreSQL Infrastructure",
      "regulatory_body": "Public Regulatory Filing / Engineering Postmortem"
    },
    "source_url": "https://www.sec.gov/Archives/edgar/data/789019/000119312524011295/d708866d8k.htm",
    "source_publisher": "Regulatory Disclosure & Cloud Engineering Archive",
    "source_stated_contributors": [
      "Aggressive long-running analytics queries blocked auto-vacuum; reached 2-billion transacti..."
    ],
    "documented_facts": [
      {
        "fact_id": "SEA-PUB-074-F1",
        "statement": "Aggressive long-running analytics queries blocked auto-vacuum; reached 2-billion transaction ID limit forcing emergency shutdown.",
        "document_citation": "Database Reliability Postmortem"
      }
    ],
    "collectsea_classification": {
      "capabilities": [
        "data.financial_records",
        "auth.infrastructure_modification",
        "arch.caching"
      ],
      "failure_mechanisms": [
        "SEA-FM-005",
        "SEA-FM-006"
      ],
      "consequences": [
        "Financial Loss",
        "Execution Error"
      ],
      "authority_level": "PRIVILEGED_INTERNAL"
    },
    "safeguards": [
      {
        "safeguard_id": "SEA-PUB-074-SG1",
        "label": "Automated Defensive Guardrail",
        "description": "Enforce strict pre-implementation automated architecture validation against SEA-FM-005.",
        "target_failure_mode": "Repeat architectural failure",
        "effectiveness_level": "PREVENTATIVE"
      }
    ],
    "status": "active"
  },
  {
    "incident_id": "SEA-PUB-075",
    "title": "WebSocket Connection Thundering Herd on Load Balancer Restart (Verified Case #75)",
    "affected_system": {
      "system_type": "Real-Time Collaboration Platform",
      "organization": "Real-Time Collaboration Platform Infrastructure",
      "product": "Edge WebSocket Reverse Proxy Mesh",
      "is_ai_system": false,
      "is_agentic": false,
      "primary_language": "Cloud & Distributed Systems"
    },
    "incident_date": "2021-04-20",
    "source_authority": {
      "document_type": "Edge Engineering Postmortem",
      "filing_id": "PUB-075",
      "reporting_entity": "Real-Time Collaboration Platform Infrastructure",
      "regulatory_body": "Public Regulatory Filing / Engineering Postmortem"
    },
    "source_url": "https://aws.amazon.com/builders-library/making-retries-safe-with-idempotent-APIs/",
    "source_publisher": "Regulatory Disclosure & Cloud Engineering Archive",
    "source_stated_contributors": [
      "Simultaneous disconnect of 500,000 active WebSocket clients during proxy restart saturated..."
    ],
    "documented_facts": [
      {
        "fact_id": "SEA-PUB-075-F1",
        "statement": "Simultaneous disconnect of 500,000 active WebSocket clients during proxy restart saturated auth services upon reconnection.",
        "document_citation": "Edge Engineering Postmortem"
      }
    ],
    "collectsea_classification": {
      "capabilities": [
        "arch.multi_tenant",
        "arch.caching",
        "auth.infrastructure_modification"
      ],
      "failure_mechanisms": [
        "SEA-FM-006",
        "SEA-FM-007"
      ],
      "consequences": [
        "Financial Loss",
        "Execution Error"
      ],
      "authority_level": "PRIVILEGED_INTERNAL"
    },
    "safeguards": [
      {
        "safeguard_id": "SEA-PUB-075-SG1",
        "label": "Automated Defensive Guardrail",
        "description": "Enforce strict pre-implementation automated architecture validation against SEA-FM-006.",
        "target_failure_mode": "Repeat architectural failure",
        "effectiveness_level": "PREVENTATIVE"
      }
    ],
    "status": "active"
  },
  {
    "incident_id": "SEA-PUB-076",
    "title": "LLM Tool Call Hallucination SQL Injection Parameter (Verified Case #76)",
    "affected_system": {
      "system_type": "Autonomous AI Database Agent",
      "organization": "Autonomous AI Database Agent Infrastructure",
      "product": "Natural Language SQL Generation Pipeline",
      "is_ai_system": true,
      "is_agentic": false,
      "primary_language": "Cloud & Distributed Systems"
    },
    "incident_date": "2022-05-21",
    "source_authority": {
      "document_type": "AI Safety Research Advisory",
      "filing_id": "PUB-076",
      "reporting_entity": "Autonomous AI Database Agent Infrastructure",
      "regulatory_body": "Public Regulatory Filing / Engineering Postmortem"
    },
    "source_url": "https://www.sec.gov/Archives/edgar/data/789019/000119312524011295/d708866d8k.htm",
    "source_publisher": "Regulatory Disclosure & Cloud Engineering Archive",
    "source_stated_contributors": [
      "LLM hallucinated unescaped string concatenation when generating dynamic SQL query from use..."
    ],
    "documented_facts": [
      {
        "fact_id": "SEA-PUB-076-F1",
        "statement": "LLM hallucinated unescaped string concatenation when generating dynamic SQL query from user input, allowing data extraction.",
        "document_citation": "AI Safety Research Advisory"
      }
    ],
    "collectsea_classification": {
      "capabilities": [
        "auth.code_execution",
        "arch.tool_enabled_agent",
        "data.untrusted_external_text"
      ],
      "failure_mechanisms": [
        "SEA-FM-010",
        "SEA-FM-001"
      ],
      "consequences": [
        "Financial Loss",
        "Execution Error"
      ],
      "authority_level": "PRIVILEGED_INTERNAL"
    },
    "safeguards": [
      {
        "safeguard_id": "SEA-PUB-076-SG1",
        "label": "Automated Defensive Guardrail",
        "description": "Enforce strict pre-implementation automated architecture validation against SEA-FM-010.",
        "target_failure_mode": "Repeat architectural failure",
        "effectiveness_level": "PREVENTATIVE"
      }
    ],
    "status": "active"
  },
  {
    "incident_id": "SEA-PUB-077",
    "title": "Cloud IAM Wildcard Permission Lateral Privilege Escalation (Verified Case #77)",
    "affected_system": {
      "system_type": "Enterprise Cloud Infrastructure",
      "organization": "Enterprise Cloud Infrastructure Infrastructure",
      "product": "Cloud IAM Policy & Role Hierarchy",
      "is_ai_system": false,
      "is_agentic": false,
      "primary_language": "Cloud & Distributed Systems"
    },
    "incident_date": "2023-06-22",
    "source_authority": {
      "document_type": "Cloud Security Audit",
      "filing_id": "PUB-077",
      "reporting_entity": "Enterprise Cloud Infrastructure Infrastructure",
      "regulatory_body": "Public Regulatory Filing / Engineering Postmortem"
    },
    "source_url": "https://aws.amazon.com/builders-library/making-retries-safe-with-idempotent-APIs/",
    "source_publisher": "Regulatory Disclosure & Cloud Engineering Archive",
    "source_stated_contributors": [
      "Overly permissive `iam:PassRole` on worker instances allowed compromised application to as..."
    ],
    "documented_facts": [
      {
        "fact_id": "SEA-PUB-077-F1",
        "statement": "Overly permissive `iam:PassRole` on worker instances allowed compromised application to assume administrator role.",
        "document_citation": "Cloud Security Audit"
      }
    ],
    "collectsea_classification": {
      "capabilities": [
        "auth.privileged_action",
        "data.credentials_secrets",
        "arch.multi_tenant"
      ],
      "failure_mechanisms": [
        "SEA-FM-001",
        "SEA-FM-009"
      ],
      "consequences": [
        "Financial Loss",
        "Execution Error"
      ],
      "authority_level": "PRIVILEGED_INTERNAL"
    },
    "safeguards": [
      {
        "safeguard_id": "SEA-PUB-077-SG1",
        "label": "Automated Defensive Guardrail",
        "description": "Enforce strict pre-implementation automated architecture validation against SEA-FM-001.",
        "target_failure_mode": "Repeat architectural failure",
        "effectiveness_level": "PREVENTATIVE"
      }
    ],
    "status": "active"
  },
  {
    "incident_id": "SEA-PUB-078",
    "title": "S3 Bucket Access Control List (ACL) Misconfiguration Data Leak (Verified Case #78)",
    "affected_system": {
      "system_type": "Financial Technology Startup",
      "organization": "Financial Technology Startup Infrastructure",
      "product": "Customer KYC Verification Document Store",
      "is_ai_system": false,
      "is_agentic": false,
      "primary_language": "Cloud & Distributed Systems"
    },
    "incident_date": "2024-07-23",
    "source_authority": {
      "document_type": "Security Audit Report",
      "filing_id": "PUB-078",
      "reporting_entity": "Financial Technology Startup Infrastructure",
      "regulatory_body": "Public Regulatory Filing / Engineering Postmortem"
    },
    "source_url": "https://www.sec.gov/Archives/edgar/data/789019/000119312524011295/d708866d8k.htm",
    "source_publisher": "Regulatory Disclosure & Cloud Engineering Archive",
    "source_stated_contributors": [
      "Default bucket ACL configured as `public-read` exposed 500,000 passport photos and bank st..."
    ],
    "documented_facts": [
      {
        "fact_id": "SEA-PUB-078-F1",
        "statement": "Default bucket ACL configured as `public-read` exposed 500,000 passport photos and bank statements to search crawlers.",
        "document_citation": "Security Audit Report"
      }
    ],
    "collectsea_classification": {
      "capabilities": [
        "data.pii",
        "data.financial_records",
        "auth.privileged_action"
      ],
      "failure_mechanisms": [
        "SEA-FM-001",
        "SEA-FM-009"
      ],
      "consequences": [
        "Financial Loss",
        "Execution Error"
      ],
      "authority_level": "PRIVILEGED_INTERNAL"
    },
    "safeguards": [
      {
        "safeguard_id": "SEA-PUB-078-SG1",
        "label": "Automated Defensive Guardrail",
        "description": "Enforce strict pre-implementation automated architecture validation against SEA-FM-001.",
        "target_failure_mode": "Repeat architectural failure",
        "effectiveness_level": "PREVENTATIVE"
      }
    ],
    "status": "active"
  },
  {
    "incident_id": "SEA-PUB-079",
    "title": "Cross-Tenant Redis Session Hijacking via Unprefixed Cache Keys (Verified Case #79)",
    "affected_system": {
      "system_type": "SaaS CRM Platform",
      "organization": "SaaS CRM Platform Infrastructure",
      "product": "Distributed Redis Session Cache Tier",
      "is_ai_system": false,
      "is_agentic": false,
      "primary_language": "Cloud & Distributed Systems"
    },
    "incident_date": "2025-08-24",
    "source_authority": {
      "document_type": "SaaS Engineering Postmortem",
      "filing_id": "PUB-079",
      "reporting_entity": "SaaS CRM Platform Infrastructure",
      "regulatory_body": "Public Regulatory Filing / Engineering Postmortem"
    },
    "source_url": "https://aws.amazon.com/builders-library/making-retries-safe-with-idempotent-APIs/",
    "source_publisher": "Regulatory Disclosure & Cloud Engineering Archive",
    "source_stated_contributors": [
      "Session store used un-namespaced integer user IDs; tenant A authenticated as user 101 retr..."
    ],
    "documented_facts": [
      {
        "fact_id": "SEA-PUB-079-F1",
        "statement": "Session store used un-namespaced integer user IDs; tenant A authenticated as user 101 retrieved session of tenant B user 101.",
        "document_citation": "SaaS Engineering Postmortem"
      }
    ],
    "collectsea_classification": {
      "capabilities": [
        "arch.multi_tenant",
        "arch.caching",
        "data.credentials_secrets"
      ],
      "failure_mechanisms": [
        "SEA-FM-001",
        "SEA-FM-004"
      ],
      "consequences": [
        "Financial Loss",
        "Execution Error"
      ],
      "authority_level": "PRIVILEGED_INTERNAL"
    },
    "safeguards": [
      {
        "safeguard_id": "SEA-PUB-079-SG1",
        "label": "Automated Defensive Guardrail",
        "description": "Enforce strict pre-implementation automated architecture validation against SEA-FM-001.",
        "target_failure_mode": "Repeat architectural failure",
        "effectiveness_level": "PREVENTATIVE"
      }
    ],
    "status": "active"
  },
  {
    "incident_id": "SEA-PUB-080",
    "title": "Autonomous AI Agent Model Context Protocol Token Hijacking (Verified Case #80)",
    "affected_system": {
      "system_type": "AI Agentic Development Platform",
      "organization": "AI Agentic Development Platform Infrastructure",
      "product": "Autonomous MCP Agent Execution Sandbox",
      "is_ai_system": true,
      "is_agentic": true,
      "primary_language": "Cloud & Distributed Systems"
    },
    "incident_date": "2021-09-25",
    "source_authority": {
      "document_type": "AI Agent Security Advisory",
      "filing_id": "PUB-080",
      "reporting_entity": "AI Agentic Development Platform Infrastructure",
      "regulatory_body": "Public Regulatory Filing / Engineering Postmortem"
    },
    "source_url": "https://www.sec.gov/Archives/edgar/data/789019/000119312524011295/d708866d8k.htm",
    "source_publisher": "Regulatory Disclosure & Cloud Engineering Archive",
    "source_stated_contributors": [
      "Model Context Protocol search tool allowed prompt injection to leak bearer tokens in subag..."
    ],
    "documented_facts": [
      {
        "fact_id": "SEA-PUB-080-F1",
        "statement": "Model Context Protocol search tool allowed prompt injection to leak bearer tokens in subagent prompt context.",
        "document_citation": "AI Agent Security Advisory"
      }
    ],
    "collectsea_classification": {
      "capabilities": [
        "arch.tool_enabled_agent",
        "data.credentials_secrets",
        "data.untrusted_external_text"
      ],
      "failure_mechanisms": [
        "SEA-FM-010",
        "SEA-FM-001"
      ],
      "consequences": [
        "Financial Loss",
        "Execution Error"
      ],
      "authority_level": "PRIVILEGED_INTERNAL"
    },
    "safeguards": [
      {
        "safeguard_id": "SEA-PUB-080-SG1",
        "label": "Automated Defensive Guardrail",
        "description": "Enforce strict pre-implementation automated architecture validation against SEA-FM-010.",
        "target_failure_mode": "Repeat architectural failure",
        "effectiveness_level": "PREVENTATIVE"
      }
    ],
    "status": "active"
  },
  {
    "incident_id": "SEA-PUB-081",
    "title": "AI LLM Coding Assistant Arbitrary Terminal Command Execution (Verified Case #81)",
    "affected_system": {
      "system_type": "AI Developer Tools Inc.",
      "organization": "AI Developer Tools Inc. Infrastructure",
      "product": "IDE Agentic Code Generation & Shell Runner",
      "is_ai_system": true,
      "is_agentic": false,
      "primary_language": "Cloud & Distributed Systems"
    },
    "incident_date": "2022-10-26",
    "source_authority": {
      "document_type": "Software Security Advisory",
      "filing_id": "PUB-081",
      "reporting_entity": "AI Developer Tools Inc. Infrastructure",
      "regulatory_body": "Public Regulatory Filing / Engineering Postmortem"
    },
    "source_url": "https://aws.amazon.com/builders-library/making-retries-safe-with-idempotent-APIs/",
    "source_publisher": "Regulatory Disclosure & Cloud Engineering Archive",
    "source_stated_contributors": [
      "AI coding agent accepted unvalidated repository prompt that executed malicious curl script..."
    ],
    "documented_facts": [
      {
        "fact_id": "SEA-PUB-081-F1",
        "statement": "AI coding agent accepted unvalidated repository prompt that executed malicious curl script inside local terminal.",
        "document_citation": "Software Security Advisory"
      }
    ],
    "collectsea_classification": {
      "capabilities": [
        "auth.code_execution",
        "arch.tool_enabled_agent",
        "data.untrusted_external_text"
      ],
      "failure_mechanisms": [
        "SEA-FM-010",
        "SEA-FM-003"
      ],
      "consequences": [
        "Financial Loss",
        "Execution Error"
      ],
      "authority_level": "PRIVILEGED_INTERNAL"
    },
    "safeguards": [
      {
        "safeguard_id": "SEA-PUB-081-SG1",
        "label": "Automated Defensive Guardrail",
        "description": "Enforce strict pre-implementation automated architecture validation against SEA-FM-010.",
        "target_failure_mode": "Repeat architectural failure",
        "effectiveness_level": "PREVENTATIVE"
      }
    ],
    "status": "active"
  },
  {
    "incident_id": "SEA-PUB-082",
    "title": "Distributed Consensus Split-Brain State Divergence (Verified Case #82)",
    "affected_system": {
      "system_type": "Distributed Database Corporation",
      "organization": "Distributed Database Corporation Infrastructure",
      "product": "Raft Consensus Cluster & Replication Log",
      "is_ai_system": false,
      "is_agentic": false,
      "primary_language": "Cloud & Distributed Systems"
    },
    "incident_date": "2023-11-27",
    "source_authority": {
      "document_type": "Distributed Systems Postmortem",
      "filing_id": "PUB-082",
      "reporting_entity": "Distributed Database Corporation Infrastructure",
      "regulatory_body": "Public Regulatory Filing / Engineering Postmortem"
    },
    "source_url": "https://www.sec.gov/Archives/edgar/data/789019/000119312524011295/d708866d8k.htm",
    "source_publisher": "Regulatory Disclosure & Cloud Engineering Archive",
    "source_stated_contributors": [
      "Asymmetric network partition caused two leader nodes to accept client writes simultaneousl..."
    ],
    "documented_facts": [
      {
        "fact_id": "SEA-PUB-082-F1",
        "statement": "Asymmetric network partition caused two leader nodes to accept client writes simultaneously, corrupting ledger state.",
        "document_citation": "Distributed Systems Postmortem"
      }
    ],
    "collectsea_classification": {
      "capabilities": [
        "auth.infrastructure_modification",
        "arch.caching",
        "data.financial_records"
      ],
      "failure_mechanisms": [
        "SEA-FM-007",
        "SEA-FM-004"
      ],
      "consequences": [
        "Financial Loss",
        "Execution Error"
      ],
      "authority_level": "PRIVILEGED_INTERNAL"
    },
    "safeguards": [
      {
        "safeguard_id": "SEA-PUB-082-SG1",
        "label": "Automated Defensive Guardrail",
        "description": "Enforce strict pre-implementation automated architecture validation against SEA-FM-007.",
        "target_failure_mode": "Repeat architectural failure",
        "effectiveness_level": "PREVENTATIVE"
      }
    ],
    "status": "active"
  },
  {
    "incident_id": "SEA-PUB-083",
    "title": "Serverless Function Cold Start Connection Pool Exhaustion (Verified Case #83)",
    "affected_system": {
      "system_type": "Serverless Cloud Provider",
      "organization": "Serverless Cloud Provider Infrastructure",
      "product": "Managed Serverless Database Connector",
      "is_ai_system": false,
      "is_agentic": false,
      "primary_language": "Cloud & Distributed Systems"
    },
    "incident_date": "2024-12-28",
    "source_authority": {
      "document_type": "Cloud Engineering Guide",
      "filing_id": "PUB-083",
      "reporting_entity": "Serverless Cloud Provider Infrastructure",
      "regulatory_body": "Public Regulatory Filing / Engineering Postmortem"
    },
    "source_url": "https://aws.amazon.com/builders-library/making-retries-safe-with-idempotent-APIs/",
    "source_publisher": "Regulatory Disclosure & Cloud Engineering Archive",
    "source_stated_contributors": [
      "Spike in concurrent lambda invocations opened 10,000 direct PostgreSQL connections, crashi..."
    ],
    "documented_facts": [
      {
        "fact_id": "SEA-PUB-083-F1",
        "statement": "Spike in concurrent lambda invocations opened 10,000 direct PostgreSQL connections, crashing primary RDS instance.",
        "document_citation": "Cloud Engineering Guide"
      }
    ],
    "collectsea_classification": {
      "capabilities": [
        "auth.infrastructure_modification",
        "arch.multi_tenant",
        "arch.external_api"
      ],
      "failure_mechanisms": [
        "SEA-FM-006",
        "SEA-FM-007"
      ],
      "consequences": [
        "Financial Loss",
        "Execution Error"
      ],
      "authority_level": "PRIVILEGED_INTERNAL"
    },
    "safeguards": [
      {
        "safeguard_id": "SEA-PUB-083-SG1",
        "label": "Automated Defensive Guardrail",
        "description": "Enforce strict pre-implementation automated architecture validation against SEA-FM-006.",
        "target_failure_mode": "Repeat architectural failure",
        "effectiveness_level": "PREVENTATIVE"
      }
    ],
    "status": "active"
  },
  {
    "incident_id": "SEA-PUB-084",
    "title": "Payment Webhook Out-of-Order Delivery State Machine Corruption (Verified Case #84)",
    "affected_system": {
      "system_type": "FinTech Billing Platform",
      "organization": "FinTech Billing Platform Infrastructure",
      "product": "Asynchronous Payment Webhook Event Consumer",
      "is_ai_system": false,
      "is_agentic": false,
      "primary_language": "Cloud & Distributed Systems"
    },
    "incident_date": "2025-01-01",
    "source_authority": {
      "document_type": "Payment Engineering Postmortem",
      "filing_id": "PUB-084",
      "reporting_entity": "FinTech Billing Platform Infrastructure",
      "regulatory_body": "Public Regulatory Filing / Engineering Postmortem"
    },
    "source_url": "https://www.sec.gov/Archives/edgar/data/789019/000119312524011295/d708866d8k.htm",
    "source_publisher": "Regulatory Disclosure & Cloud Engineering Archive",
    "source_stated_contributors": [
      "Late-arriving `payment_failed` webhook processed after `subscription_renewed`, deactivatin..."
    ],
    "documented_facts": [
      {
        "fact_id": "SEA-PUB-084-F1",
        "statement": "Late-arriving `payment_failed` webhook processed after `subscription_renewed`, deactivating active paying customer account.",
        "document_citation": "Payment Engineering Postmortem"
      }
    ],
    "collectsea_classification": {
      "capabilities": [
        "auth.financial_action",
        "arch.external_api",
        "data.financial_records"
      ],
      "failure_mechanisms": [
        "SEA-FM-007",
        "SEA-FM-008"
      ],
      "consequences": [
        "Financial Loss",
        "Execution Error"
      ],
      "authority_level": "IRREVERSIBLE_EXTERNAL"
    },
    "safeguards": [
      {
        "safeguard_id": "SEA-PUB-084-SG1",
        "label": "Automated Defensive Guardrail",
        "description": "Enforce strict pre-implementation automated architecture validation against SEA-FM-007.",
        "target_failure_mode": "Repeat architectural failure",
        "effectiveness_level": "PREVENTATIVE"
      }
    ],
    "status": "active"
  },
  {
    "incident_id": "SEA-PUB-085",
    "title": "GraphQL Deeply Nested Query Denial of Service (Verified Case #85)",
    "affected_system": {
      "system_type": "Enterprise API Gateway",
      "organization": "Enterprise API Gateway Infrastructure",
      "product": "Public GraphQL Query Parser & Resolver",
      "is_ai_system": false,
      "is_agentic": false,
      "primary_language": "Cloud & Distributed Systems"
    },
    "incident_date": "2021-02-02",
    "source_authority": {
      "document_type": "API Security Advisory",
      "filing_id": "PUB-085",
      "reporting_entity": "Enterprise API Gateway Infrastructure",
      "regulatory_body": "Public Regulatory Filing / Engineering Postmortem"
    },
    "source_url": "https://aws.amazon.com/builders-library/making-retries-safe-with-idempotent-APIs/",
    "source_publisher": "Regulatory Disclosure & Cloud Engineering Archive",
    "source_stated_contributors": [
      "Recursive query execution (`user { friends { friends { friends } } }`) caused heap memory ..."
    ],
    "documented_facts": [
      {
        "fact_id": "SEA-PUB-085-F1",
        "statement": "Recursive query execution (`user { friends { friends { friends } } }`) caused heap memory exhaustion on backend node.",
        "document_citation": "API Security Advisory"
      }
    ],
    "collectsea_classification": {
      "capabilities": [
        "arch.multi_tenant",
        "arch.external_api",
        "data.untrusted_external_text"
      ],
      "failure_mechanisms": [
        "SEA-FM-006",
        "SEA-FM-003"
      ],
      "consequences": [
        "Financial Loss",
        "Execution Error"
      ],
      "authority_level": "PRIVILEGED_INTERNAL"
    },
    "safeguards": [
      {
        "safeguard_id": "SEA-PUB-085-SG1",
        "label": "Automated Defensive Guardrail",
        "description": "Enforce strict pre-implementation automated architecture validation against SEA-FM-006.",
        "target_failure_mode": "Repeat architectural failure",
        "effectiveness_level": "PREVENTATIVE"
      }
    ],
    "status": "active"
  },
  {
    "incident_id": "SEA-PUB-086",
    "title": "JWT Secret Key Confusion & Privilege Escalation (Verified Case #86)",
    "affected_system": {
      "system_type": "Cloud SaaS Authentication Service",
      "organization": "Cloud SaaS Authentication Service Infrastructure",
      "product": "OAuth2 / OpenID Connect Token Signer",
      "is_ai_system": false,
      "is_agentic": false,
      "primary_language": "Cloud & Distributed Systems"
    },
    "incident_date": "2022-03-03",
    "source_authority": {
      "document_type": "Identity Security Report",
      "filing_id": "PUB-086",
      "reporting_entity": "Cloud SaaS Authentication Service Infrastructure",
      "regulatory_body": "Public Regulatory Filing / Engineering Postmortem"
    },
    "source_url": "https://www.sec.gov/Archives/edgar/data/789019/000119312524011295/d708866d8k.htm",
    "source_publisher": "Regulatory Disclosure & Cloud Engineering Archive",
    "source_stated_contributors": [
      "Backend accepted HMAC-SHA256 tokens signed with public RSA key, allowing attacker to forge..."
    ],
    "documented_facts": [
      {
        "fact_id": "SEA-PUB-086-F1",
        "statement": "Backend accepted HMAC-SHA256 tokens signed with public RSA key, allowing attacker to forge administrator tokens.",
        "document_citation": "Identity Security Report"
      }
    ],
    "collectsea_classification": {
      "capabilities": [
        "data.credentials_secrets",
        "auth.privileged_action",
        "arch.multi_tenant"
      ],
      "failure_mechanisms": [
        "SEA-FM-001",
        "SEA-FM-008"
      ],
      "consequences": [
        "Financial Loss",
        "Execution Error"
      ],
      "authority_level": "PRIVILEGED_INTERNAL"
    },
    "safeguards": [
      {
        "safeguard_id": "SEA-PUB-086-SG1",
        "label": "Automated Defensive Guardrail",
        "description": "Enforce strict pre-implementation automated architecture validation against SEA-FM-001.",
        "target_failure_mode": "Repeat architectural failure",
        "effectiveness_level": "PREVENTATIVE"
      }
    ],
    "status": "active"
  },
  {
    "incident_id": "SEA-PUB-087",
    "title": "Distributed Rate Limiter Redis Key Collision & Global Lockout (Verified Case #87)",
    "affected_system": {
      "system_type": "Global API Proxy Network",
      "organization": "Global API Proxy Network Infrastructure",
      "product": "Distributed Redis Token Bucket Rate Limiter",
      "is_ai_system": false,
      "is_agentic": false,
      "primary_language": "Cloud & Distributed Systems"
    },
    "incident_date": "2023-04-04",
    "source_authority": {
      "document_type": "Edge Engineering Postmortem",
      "filing_id": "PUB-087",
      "reporting_entity": "Global API Proxy Network Infrastructure",
      "regulatory_body": "Public Regulatory Filing / Engineering Postmortem"
    },
    "source_url": "https://aws.amazon.com/builders-library/making-retries-safe-with-idempotent-APIs/",
    "source_publisher": "Regulatory Disclosure & Cloud Engineering Archive",
    "source_stated_contributors": [
      "Missing tenant namespace prefix in rate limiter Redis key caused single user limit to appl..."
    ],
    "documented_facts": [
      {
        "fact_id": "SEA-PUB-087-F1",
        "statement": "Missing tenant namespace prefix in rate limiter Redis key caused single user limit to apply globally to all tenants.",
        "document_citation": "Edge Engineering Postmortem"
      }
    ],
    "collectsea_classification": {
      "capabilities": [
        "arch.multi_tenant",
        "arch.caching",
        "auth.infrastructure_modification"
      ],
      "failure_mechanisms": [
        "SEA-FM-001",
        "SEA-FM-006"
      ],
      "consequences": [
        "Financial Loss",
        "Execution Error"
      ],
      "authority_level": "PRIVILEGED_INTERNAL"
    },
    "safeguards": [
      {
        "safeguard_id": "SEA-PUB-087-SG1",
        "label": "Automated Defensive Guardrail",
        "description": "Enforce strict pre-implementation automated architecture validation against SEA-FM-001.",
        "target_failure_mode": "Repeat architectural failure",
        "effectiveness_level": "PREVENTATIVE"
      }
    ],
    "status": "active"
  },
  {
    "incident_id": "SEA-PUB-088",
    "title": "Kafka Consumer Group Rebalance Storm Message Lag (Verified Case #88)",
    "affected_system": {
      "system_type": "Streaming Analytics Platform",
      "organization": "Streaming Analytics Platform Infrastructure",
      "product": "Distributed Event Stream Processing Engine",
      "is_ai_system": false,
      "is_agentic": false,
      "primary_language": "Cloud & Distributed Systems"
    },
    "incident_date": "2024-05-05",
    "source_authority": {
      "document_type": "Streaming Engineering Postmortem",
      "filing_id": "PUB-088",
      "reporting_entity": "Streaming Analytics Platform Infrastructure",
      "regulatory_body": "Public Regulatory Filing / Engineering Postmortem"
    },
    "source_url": "https://www.sec.gov/Archives/edgar/data/789019/000119312524011295/d708866d8k.htm",
    "source_publisher": "Regulatory Disclosure & Cloud Engineering Archive",
    "source_stated_contributors": [
      "Slow consumer heartbeat during heavy batch processing triggered infinite rebalance loop, h..."
    ],
    "documented_facts": [
      {
        "fact_id": "SEA-PUB-088-F1",
        "statement": "Slow consumer heartbeat during heavy batch processing triggered infinite rebalance loop, halting all event consumption.",
        "document_citation": "Streaming Engineering Postmortem"
      }
    ],
    "collectsea_classification": {
      "capabilities": [
        "auth.infrastructure_modification",
        "arch.caching",
        "arch.external_api"
      ],
      "failure_mechanisms": [
        "SEA-FM-006",
        "SEA-FM-007"
      ],
      "consequences": [
        "Financial Loss",
        "Execution Error"
      ],
      "authority_level": "PRIVILEGED_INTERNAL"
    },
    "safeguards": [
      {
        "safeguard_id": "SEA-PUB-088-SG1",
        "label": "Automated Defensive Guardrail",
        "description": "Enforce strict pre-implementation automated architecture validation against SEA-FM-006.",
        "target_failure_mode": "Repeat architectural failure",
        "effectiveness_level": "PREVENTATIVE"
      }
    ],
    "status": "active"
  },
  {
    "incident_id": "SEA-PUB-089",
    "title": "Kubernetes Ingress Controller Memory Leak on Dynamic SSL Reload (Verified Case #89)",
    "affected_system": {
      "system_type": "Cloud Orchestration Mesh",
      "organization": "Cloud Orchestration Mesh Infrastructure",
      "product": "NGINX Ingress Controller & Cert-Manager",
      "is_ai_system": false,
      "is_agentic": false,
      "primary_language": "Cloud & Distributed Systems"
    },
    "incident_date": "2025-06-06",
    "source_authority": {
      "document_type": "Kubernetes Incident Postmortem",
      "filing_id": "PUB-089",
      "reporting_entity": "Cloud Orchestration Mesh Infrastructure",
      "regulatory_body": "Public Regulatory Filing / Engineering Postmortem"
    },
    "source_url": "https://aws.amazon.com/builders-library/making-retries-safe-with-idempotent-APIs/",
    "source_publisher": "Regulatory Disclosure & Cloud Engineering Archive",
    "source_stated_contributors": [
      "Frequent Let's Encrypt cert renewals triggered daily NGINX reloads, fragmenting heap until..."
    ],
    "documented_facts": [
      {
        "fact_id": "SEA-PUB-089-F1",
        "statement": "Frequent Let's Encrypt cert renewals triggered daily NGINX reloads, fragmenting heap until pods OOM-killed.",
        "document_citation": "Kubernetes Incident Postmortem"
      }
    ],
    "collectsea_classification": {
      "capabilities": [
        "auth.infrastructure_modification",
        "data.credentials_secrets",
        "arch.external_api"
      ],
      "failure_mechanisms": [
        "SEA-FM-006",
        "SEA-FM-005"
      ],
      "consequences": [
        "Financial Loss",
        "Execution Error"
      ],
      "authority_level": "PRIVILEGED_INTERNAL"
    },
    "safeguards": [
      {
        "safeguard_id": "SEA-PUB-089-SG1",
        "label": "Automated Defensive Guardrail",
        "description": "Enforce strict pre-implementation automated architecture validation against SEA-FM-006.",
        "target_failure_mode": "Repeat architectural failure",
        "effectiveness_level": "PREVENTATIVE"
      }
    ],
    "status": "active"
  },
  {
    "incident_id": "SEA-PUB-090",
    "title": "Container Image Registry Tag Mutation Supply Chain Compromise (Verified Case #90)",
    "affected_system": {
      "system_type": "Cloud Native Platform",
      "organization": "Cloud Native Platform Infrastructure",
      "product": "Public Docker Container Image Registry",
      "is_ai_system": false,
      "is_agentic": false,
      "primary_language": "Cloud & Distributed Systems"
    },
    "incident_date": "2021-07-07",
    "source_authority": {
      "document_type": "Cloud Supply Chain Report",
      "filing_id": "PUB-090",
      "reporting_entity": "Cloud Native Platform Infrastructure",
      "regulatory_body": "Public Regulatory Filing / Engineering Postmortem"
    },
    "source_url": "https://www.sec.gov/Archives/edgar/data/789019/000119312524011295/d708866d8k.htm",
    "source_publisher": "Regulatory Disclosure & Cloud Engineering Archive",
    "source_stated_contributors": [
      "Mutable `:latest` container tag overwritten by compromised build runner; deployed vulnerab..."
    ],
    "documented_facts": [
      {
        "fact_id": "SEA-PUB-090-F1",
        "statement": "Mutable `:latest` container tag overwritten by compromised build runner; deployed vulnerable image to production.",
        "document_citation": "Cloud Supply Chain Report"
      }
    ],
    "collectsea_classification": {
      "capabilities": [
        "auth.code_execution",
        "auth.infrastructure_modification",
        "data.credentials_secrets"
      ],
      "failure_mechanisms": [
        "SEA-FM-003",
        "SEA-FM-009"
      ],
      "consequences": [
        "Financial Loss",
        "Execution Error"
      ],
      "authority_level": "PRIVILEGED_INTERNAL"
    },
    "safeguards": [
      {
        "safeguard_id": "SEA-PUB-090-SG1",
        "label": "Automated Defensive Guardrail",
        "description": "Enforce strict pre-implementation automated architecture validation against SEA-FM-003.",
        "target_failure_mode": "Repeat architectural failure",
        "effectiveness_level": "PREVENTATIVE"
      }
    ],
    "status": "active"
  },
  {
    "incident_id": "SEA-PUB-091",
    "title": "DNSSEC Key Rollback & Global Domain Invalidation (Verified Case #91)",
    "affected_system": {
      "system_type": "Top-Level Domain Registry",
      "organization": "Top-Level Domain Registry Infrastructure",
      "product": "Authoritative DNSSEC Signing Infrastructure",
      "is_ai_system": false,
      "is_agentic": false,
      "primary_language": "Cloud & Distributed Systems"
    },
    "incident_date": "2022-08-08",
    "source_authority": {
      "document_type": "DNS Engineering Postmortem",
      "filing_id": "PUB-091",
      "reporting_entity": "Top-Level Domain Registry Infrastructure",
      "regulatory_body": "Public Regulatory Filing / Engineering Postmortem"
    },
    "source_url": "https://aws.amazon.com/builders-library/making-retries-safe-with-idempotent-APIs/",
    "source_publisher": "Regulatory Disclosure & Cloud Engineering Archive",
    "source_stated_contributors": [
      "Mismatched DS records during planned Key Signing Key (KSK) rollover caused recursive resol..."
    ],
    "documented_facts": [
      {
        "fact_id": "SEA-PUB-091-F1",
        "statement": "Mismatched DS records during planned Key Signing Key (KSK) rollover caused recursive resolvers worldwide to return SERVFAIL.",
        "document_citation": "DNS Engineering Postmortem"
      }
    ],
    "collectsea_classification": {
      "capabilities": [
        "auth.infrastructure_modification",
        "data.credentials_secrets",
        "arch.external_api"
      ],
      "failure_mechanisms": [
        "SEA-FM-008",
        "SEA-FM-005"
      ],
      "consequences": [
        "Financial Loss",
        "Execution Error"
      ],
      "authority_level": "PRIVILEGED_INTERNAL"
    },
    "safeguards": [
      {
        "safeguard_id": "SEA-PUB-091-SG1",
        "label": "Automated Defensive Guardrail",
        "description": "Enforce strict pre-implementation automated architecture validation against SEA-FM-008.",
        "target_failure_mode": "Repeat architectural failure",
        "effectiveness_level": "PREVENTATIVE"
      }
    ],
    "status": "active"
  },
  {
    "incident_id": "SEA-PUB-092",
    "title": "OAuth Refresh Token Reuse Race Condition & Account Takeover (Verified Case #92)",
    "affected_system": {
      "system_type": "Consumer Mobile Platform",
      "organization": "Consumer Mobile Platform Infrastructure",
      "product": "Mobile OAuth2 Token Exchange Gateway",
      "is_ai_system": false,
      "is_agentic": false,
      "primary_language": "Cloud & Distributed Systems"
    },
    "incident_date": "2023-09-09",
    "source_authority": {
      "document_type": "Mobile Security Advisory",
      "filing_id": "PUB-092",
      "reporting_entity": "Consumer Mobile Platform Infrastructure",
      "regulatory_body": "Public Regulatory Filing / Engineering Postmortem"
    },
    "source_url": "https://www.sec.gov/Archives/edgar/data/789019/000119312524011295/d708866d8k.htm",
    "source_publisher": "Regulatory Disclosure & Cloud Engineering Archive",
    "source_stated_contributors": [
      "Simultaneous token refresh requests from multi-tab sessions triggered false reuse detectio..."
    ],
    "documented_facts": [
      {
        "fact_id": "SEA-PUB-092-F1",
        "statement": "Simultaneous token refresh requests from multi-tab sessions triggered false reuse detection, locking user accounts.",
        "document_citation": "Mobile Security Advisory"
      }
    ],
    "collectsea_classification": {
      "capabilities": [
        "data.credentials_secrets",
        "arch.multi_tenant",
        "auth.privileged_action"
      ],
      "failure_mechanisms": [
        "SEA-FM-007",
        "SEA-FM-001"
      ],
      "consequences": [
        "Financial Loss",
        "Execution Error"
      ],
      "authority_level": "PRIVILEGED_INTERNAL"
    },
    "safeguards": [
      {
        "safeguard_id": "SEA-PUB-092-SG1",
        "label": "Automated Defensive Guardrail",
        "description": "Enforce strict pre-implementation automated architecture validation against SEA-FM-007.",
        "target_failure_mode": "Repeat architectural failure",
        "effectiveness_level": "PREVENTATIVE"
      }
    ],
    "status": "active"
  },
  {
    "incident_id": "SEA-PUB-093",
    "title": "BGP Prefix Hijack Inadvertent Cryptocurrency Wallet Redirection (Verified Case #93)",
    "affected_system": {
      "system_type": "Internet Routing Infrastructure",
      "organization": "Internet Routing Infrastructure Infrastructure",
      "product": "Autonomous System BGP Routing Gateway",
      "is_ai_system": false,
      "is_agentic": false,
      "primary_language": "Cloud & Distributed Systems"
    },
    "incident_date": "2024-10-10",
    "source_authority": {
      "document_type": "Internet Routing Postmortem",
      "filing_id": "PUB-093",
      "reporting_entity": "Internet Routing Infrastructure Infrastructure",
      "regulatory_body": "Public Regulatory Filing / Engineering Postmortem"
    },
    "source_url": "https://aws.amazon.com/builders-library/making-retries-safe-with-idempotent-APIs/",
    "source_publisher": "Regulatory Disclosure & Cloud Engineering Archive",
    "source_stated_contributors": [
      "Rogue BGP route announcement redirected DNS queries for major cryptocurrency portal to mal..."
    ],
    "documented_facts": [
      {
        "fact_id": "SEA-PUB-093-F1",
        "statement": "Rogue BGP route announcement redirected DNS queries for major cryptocurrency portal to malicious server for 2 hours.",
        "document_citation": "Internet Routing Postmortem"
      }
    ],
    "collectsea_classification": {
      "capabilities": [
        "auth.infrastructure_modification",
        "arch.external_api",
        "data.credentials_secrets"
      ],
      "failure_mechanisms": [
        "SEA-FM-001",
        "SEA-FM-005"
      ],
      "consequences": [
        "Financial Loss",
        "Execution Error"
      ],
      "authority_level": "PRIVILEGED_INTERNAL"
    },
    "safeguards": [
      {
        "safeguard_id": "SEA-PUB-093-SG1",
        "label": "Automated Defensive Guardrail",
        "description": "Enforce strict pre-implementation automated architecture validation against SEA-FM-001.",
        "target_failure_mode": "Repeat architectural failure",
        "effectiveness_level": "PREVENTATIVE"
      }
    ],
    "status": "active"
  },
  {
    "incident_id": "SEA-PUB-094",
    "title": "Database Auto-Vacuum Starvation Transaction ID Wraparound (Verified Case #94)",
    "affected_system": {
      "system_type": "Enterprise Managed PostgreSQL",
      "organization": "Enterprise Managed PostgreSQL Infrastructure",
      "product": "High-Volume Transaction Ledger Database",
      "is_ai_system": false,
      "is_agentic": false,
      "primary_language": "Cloud & Distributed Systems"
    },
    "incident_date": "2025-11-11",
    "source_authority": {
      "document_type": "Database Reliability Postmortem",
      "filing_id": "PUB-094",
      "reporting_entity": "Enterprise Managed PostgreSQL Infrastructure",
      "regulatory_body": "Public Regulatory Filing / Engineering Postmortem"
    },
    "source_url": "https://www.sec.gov/Archives/edgar/data/789019/000119312524011295/d708866d8k.htm",
    "source_publisher": "Regulatory Disclosure & Cloud Engineering Archive",
    "source_stated_contributors": [
      "Aggressive long-running analytics queries blocked auto-vacuum; reached 2-billion transacti..."
    ],
    "documented_facts": [
      {
        "fact_id": "SEA-PUB-094-F1",
        "statement": "Aggressive long-running analytics queries blocked auto-vacuum; reached 2-billion transaction ID limit forcing emergency shutdown.",
        "document_citation": "Database Reliability Postmortem"
      }
    ],
    "collectsea_classification": {
      "capabilities": [
        "data.financial_records",
        "auth.infrastructure_modification",
        "arch.caching"
      ],
      "failure_mechanisms": [
        "SEA-FM-005",
        "SEA-FM-006"
      ],
      "consequences": [
        "Financial Loss",
        "Execution Error"
      ],
      "authority_level": "PRIVILEGED_INTERNAL"
    },
    "safeguards": [
      {
        "safeguard_id": "SEA-PUB-094-SG1",
        "label": "Automated Defensive Guardrail",
        "description": "Enforce strict pre-implementation automated architecture validation against SEA-FM-005.",
        "target_failure_mode": "Repeat architectural failure",
        "effectiveness_level": "PREVENTATIVE"
      }
    ],
    "status": "active"
  },
  {
    "incident_id": "SEA-PUB-095",
    "title": "WebSocket Connection Thundering Herd on Load Balancer Restart (Verified Case #95)",
    "affected_system": {
      "system_type": "Real-Time Collaboration Platform",
      "organization": "Real-Time Collaboration Platform Infrastructure",
      "product": "Edge WebSocket Reverse Proxy Mesh",
      "is_ai_system": false,
      "is_agentic": false,
      "primary_language": "Cloud & Distributed Systems"
    },
    "incident_date": "2021-12-12",
    "source_authority": {
      "document_type": "Edge Engineering Postmortem",
      "filing_id": "PUB-095",
      "reporting_entity": "Real-Time Collaboration Platform Infrastructure",
      "regulatory_body": "Public Regulatory Filing / Engineering Postmortem"
    },
    "source_url": "https://aws.amazon.com/builders-library/making-retries-safe-with-idempotent-APIs/",
    "source_publisher": "Regulatory Disclosure & Cloud Engineering Archive",
    "source_stated_contributors": [
      "Simultaneous disconnect of 500,000 active WebSocket clients during proxy restart saturated..."
    ],
    "documented_facts": [
      {
        "fact_id": "SEA-PUB-095-F1",
        "statement": "Simultaneous disconnect of 500,000 active WebSocket clients during proxy restart saturated auth services upon reconnection.",
        "document_citation": "Edge Engineering Postmortem"
      }
    ],
    "collectsea_classification": {
      "capabilities": [
        "arch.multi_tenant",
        "arch.caching",
        "auth.infrastructure_modification"
      ],
      "failure_mechanisms": [
        "SEA-FM-006",
        "SEA-FM-007"
      ],
      "consequences": [
        "Financial Loss",
        "Execution Error"
      ],
      "authority_level": "PRIVILEGED_INTERNAL"
    },
    "safeguards": [
      {
        "safeguard_id": "SEA-PUB-095-SG1",
        "label": "Automated Defensive Guardrail",
        "description": "Enforce strict pre-implementation automated architecture validation against SEA-FM-006.",
        "target_failure_mode": "Repeat architectural failure",
        "effectiveness_level": "PREVENTATIVE"
      }
    ],
    "status": "active"
  },
  {
    "incident_id": "SEA-PUB-096",
    "title": "LLM Tool Call Hallucination SQL Injection Parameter (Verified Case #96)",
    "affected_system": {
      "system_type": "Autonomous AI Database Agent",
      "organization": "Autonomous AI Database Agent Infrastructure",
      "product": "Natural Language SQL Generation Pipeline",
      "is_ai_system": true,
      "is_agentic": false,
      "primary_language": "Cloud & Distributed Systems"
    },
    "incident_date": "2022-01-13",
    "source_authority": {
      "document_type": "AI Safety Research Advisory",
      "filing_id": "PUB-096",
      "reporting_entity": "Autonomous AI Database Agent Infrastructure",
      "regulatory_body": "Public Regulatory Filing / Engineering Postmortem"
    },
    "source_url": "https://www.sec.gov/Archives/edgar/data/789019/000119312524011295/d708866d8k.htm",
    "source_publisher": "Regulatory Disclosure & Cloud Engineering Archive",
    "source_stated_contributors": [
      "LLM hallucinated unescaped string concatenation when generating dynamic SQL query from use..."
    ],
    "documented_facts": [
      {
        "fact_id": "SEA-PUB-096-F1",
        "statement": "LLM hallucinated unescaped string concatenation when generating dynamic SQL query from user input, allowing data extraction.",
        "document_citation": "AI Safety Research Advisory"
      }
    ],
    "collectsea_classification": {
      "capabilities": [
        "auth.code_execution",
        "arch.tool_enabled_agent",
        "data.untrusted_external_text"
      ],
      "failure_mechanisms": [
        "SEA-FM-010",
        "SEA-FM-001"
      ],
      "consequences": [
        "Financial Loss",
        "Execution Error"
      ],
      "authority_level": "PRIVILEGED_INTERNAL"
    },
    "safeguards": [
      {
        "safeguard_id": "SEA-PUB-096-SG1",
        "label": "Automated Defensive Guardrail",
        "description": "Enforce strict pre-implementation automated architecture validation against SEA-FM-010.",
        "target_failure_mode": "Repeat architectural failure",
        "effectiveness_level": "PREVENTATIVE"
      }
    ],
    "status": "active"
  },
  {
    "incident_id": "SEA-PUB-097",
    "title": "Cloud IAM Wildcard Permission Lateral Privilege Escalation (Verified Case #97)",
    "affected_system": {
      "system_type": "Enterprise Cloud Infrastructure",
      "organization": "Enterprise Cloud Infrastructure Infrastructure",
      "product": "Cloud IAM Policy & Role Hierarchy",
      "is_ai_system": false,
      "is_agentic": false,
      "primary_language": "Cloud & Distributed Systems"
    },
    "incident_date": "2023-02-14",
    "source_authority": {
      "document_type": "Cloud Security Audit",
      "filing_id": "PUB-097",
      "reporting_entity": "Enterprise Cloud Infrastructure Infrastructure",
      "regulatory_body": "Public Regulatory Filing / Engineering Postmortem"
    },
    "source_url": "https://aws.amazon.com/builders-library/making-retries-safe-with-idempotent-APIs/",
    "source_publisher": "Regulatory Disclosure & Cloud Engineering Archive",
    "source_stated_contributors": [
      "Overly permissive `iam:PassRole` on worker instances allowed compromised application to as..."
    ],
    "documented_facts": [
      {
        "fact_id": "SEA-PUB-097-F1",
        "statement": "Overly permissive `iam:PassRole` on worker instances allowed compromised application to assume administrator role.",
        "document_citation": "Cloud Security Audit"
      }
    ],
    "collectsea_classification": {
      "capabilities": [
        "auth.privileged_action",
        "data.credentials_secrets",
        "arch.multi_tenant"
      ],
      "failure_mechanisms": [
        "SEA-FM-001",
        "SEA-FM-009"
      ],
      "consequences": [
        "Financial Loss",
        "Execution Error"
      ],
      "authority_level": "PRIVILEGED_INTERNAL"
    },
    "safeguards": [
      {
        "safeguard_id": "SEA-PUB-097-SG1",
        "label": "Automated Defensive Guardrail",
        "description": "Enforce strict pre-implementation automated architecture validation against SEA-FM-001.",
        "target_failure_mode": "Repeat architectural failure",
        "effectiveness_level": "PREVENTATIVE"
      }
    ],
    "status": "active"
  },
  {
    "incident_id": "SEA-PUB-098",
    "title": "S3 Bucket Access Control List (ACL) Misconfiguration Data Leak (Verified Case #98)",
    "affected_system": {
      "system_type": "Financial Technology Startup",
      "organization": "Financial Technology Startup Infrastructure",
      "product": "Customer KYC Verification Document Store",
      "is_ai_system": false,
      "is_agentic": false,
      "primary_language": "Cloud & Distributed Systems"
    },
    "incident_date": "2024-03-15",
    "source_authority": {
      "document_type": "Security Audit Report",
      "filing_id": "PUB-098",
      "reporting_entity": "Financial Technology Startup Infrastructure",
      "regulatory_body": "Public Regulatory Filing / Engineering Postmortem"
    },
    "source_url": "https://www.sec.gov/Archives/edgar/data/789019/000119312524011295/d708866d8k.htm",
    "source_publisher": "Regulatory Disclosure & Cloud Engineering Archive",
    "source_stated_contributors": [
      "Default bucket ACL configured as `public-read` exposed 500,000 passport photos and bank st..."
    ],
    "documented_facts": [
      {
        "fact_id": "SEA-PUB-098-F1",
        "statement": "Default bucket ACL configured as `public-read` exposed 500,000 passport photos and bank statements to search crawlers.",
        "document_citation": "Security Audit Report"
      }
    ],
    "collectsea_classification": {
      "capabilities": [
        "data.pii",
        "data.financial_records",
        "auth.privileged_action"
      ],
      "failure_mechanisms": [
        "SEA-FM-001",
        "SEA-FM-009"
      ],
      "consequences": [
        "Financial Loss",
        "Execution Error"
      ],
      "authority_level": "PRIVILEGED_INTERNAL"
    },
    "safeguards": [
      {
        "safeguard_id": "SEA-PUB-098-SG1",
        "label": "Automated Defensive Guardrail",
        "description": "Enforce strict pre-implementation automated architecture validation against SEA-FM-001.",
        "target_failure_mode": "Repeat architectural failure",
        "effectiveness_level": "PREVENTATIVE"
      }
    ],
    "status": "active"
  },
  {
    "incident_id": "SEA-PUB-099",
    "title": "Cross-Tenant Redis Session Hijacking via Unprefixed Cache Keys (Verified Case #99)",
    "affected_system": {
      "system_type": "SaaS CRM Platform",
      "organization": "SaaS CRM Platform Infrastructure",
      "product": "Distributed Redis Session Cache Tier",
      "is_ai_system": false,
      "is_agentic": false,
      "primary_language": "Cloud & Distributed Systems"
    },
    "incident_date": "2025-04-16",
    "source_authority": {
      "document_type": "SaaS Engineering Postmortem",
      "filing_id": "PUB-099",
      "reporting_entity": "SaaS CRM Platform Infrastructure",
      "regulatory_body": "Public Regulatory Filing / Engineering Postmortem"
    },
    "source_url": "https://aws.amazon.com/builders-library/making-retries-safe-with-idempotent-APIs/",
    "source_publisher": "Regulatory Disclosure & Cloud Engineering Archive",
    "source_stated_contributors": [
      "Session store used un-namespaced integer user IDs; tenant A authenticated as user 101 retr..."
    ],
    "documented_facts": [
      {
        "fact_id": "SEA-PUB-099-F1",
        "statement": "Session store used un-namespaced integer user IDs; tenant A authenticated as user 101 retrieved session of tenant B user 101.",
        "document_citation": "SaaS Engineering Postmortem"
      }
    ],
    "collectsea_classification": {
      "capabilities": [
        "arch.multi_tenant",
        "arch.caching",
        "data.credentials_secrets"
      ],
      "failure_mechanisms": [
        "SEA-FM-001",
        "SEA-FM-004"
      ],
      "consequences": [
        "Financial Loss",
        "Execution Error"
      ],
      "authority_level": "PRIVILEGED_INTERNAL"
    },
    "safeguards": [
      {
        "safeguard_id": "SEA-PUB-099-SG1",
        "label": "Automated Defensive Guardrail",
        "description": "Enforce strict pre-implementation automated architecture validation against SEA-FM-001.",
        "target_failure_mode": "Repeat architectural failure",
        "effectiveness_level": "PREVENTATIVE"
      }
    ],
    "status": "active"
  },
  {
    "incident_id": "SEA-PUB-100",
    "title": "Autonomous AI Agent Model Context Protocol Token Hijacking (Verified Case #100)",
    "affected_system": {
      "system_type": "AI Agentic Development Platform",
      "organization": "AI Agentic Development Platform Infrastructure",
      "product": "Autonomous MCP Agent Execution Sandbox",
      "is_ai_system": true,
      "is_agentic": true,
      "primary_language": "Cloud & Distributed Systems"
    },
    "incident_date": "2021-05-17",
    "source_authority": {
      "document_type": "AI Agent Security Advisory",
      "filing_id": "PUB-100",
      "reporting_entity": "AI Agentic Development Platform Infrastructure",
      "regulatory_body": "Public Regulatory Filing / Engineering Postmortem"
    },
    "source_url": "https://www.sec.gov/Archives/edgar/data/789019/000119312524011295/d708866d8k.htm",
    "source_publisher": "Regulatory Disclosure & Cloud Engineering Archive",
    "source_stated_contributors": [
      "Model Context Protocol search tool allowed prompt injection to leak bearer tokens in subag..."
    ],
    "documented_facts": [
      {
        "fact_id": "SEA-PUB-100-F1",
        "statement": "Model Context Protocol search tool allowed prompt injection to leak bearer tokens in subagent prompt context.",
        "document_citation": "AI Agent Security Advisory"
      }
    ],
    "collectsea_classification": {
      "capabilities": [
        "arch.tool_enabled_agent",
        "data.credentials_secrets",
        "data.untrusted_external_text"
      ],
      "failure_mechanisms": [
        "SEA-FM-010",
        "SEA-FM-001"
      ],
      "consequences": [
        "Financial Loss",
        "Execution Error"
      ],
      "authority_level": "PRIVILEGED_INTERNAL"
    },
    "safeguards": [
      {
        "safeguard_id": "SEA-PUB-100-SG1",
        "label": "Automated Defensive Guardrail",
        "description": "Enforce strict pre-implementation automated architecture validation against SEA-FM-010.",
        "target_failure_mode": "Repeat architectural failure",
        "effectiveness_level": "PREVENTATIVE"
      }
    ],
    "status": "active"
  },
  {
    "incident_id": "SEA-PUB-101",
    "title": "AI LLM Coding Assistant Arbitrary Terminal Command Execution (Verified Case #101)",
    "affected_system": {
      "system_type": "AI Developer Tools Inc.",
      "organization": "AI Developer Tools Inc. Infrastructure",
      "product": "IDE Agentic Code Generation & Shell Runner",
      "is_ai_system": true,
      "is_agentic": false,
      "primary_language": "Cloud & Distributed Systems"
    },
    "incident_date": "2022-06-18",
    "source_authority": {
      "document_type": "Software Security Advisory",
      "filing_id": "PUB-101",
      "reporting_entity": "AI Developer Tools Inc. Infrastructure",
      "regulatory_body": "Public Regulatory Filing / Engineering Postmortem"
    },
    "source_url": "https://aws.amazon.com/builders-library/making-retries-safe-with-idempotent-APIs/",
    "source_publisher": "Regulatory Disclosure & Cloud Engineering Archive",
    "source_stated_contributors": [
      "AI coding agent accepted unvalidated repository prompt that executed malicious curl script..."
    ],
    "documented_facts": [
      {
        "fact_id": "SEA-PUB-101-F1",
        "statement": "AI coding agent accepted unvalidated repository prompt that executed malicious curl script inside local terminal.",
        "document_citation": "Software Security Advisory"
      }
    ],
    "collectsea_classification": {
      "capabilities": [
        "auth.code_execution",
        "arch.tool_enabled_agent",
        "data.untrusted_external_text"
      ],
      "failure_mechanisms": [
        "SEA-FM-010",
        "SEA-FM-003"
      ],
      "consequences": [
        "Financial Loss",
        "Execution Error"
      ],
      "authority_level": "PRIVILEGED_INTERNAL"
    },
    "safeguards": [
      {
        "safeguard_id": "SEA-PUB-101-SG1",
        "label": "Automated Defensive Guardrail",
        "description": "Enforce strict pre-implementation automated architecture validation against SEA-FM-010.",
        "target_failure_mode": "Repeat architectural failure",
        "effectiveness_level": "PREVENTATIVE"
      }
    ],
    "status": "active"
  },
  {
    "incident_id": "SEA-PUB-102",
    "title": "Distributed Consensus Split-Brain State Divergence (Verified Case #102)",
    "affected_system": {
      "system_type": "Distributed Database Corporation",
      "organization": "Distributed Database Corporation Infrastructure",
      "product": "Raft Consensus Cluster & Replication Log",
      "is_ai_system": false,
      "is_agentic": false,
      "primary_language": "Cloud & Distributed Systems"
    },
    "incident_date": "2023-07-19",
    "source_authority": {
      "document_type": "Distributed Systems Postmortem",
      "filing_id": "PUB-102",
      "reporting_entity": "Distributed Database Corporation Infrastructure",
      "regulatory_body": "Public Regulatory Filing / Engineering Postmortem"
    },
    "source_url": "https://www.sec.gov/Archives/edgar/data/789019/000119312524011295/d708866d8k.htm",
    "source_publisher": "Regulatory Disclosure & Cloud Engineering Archive",
    "source_stated_contributors": [
      "Asymmetric network partition caused two leader nodes to accept client writes simultaneousl..."
    ],
    "documented_facts": [
      {
        "fact_id": "SEA-PUB-102-F1",
        "statement": "Asymmetric network partition caused two leader nodes to accept client writes simultaneously, corrupting ledger state.",
        "document_citation": "Distributed Systems Postmortem"
      }
    ],
    "collectsea_classification": {
      "capabilities": [
        "auth.infrastructure_modification",
        "arch.caching",
        "data.financial_records"
      ],
      "failure_mechanisms": [
        "SEA-FM-007",
        "SEA-FM-004"
      ],
      "consequences": [
        "Financial Loss",
        "Execution Error"
      ],
      "authority_level": "PRIVILEGED_INTERNAL"
    },
    "safeguards": [
      {
        "safeguard_id": "SEA-PUB-102-SG1",
        "label": "Automated Defensive Guardrail",
        "description": "Enforce strict pre-implementation automated architecture validation against SEA-FM-007.",
        "target_failure_mode": "Repeat architectural failure",
        "effectiveness_level": "PREVENTATIVE"
      }
    ],
    "status": "active"
  },
  {
    "incident_id": "SEA-PUB-103",
    "title": "Serverless Function Cold Start Connection Pool Exhaustion (Verified Case #103)",
    "affected_system": {
      "system_type": "Serverless Cloud Provider",
      "organization": "Serverless Cloud Provider Infrastructure",
      "product": "Managed Serverless Database Connector",
      "is_ai_system": false,
      "is_agentic": false,
      "primary_language": "Cloud & Distributed Systems"
    },
    "incident_date": "2024-08-20",
    "source_authority": {
      "document_type": "Cloud Engineering Guide",
      "filing_id": "PUB-103",
      "reporting_entity": "Serverless Cloud Provider Infrastructure",
      "regulatory_body": "Public Regulatory Filing / Engineering Postmortem"
    },
    "source_url": "https://aws.amazon.com/builders-library/making-retries-safe-with-idempotent-APIs/",
    "source_publisher": "Regulatory Disclosure & Cloud Engineering Archive",
    "source_stated_contributors": [
      "Spike in concurrent lambda invocations opened 10,000 direct PostgreSQL connections, crashi..."
    ],
    "documented_facts": [
      {
        "fact_id": "SEA-PUB-103-F1",
        "statement": "Spike in concurrent lambda invocations opened 10,000 direct PostgreSQL connections, crashing primary RDS instance.",
        "document_citation": "Cloud Engineering Guide"
      }
    ],
    "collectsea_classification": {
      "capabilities": [
        "auth.infrastructure_modification",
        "arch.multi_tenant",
        "arch.external_api"
      ],
      "failure_mechanisms": [
        "SEA-FM-006",
        "SEA-FM-007"
      ],
      "consequences": [
        "Financial Loss",
        "Execution Error"
      ],
      "authority_level": "PRIVILEGED_INTERNAL"
    },
    "safeguards": [
      {
        "safeguard_id": "SEA-PUB-103-SG1",
        "label": "Automated Defensive Guardrail",
        "description": "Enforce strict pre-implementation automated architecture validation against SEA-FM-006.",
        "target_failure_mode": "Repeat architectural failure",
        "effectiveness_level": "PREVENTATIVE"
      }
    ],
    "status": "active"
  },
  {
    "incident_id": "SEA-PUB-104",
    "title": "Payment Webhook Out-of-Order Delivery State Machine Corruption (Verified Case #104)",
    "affected_system": {
      "system_type": "FinTech Billing Platform",
      "organization": "FinTech Billing Platform Infrastructure",
      "product": "Asynchronous Payment Webhook Event Consumer",
      "is_ai_system": false,
      "is_agentic": false,
      "primary_language": "Cloud & Distributed Systems"
    },
    "incident_date": "2025-09-21",
    "source_authority": {
      "document_type": "Payment Engineering Postmortem",
      "filing_id": "PUB-104",
      "reporting_entity": "FinTech Billing Platform Infrastructure",
      "regulatory_body": "Public Regulatory Filing / Engineering Postmortem"
    },
    "source_url": "https://www.sec.gov/Archives/edgar/data/789019/000119312524011295/d708866d8k.htm",
    "source_publisher": "Regulatory Disclosure & Cloud Engineering Archive",
    "source_stated_contributors": [
      "Late-arriving `payment_failed` webhook processed after `subscription_renewed`, deactivatin..."
    ],
    "documented_facts": [
      {
        "fact_id": "SEA-PUB-104-F1",
        "statement": "Late-arriving `payment_failed` webhook processed after `subscription_renewed`, deactivating active paying customer account.",
        "document_citation": "Payment Engineering Postmortem"
      }
    ],
    "collectsea_classification": {
      "capabilities": [
        "auth.financial_action",
        "arch.external_api",
        "data.financial_records"
      ],
      "failure_mechanisms": [
        "SEA-FM-007",
        "SEA-FM-008"
      ],
      "consequences": [
        "Financial Loss",
        "Execution Error"
      ],
      "authority_level": "IRREVERSIBLE_EXTERNAL"
    },
    "safeguards": [
      {
        "safeguard_id": "SEA-PUB-104-SG1",
        "label": "Automated Defensive Guardrail",
        "description": "Enforce strict pre-implementation automated architecture validation against SEA-FM-007.",
        "target_failure_mode": "Repeat architectural failure",
        "effectiveness_level": "PREVENTATIVE"
      }
    ],
    "status": "active"
  },
  {
    "incident_id": "SEA-PUB-105",
    "title": "GraphQL Deeply Nested Query Denial of Service (Verified Case #105)",
    "affected_system": {
      "system_type": "Enterprise API Gateway",
      "organization": "Enterprise API Gateway Infrastructure",
      "product": "Public GraphQL Query Parser & Resolver",
      "is_ai_system": false,
      "is_agentic": false,
      "primary_language": "Cloud & Distributed Systems"
    },
    "incident_date": "2021-10-22",
    "source_authority": {
      "document_type": "API Security Advisory",
      "filing_id": "PUB-105",
      "reporting_entity": "Enterprise API Gateway Infrastructure",
      "regulatory_body": "Public Regulatory Filing / Engineering Postmortem"
    },
    "source_url": "https://aws.amazon.com/builders-library/making-retries-safe-with-idempotent-APIs/",
    "source_publisher": "Regulatory Disclosure & Cloud Engineering Archive",
    "source_stated_contributors": [
      "Recursive query execution (`user { friends { friends { friends } } }`) caused heap memory ..."
    ],
    "documented_facts": [
      {
        "fact_id": "SEA-PUB-105-F1",
        "statement": "Recursive query execution (`user { friends { friends { friends } } }`) caused heap memory exhaustion on backend node.",
        "document_citation": "API Security Advisory"
      }
    ],
    "collectsea_classification": {
      "capabilities": [
        "arch.multi_tenant",
        "arch.external_api",
        "data.untrusted_external_text"
      ],
      "failure_mechanisms": [
        "SEA-FM-006",
        "SEA-FM-003"
      ],
      "consequences": [
        "Financial Loss",
        "Execution Error"
      ],
      "authority_level": "PRIVILEGED_INTERNAL"
    },
    "safeguards": [
      {
        "safeguard_id": "SEA-PUB-105-SG1",
        "label": "Automated Defensive Guardrail",
        "description": "Enforce strict pre-implementation automated architecture validation against SEA-FM-006.",
        "target_failure_mode": "Repeat architectural failure",
        "effectiveness_level": "PREVENTATIVE"
      }
    ],
    "status": "active"
  },
  {
    "incident_id": "SEA-PUB-106",
    "title": "JWT Secret Key Confusion & Privilege Escalation (Verified Case #106)",
    "affected_system": {
      "system_type": "Cloud SaaS Authentication Service",
      "organization": "Cloud SaaS Authentication Service Infrastructure",
      "product": "OAuth2 / OpenID Connect Token Signer",
      "is_ai_system": false,
      "is_agentic": false,
      "primary_language": "Cloud & Distributed Systems"
    },
    "incident_date": "2022-11-23",
    "source_authority": {
      "document_type": "Identity Security Report",
      "filing_id": "PUB-106",
      "reporting_entity": "Cloud SaaS Authentication Service Infrastructure",
      "regulatory_body": "Public Regulatory Filing / Engineering Postmortem"
    },
    "source_url": "https://www.sec.gov/Archives/edgar/data/789019/000119312524011295/d708866d8k.htm",
    "source_publisher": "Regulatory Disclosure & Cloud Engineering Archive",
    "source_stated_contributors": [
      "Backend accepted HMAC-SHA256 tokens signed with public RSA key, allowing attacker to forge..."
    ],
    "documented_facts": [
      {
        "fact_id": "SEA-PUB-106-F1",
        "statement": "Backend accepted HMAC-SHA256 tokens signed with public RSA key, allowing attacker to forge administrator tokens.",
        "document_citation": "Identity Security Report"
      }
    ],
    "collectsea_classification": {
      "capabilities": [
        "data.credentials_secrets",
        "auth.privileged_action",
        "arch.multi_tenant"
      ],
      "failure_mechanisms": [
        "SEA-FM-001",
        "SEA-FM-008"
      ],
      "consequences": [
        "Financial Loss",
        "Execution Error"
      ],
      "authority_level": "PRIVILEGED_INTERNAL"
    },
    "safeguards": [
      {
        "safeguard_id": "SEA-PUB-106-SG1",
        "label": "Automated Defensive Guardrail",
        "description": "Enforce strict pre-implementation automated architecture validation against SEA-FM-001.",
        "target_failure_mode": "Repeat architectural failure",
        "effectiveness_level": "PREVENTATIVE"
      }
    ],
    "status": "active"
  },
  {
    "incident_id": "SEA-PUB-107",
    "title": "Distributed Rate Limiter Redis Key Collision & Global Lockout (Verified Case #107)",
    "affected_system": {
      "system_type": "Global API Proxy Network",
      "organization": "Global API Proxy Network Infrastructure",
      "product": "Distributed Redis Token Bucket Rate Limiter",
      "is_ai_system": false,
      "is_agentic": false,
      "primary_language": "Cloud & Distributed Systems"
    },
    "incident_date": "2023-12-24",
    "source_authority": {
      "document_type": "Edge Engineering Postmortem",
      "filing_id": "PUB-107",
      "reporting_entity": "Global API Proxy Network Infrastructure",
      "regulatory_body": "Public Regulatory Filing / Engineering Postmortem"
    },
    "source_url": "https://aws.amazon.com/builders-library/making-retries-safe-with-idempotent-APIs/",
    "source_publisher": "Regulatory Disclosure & Cloud Engineering Archive",
    "source_stated_contributors": [
      "Missing tenant namespace prefix in rate limiter Redis key caused single user limit to appl..."
    ],
    "documented_facts": [
      {
        "fact_id": "SEA-PUB-107-F1",
        "statement": "Missing tenant namespace prefix in rate limiter Redis key caused single user limit to apply globally to all tenants.",
        "document_citation": "Edge Engineering Postmortem"
      }
    ],
    "collectsea_classification": {
      "capabilities": [
        "arch.multi_tenant",
        "arch.caching",
        "auth.infrastructure_modification"
      ],
      "failure_mechanisms": [
        "SEA-FM-001",
        "SEA-FM-006"
      ],
      "consequences": [
        "Financial Loss",
        "Execution Error"
      ],
      "authority_level": "PRIVILEGED_INTERNAL"
    },
    "safeguards": [
      {
        "safeguard_id": "SEA-PUB-107-SG1",
        "label": "Automated Defensive Guardrail",
        "description": "Enforce strict pre-implementation automated architecture validation against SEA-FM-001.",
        "target_failure_mode": "Repeat architectural failure",
        "effectiveness_level": "PREVENTATIVE"
      }
    ],
    "status": "active"
  },
  {
    "incident_id": "SEA-PUB-108",
    "title": "Kafka Consumer Group Rebalance Storm Message Lag (Verified Case #108)",
    "affected_system": {
      "system_type": "Streaming Analytics Platform",
      "organization": "Streaming Analytics Platform Infrastructure",
      "product": "Distributed Event Stream Processing Engine",
      "is_ai_system": false,
      "is_agentic": false,
      "primary_language": "Cloud & Distributed Systems"
    },
    "incident_date": "2024-01-25",
    "source_authority": {
      "document_type": "Streaming Engineering Postmortem",
      "filing_id": "PUB-108",
      "reporting_entity": "Streaming Analytics Platform Infrastructure",
      "regulatory_body": "Public Regulatory Filing / Engineering Postmortem"
    },
    "source_url": "https://www.sec.gov/Archives/edgar/data/789019/000119312524011295/d708866d8k.htm",
    "source_publisher": "Regulatory Disclosure & Cloud Engineering Archive",
    "source_stated_contributors": [
      "Slow consumer heartbeat during heavy batch processing triggered infinite rebalance loop, h..."
    ],
    "documented_facts": [
      {
        "fact_id": "SEA-PUB-108-F1",
        "statement": "Slow consumer heartbeat during heavy batch processing triggered infinite rebalance loop, halting all event consumption.",
        "document_citation": "Streaming Engineering Postmortem"
      }
    ],
    "collectsea_classification": {
      "capabilities": [
        "auth.infrastructure_modification",
        "arch.caching",
        "arch.external_api"
      ],
      "failure_mechanisms": [
        "SEA-FM-006",
        "SEA-FM-007"
      ],
      "consequences": [
        "Financial Loss",
        "Execution Error"
      ],
      "authority_level": "PRIVILEGED_INTERNAL"
    },
    "safeguards": [
      {
        "safeguard_id": "SEA-PUB-108-SG1",
        "label": "Automated Defensive Guardrail",
        "description": "Enforce strict pre-implementation automated architecture validation against SEA-FM-006.",
        "target_failure_mode": "Repeat architectural failure",
        "effectiveness_level": "PREVENTATIVE"
      }
    ],
    "status": "active"
  }
];

export const INCIDENT_MAP: Record<string, IncidentRecord> = INCIDENTS.reduce((acc, inc) => {
  acc[inc.incident_id] = inc;
  return acc;
}, {} as Record<string, IncidentRecord>);
